<svg
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <defs>
            <clipPath id="clip0_5317_26">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_64">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_100">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_123">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_127">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_129">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_139">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_151">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_203">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_211">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_245">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_251">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_253">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_326">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_339">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_377">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_389">
                <rect
                    width="24"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_399">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_426">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_428">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_430">
                <rect
                    width="32"
                    height="32"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_444">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_450">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_454">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_466">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_490">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_578">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_607">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_664">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_682">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_725">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_729">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_746">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_760">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_768">
                <rect
                    width="28"
                    height="28"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5317_784">
                <rect
                    width="32"
                    height="32"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_119_8">
                <rect
                    width="26"
                    height="26"
                    rx="13"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_119_20">
                <rect
                    width="26"
                    height="26"
                    rx="13"
                    fill="white"></rect>
            </clipPath>
            <clipPath id="clip1_119_20">
                <rect
                    width="26"
                    height="26"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <linearGradient
                id="paint0_linear_4329_3923"
                x1="5.51544"
                y1="14.5787"
                x2="23.4178"
                y2="15.4828"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#0064E1"></stop>
                <stop
                    offset="0.4"
                    stop-color="#0064E1"></stop>
                <stop
                    offset="0.83"
                    stop-color="#0073EE"></stop>
                <stop
                    offset="1"
                    stop-color="#0082FB"></stop>
            </linearGradient>
            <linearGradient
                id="paint1_linear_4329_3923"
                x1="4.06872"
                y1="16.5678"
                x2="4.06872"
                y2="9.96745"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#0082FB"></stop>
                <stop
                    offset="1"
                    stop-color="#0064E0"></stop>
            </linearGradient>
        </defs>
        <defs>
            <clipPath id="clip0_4314_1255">
                <rect
                    width="26"
                    height="26"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5337_199">
                <rect
                    width="26"
                    height="26"
                    fill="white"></rect>
            </clipPath>
        </defs>
        <defs>
            <clipPath id="clip0_5596_2448">
                <rect
                    width="26"
                    height="26"
                    fill="white"></rect>
            </clipPath>
        </defs>
    </defs>
    <symbol
        id="icon-ui-action-disabled"
        viewBox="0 0 28 28">
        <path d="M13.173 17.787L18.426 14.754L12 26L13.173 17.787Z"></path>
        <path d="M16 2L9.83704 12.784L14.874 9.876L15.999 2H16Z"></path>
        <path d="M21.248 8.50598L5.74304 17.458L6.74304 19.19L22.248 10.238L21.248 8.50598Z"></path>
    </symbol>
    <symbol
        id="icon-ui-add"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_26)">
            <path
                d="M16 12.25V1.75C16 0.784 14.966 0 14 0C13.034 0 12 0.784 12 1.75V12.25H1.75C0.784 12.25 0 13.034 0 14C0 14.966 0.784 15.75 1.75 15.75H12V26.25C12 27.216 13.034 28 14 28C14.966 28 16 27.216 16 26.25V15.75H26.25C27.216 15.75 28 14.966 28 14C28 13.034 27.216 12.25 26.25 12.25H16Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_26">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-ad-default"
        viewBox="0 0 28 28">
        <path
            d="M6 18V24H12V26H4V18H6ZM26 18V26H18V24H24V18H26ZM12 4V6H6V12H4V4H12ZM26 4V12H24V6H18V4H26Z"></path>
    </symbol>
    <symbol
        id="icon-ui-ads-create"
        viewBox="0 0 28 28">
        <path
            d="M20 14V18H24V20H20V24H18V20H14V18H18V14H20ZM6 10V12H8V14H4V10H6ZM14 10V14H10V12H12V10H14ZM8 4V6H6V8H4V4H8ZM14 4V8H12V6H10V4H14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-ads-group"
        viewBox="0 0 28 28">
        <path
            d="M12 22V24H16V26H10V22H12ZM26 20V26H20V24H24V20H26ZM6 14V18H10V20H4V14H6ZM20 14V20H14V18H18V14H20ZM26 10V16H24V12H22V10H26ZM10 4V6H6V10H4V4H10ZM20 4V10H18V6H14V4H20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-ads-s"
        viewBox="0 0 28 28">
        <path
            d="M6 18V24H12V26H4V18H6ZM26 18V26H18V24H24V18H26ZM12 4V6H6V12H4V4H12ZM26 4V12H24V6H18V4H26Z"></path>
    </symbol>
    <symbol
        id="icon-ui-ai_stars"
        viewBox="0 0 28 28">
        <path
            d="M13.333 26L16.24 19.573L22.667 16.666L16.24 13.759L13.333 7.33198L10.426 13.759L3.99902 16.666L10.426 19.573L13.333 26ZM20 12.667L21.653 8.98698L25.333 7.33398L21.653 5.68098L20 2.00098L18.347 5.68098L14.667 7.33398L18.347 8.98698L20 12.667ZM13.333 26L16.24 19.573L22.667 16.666L16.24 13.759L13.333 7.33198L10.426 13.759L3.99902 16.666L10.426 19.573L13.333 26ZM20 12.667L21.653 8.98698L25.333 7.33398L21.653 5.68098L20 2.00098L18.347 5.68098L14.667 7.33398L18.347 8.98698L20 12.667Z"></path>
    </symbol>
    <symbol
        id="icon-ui-alert"
        viewBox="0 0 28 28">
        <path
            d="M4 18V14C4 11.25 5.124 8.75 6.938 6.938C8.75 5.126 11.25 4 14 4C16.75 4 19.25 5.126 21.062 6.938C22.876 8.75 24 11.25 24 14V18H4ZM10 20H18C18 22.208 16.208 24 14 24C11.792 24 10 22.208 10 20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-bottom"
        viewBox="0 0 28 28">
        <path d="M4 26V24H26V26H4ZM10 22V4H20V22H10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-canvas-bottom"
        viewBox="0 0 28 28">
        <path d="M26 24V26H4V4H26V24ZM24 24V6H6V24H24ZM10 24V10H20V24H10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-canvas-center"
        viewBox="0 0 28 28">
        <path d="M16 24H24V6H16V10H20V20H16V24ZM14 24V20H10V10H14V6H6V24H14ZM6 26H4V4H26V26H6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-canvas-left"
        viewBox="0 0 28 28">
        <path d="M6 26H4V4H26V26H6ZM6 24H24V6H6V24ZM6 10H20V20H6V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-canvas-middle"
        viewBox="0 0 28 28">
        <path d="M6 16V24H24V16H20V20H10V16H6ZM6 14H10V10H20V14H24V6H6V14ZM4 6V4H26V26H4V6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-canvas-right"
        viewBox="0 0 28 28">
        <path d="M24 26H26V4H4V26H24ZM24 24H6V6H24V24ZM24 10H10V20H24V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-canvas-top"
        viewBox="0 0 28 28">
        <path d="M4 6V4H26V26H4V6ZM6 6V24H24V6H6ZM20 6V20H10V6H20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-center"
        viewBox="0 0 28 28">
        <path d="M16 10H26V20H16V26H14V20H4V10H14V4H16V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-left"
        viewBox="0 0 28 28">
        <path d="M4 4H6V26H4V4ZM8 10H26V20H8V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-middle"
        viewBox="0 0 28 28">
        <path d="M20 16V26H10V16H4V14H10V4H20V14H26V16H20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-right"
        viewBox="0 0 28 28">
        <path d="M26 4H24V26H26V4ZM22 10H4V20H22V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-align-top"
        viewBox="0 0 28 28">
        <path d="M26 4V6H4V4H26ZM20 8V26H10V8H20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-analytics-l"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_64)">
            <path
                d="M0 20H8V28H0V20ZM10 16H18V28H10V16ZM28 10V28H20V10H28ZM24 0V6H22V3.414L15 10.414L11 6.414L5 12.414L3.586 11L11 3.586L15 7.586L20.584 2H18V0H24Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_64">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-analytics-s"
        viewBox="0 0 28 28">
        <path
            d="M4 20H10V26H4V20ZM12.143 16H18.143V26H12.143V16ZM26 12V26H20V12H26ZM22 4V10H20V7.414L15 12.414L13 10.414L9 14.414L7.586 13L13 7.586L15 9.586L18.584 6H16V4H22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-animation"
        viewBox="0 0 28 28">
        <path
            d="M9.757 18.243L14 14V8C17.314 8 20 10.686 20 14C20 17.314 17.314 20 14 20C12.343 20 10.843 19.328 9.757 18.243ZM14 24C8.477 24 4 19.523 4 14C4 8.477 8.477 4 14 4C19.523 4 24 8.477 24 14C24 19.523 19.523 24 14 24ZM14 22C18.418 22 22 18.418 22 14C22 9.582 18.418 6 14 6C9.582 6 6 9.582 6 14C6 18.418 9.582 22 14 22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-announcement"
        viewBox="0 0 28 28">
        <path
            d="M13.1619 7.56998L3.65093 10.118C3.01993 10.287 2.48293 10.7 2.15593 11.265C1.82893 11.83 1.74093 12.502 1.90993 13.133L3.18393 17.888C3.35293 18.519 3.76593 19.056 4.33093 19.383C4.89593 19.71 5.56793 19.798 6.19893 19.629L7.38793 19.31L8.66193 24.065C8.74593 24.38 8.95293 24.649 9.23493 24.812C9.51693 24.975 9.85393 25.019 10.1689 24.935L12.5469 24.298C12.8619 24.214 13.1309 24.007 13.2939 23.725C13.4569 23.443 13.5009 23.106 13.4169 22.791L12.1429 18.036L15.7089 17.08L22.9269 20.243L17.8299 1.22198L13.1599 7.56998H13.1619ZM25.7309 9.29898C26.2759 11.332 25.6279 13.48 24.0329 14.851L21.4849 5.33998C23.5429 5.74398 25.1899 7.27798 25.7309 9.29898Z"></path>
    </symbol>
    <symbol
        id="icon-ui-arrange-top"
        viewBox="0 0 28 28">
        <path
            d="M16 11.447V18H24V22H6V18H14V11.448L11.224 14.224L10 13L15.001 7.999L20 13L18.776 14.224L16 11.447ZM6 4H24V6H6V4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-arrange-up"
        viewBox="0 0 28 28">
        <path d="M6 6H24V10H6V6ZM6 12H24V14H6V12ZM6 16H24V18H6V16ZM6 20H24V22H6V20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-arrow-alt-left"
        viewBox="0 0 28 28">
        <path
            d="M23.995 14.995C23.995 14.443 23.547 13.995 22.995 13.995H8.62497L15.659 7.74199C16.072 7.37499 16.109 6.74299 15.742 6.32999C15.375 5.91699 14.743 5.87999 14.33 6.24699L7.01197 12.752C5.77397 13.853 5.66197 15.749 6.76297 16.987C6.84097 17.075 6.92397 17.158 7.01197 17.236L14.33 23.741C14.743 24.108 15.375 24.071 15.742 23.658C16.109 23.245 16.072 22.613 15.659 22.246L8.62497 15.993H22.995C23.547 15.993 23.995 15.545 23.995 14.993V14.995Z"></path>
    </symbol>
    <symbol
        id="icon-ui-arrow-alt-up"
        viewBox="0 0 28 28">
        <path
            d="M15.9999 22H13.9999V11.414L8.99994 16.414L7.58594 15L14.9999 7.586L22.4139 15L20.9999 16.414L15.9999 11.414V22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-arrow-down"
        viewBox="0 0 28 28">
        <path
            d="M21.253 11.336C21.62 10.923 22.252 10.886 22.665 11.253C23.078 11.62 23.115 12.252 22.7479 12.665L16.2429 19.983C15.1419 21.221 13.246 21.333 12.008 20.232C11.92 20.154 11.8369 20.071 11.7589 19.983L5.25395 12.665C4.88695 12.252 4.92395 11.62 5.33695 11.253C5.74995 10.886 6.38195 10.923 6.74895 11.336L13.2539 18.654C13.2799 18.683 13.3079 18.711 13.3369 18.737C13.7499 19.104 14.3819 19.067 14.7489 18.654L21.253 11.336Z"></path>
    </symbol>
    <symbol
        id="icon-ui-arrow-left"
        viewBox="0 0 28 28">
        <path
            d="M18.6641 6.747C19.0771 6.38 19.1141 5.748 18.7471 5.335C18.3801 4.922 17.7481 4.885 17.3351 5.252L10.0171 11.757C8.7791 12.858 8.6671 14.754 9.7681 15.992C9.8461 16.08 9.9291 16.163 10.0171 16.241L17.3351 22.746C17.7481 23.113 18.3801 23.076 18.7471 22.663C19.1141 22.25 19.0771 21.618 18.6641 21.251L11.3461 14.746C11.3171 14.72 11.2891 14.692 11.2631 14.663C10.8961 14.25 10.9331 13.618 11.3461 13.251L18.6641 6.746V6.747Z"></path>
    </symbol>
    <symbol
        id="icon-ui-arrow-right"
        viewBox="0 0 28 28">
        <path
            d="M9.33597 6.747C8.92297 6.38 8.88597 5.748 9.25297 5.335C9.61997 4.922 10.252 4.885 10.665 5.252L17.983 11.757C19.221 12.858 19.333 14.754 18.232 15.992C18.154 16.08 18.071 16.163 17.983 16.241L10.665 22.746C10.252 23.113 9.61997 23.076 9.25297 22.663C8.88597 22.25 8.92297 21.618 9.33597 21.251L16.654 14.746C16.683 14.72 16.711 14.692 16.737 14.663C17.104 14.25 17.067 13.618 16.654 13.251L9.33597 6.746V6.747Z"></path>
    </symbol>
    <symbol
        id="icon-ui-arrow-up"
        viewBox="0 0 28 28">
        <path
            d="M6.747 18.664C6.38 19.077 5.748 19.114 5.335 18.747C4.922 18.38 4.885 17.748 5.252 17.335L11.757 10.017C12.858 8.77898 14.754 8.66698 15.992 9.76798C16.08 9.84598 16.163 9.92898 16.241 10.017L22.746 17.335C23.113 17.748 23.076 18.38 22.663 18.747C22.25 19.114 21.618 19.077 21.251 18.664L14.746 11.346C14.72 11.317 14.692 11.289 14.663 11.263C14.25 10.896 13.618 10.933 13.251 11.346L6.746 18.664H6.747Z"></path>
    </symbol>
    <symbol
        id="icon-ui-assign-cs"
        viewBox="0 0 28 28">
        <path
            d="M5 4C4.448 4 4 4.448 4 5V13C4 13.552 4.448 14 5 14H11C11.552 14 12 13.552 12 13V5C12 4.448 11.552 4 11 4H5Z"></path>
        <path
            d="M16 5C16 4.448 16.448 4 17 4H23C23.552 4 24 4.448 24 5V9C24 9.552 23.552 10 23 10H17C16.448 10 16 9.552 16 9V5Z"></path>
        <path
            d="M5 18C4.448 18 4 18.448 4 19V23C4 23.552 4.448 24 5 24H11C11.552 24 12 23.552 12 23V19C12 18.448 11.552 18 11 18H5Z"></path>
        <path d="M20 14H22V24H20V14Z"></path>
        <path d="M26 18V20H16V18H26Z"></path>
    </symbol>
    <symbol
        id="icon-ui-asterisk"
        viewBox="0 0 28 28">
        <path
            d="M16.424 10L15.984 14.104L20.12 12.944L20.421 15.275L16.554 15.587L19.089 18.928L16.951 20.077L15.168 16.446L13.567 20.077L11.365 18.928L13.846 15.587L10 15.275L10.376 12.944L14.415 14.104L13.975 10H16.424Z"></path>
    </symbol>
    <symbol
        id="icon-ui-audience-network"
        viewBox="0 0 28 28">
        <path
            d="M14 2.00002C7.373 2.00002 2 6.95702 2 13.071C2 15.783 3.057 18.267 4.811 20.191L2.76 22.225C2.656 22.328 2.598 22.467 2.598 22.611V25.433C2.598 25.738 2.852 25.984 3.165 25.984H6.069C6.217 25.984 6.359 25.928 6.465 25.827L8.698 23.71C8.72 23.689 8.75 23.677 8.781 23.677H19.205C19.237 23.677 19.267 23.689 19.289 23.711L21.476 25.837C21.582 25.94 21.727 25.998 21.877 25.998H24.836C25.149 25.998 25.403 25.751 25.403 25.447V22.625C25.403 22.481 25.345 22.342 25.241 22.239L23.182 20.198C24.94 18.272 26 15.785 26 13.07C26 6.95502 20.627 1.99902 14 1.99902V2.00002ZM21.164 13.231C21.164 16.645 17.956 19.412 14 19.412C10.044 19.412 6.836 16.645 6.836 13.231C6.836 9.81702 10.044 7.05002 14 7.05002C17.956 7.05002 21.164 9.81702 21.164 13.231Z"></path>
    </symbol>
    <symbol
        id="icon-ui-banner-set"
        viewBox="0 0 28 28">
        <path
            d="M5 18H11C11.552 18 12 18.448 12 19V23C12 23.552 11.552 24 11 24H5C4.448 24 4 23.552 4 23V19C4 18.448 4.448 18 5 18ZM17 4H23C23.552 4 24 4.448 24 5V9C24 9.552 23.552 10 23 10H17C16.448 10 16 9.552 16 9V5C16 4.448 16.448 4 17 4ZM17 14H23C23.552 14 24 14.448 24 15V23C24 23.552 23.552 24 23 24H17C16.448 24 16 23.552 16 23V15C16 14.448 16.448 14 17 14ZM5 4H11C11.552 4 12 4.448 12 5V13C12 13.552 11.552 14 11 14H5C4.448 14 4 13.552 4 13V5C4 4.448 4.448 4 5 4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-banner-sets"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_100)">
            <path
                d="M0 18.2C0 17.427 0.627 16.8 1.4 16.8H9.8C10.573 16.8 11.2 17.427 11.2 18.2V26.6C11.2 27.373 10.573 28 9.8 28H1.4C0.627 28 0 27.373 0 26.6L0 18.2Z"></path>
            <path
                d="M0 11.2C0 10.427 0.627 9.79999 1.4 9.79999H16.8C17.573 9.79999 18.2 10.427 18.2 11.2V26.6C18.2 27.373 17.573 28 16.8 28H15.4C14.627 28 14 27.373 14 26.6V15.4C14 14.627 13.373 14 12.6 14H1.4C0.627 14 0 13.373 0 12.6L0 11.2Z"></path>
            <path
                d="M0 1.4C0 0.627 0.627 0 1.4 0H26.6C27.373 0 28 0.627 28 1.4V26.6C28 27.373 27.373 28 26.6 28H22.4C21.627 28 21 27.373 21 26.6V8.4C21 7.627 20.373 7 19.6 7H1.4C0.627 7 0 6.373 0 5.6L0 1.4Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_100">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-big-preview"
        viewBox="0 0 28 28">
        <path d="M24 10V24H4V10H24ZM24 4V8H4V4H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-bookmark-outline"
        viewBox="0 0 28 28">
        <path
            d="M14 20L8 24V6C8 4.895 8.895 4 10 4H18C19.105 4 20 4.895 20 6V24L14 20ZM10 20.263L14 17.596L18 20.263V6H10V20.263Z"></path>
    </symbol>
    <symbol
        id="icon-ui-border-joint"
        viewBox="0 0 28 28">
        <path
            d="M20 6C21.105 6 22 6.895 22 8V20C22 21.105 21.105 22 20 22H8C6.895 22 6 21.105 6 20V8C6 6.895 6.895 6 8 6H20ZM8 4C5.791 4 4 5.791 4 8V20C4 22.209 5.791 24 8 24H20C22.209 24 24 22.209 24 20V8C24 5.791 22.209 4 20 4H8Z"></path>
    </symbol>
    <symbol
        id="icon-ui-border-separate"
        viewBox="0 0 28 28">
        <path d="M10 4H18V6H10V4Z"></path>
        <path d="M10 22H18V24H10V22Z"></path>
        <path d="M4 10H6V18H4V10Z"></path>
        <path d="M22 10H24V18H22V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-button"
        viewBox="0 0 28 28">
        <path
            d="M24 20V18C25.105 18 26 17.105 26 16V8C26 6.895 25.105 6 24 6H4C2.895 6 2 6.895 2 8V16C2 17.105 2.895 18 4 18H8V20H4C1.791 20 0 18.209 0 16V8C0 5.791 1.791 4 4 4H24C26.209 4 28 5.791 28 8V16C28 18.209 26.209 20 24 20ZM12 12L22 22L12 26V12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-camera"
        viewBox="0 0 28 28">
        <path
            d="M13.667 20.917C15.125 20.917 16.365 20.406 17.386 19.385C18.407 18.364 18.917 17.124 18.917 15.667C18.917 14.209 18.406 12.969 17.385 11.948C16.364 10.927 15.124 10.417 13.667 10.417C12.209 10.417 10.969 10.928 9.948 11.949C8.927 12.97 8.417 14.21 8.417 15.667C8.417 17.125 8.928 18.365 9.949 19.386C10.97 20.407 12.21 20.917 13.667 20.917ZM13.667 18.583C12.85 18.583 12.16 18.301 11.596 17.737C11.032 17.173 10.75 16.483 10.75 15.666C10.75 14.849 11.032 14.159 11.596 13.595C12.16 13.031 12.85 12.749 13.667 12.749C14.484 12.749 15.174 13.031 15.738 13.595C16.302 14.159 16.584 14.849 16.584 15.666C16.584 16.483 16.302 17.173 15.738 17.737C15.174 18.301 14.484 18.583 13.667 18.583ZM4.333 25C3.691 25 3.142 24.771 2.685 24.314C2.228 23.857 1.999 23.308 2 22.667V8.667C2 8.025 2.229 7.476 2.686 7.018C3.143 6.56 3.692 6.332 4.333 6.333H8.008L10.166 4H17.166L19.324 6.333H22.999C23.641 6.333 24.19 6.562 24.648 7.019C25.106 7.476 25.334 8.025 25.333 8.666V22.666C25.333 23.308 25.104 23.857 24.647 24.315C24.19 24.773 23.64 25.001 23 25H4.333ZM23 22.667V8.667H18.275L16.146 6.334H11.188L9.059 8.667H4.334V22.667H23Z"></path>
    </symbol>
    <symbol
        id="icon-ui-campaign"
        viewBox="0 0 28 28">
        <path
            d="M14 15.029C14 13.699 13.184 12.556 12 12V18.05C13.184 17.501 14 16.359 14 15.029ZM2 12V18H6L10 22V8L6 12H2Z"></path>
    </symbol>
    <symbol
        id="icon-ui-campaign-add-to"
        viewBox="0 0 28 28">
        <path
            d="M16 13.029C16 11.699 15.184 10.556 14 10V16.05C15.184 15.501 16 14.359 16 13.029ZM22 20H26V22H22V26H20V22H16V20H20V16H22V20ZM4 10H8L12 6V20L8 16H4V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-campaign-forward-to"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_123)">
            <path
                d="M28 15.029C28 13.699 27.184 12.556 26 12V18.05C27.184 17.501 28 16.359 28 15.029ZM7.172 15.998H-2V13.998H7.171L3.807 10.634L5.221 9.22L11 14.999L5.221 20.776L3.807 19.362L7.172 15.998ZM16 12H20L24 8V22L20 18H16V12Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_123">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-campaign-go-to"
        viewBox="0 0 28 28">
        <path
            d="M16 13.029C16 11.699 15.184 10.556 14 10V16.05C15.184 15.501 16 14.359 16 13.029ZM22.537 22H16V20H22.536L19.76 17.224L20.984 16L25.985 21.001L20.984 26L19.76 24.776L22.537 22ZM4 10H8L12 6V20L8 16H4V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-campaigns-l"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_127)">
            <path
                d="M10.8799 21.197L6.80192 17.119C7.19792 16.225 7.60692 15.365 8.02692 14.538L1.69692 13.335C1.64492 13.337 1.59392 13.33 1.54592 13.314C1.31292 13.236 1.21792 12.971 1.33592 12.722L5.27592 8.62297C5.36692 8.42797 5.56492 8.29497 5.76692 8.29097L11.9989 8.17497C12.7619 7.19197 13.5539 6.28897 14.3749 5.46797C17.1769 2.66597 21.5639 0.84497 27.5369 0.00496966C27.7979 -0.0310303 28.0039 0.14797 27.9979 0.40697C27.9979 0.42597 27.9959 0.44397 27.9929 0.46297C27.1529 6.43597 25.3319 10.823 22.5299 13.625C21.7069 14.448 20.8019 15.242 19.8159 16.007L19.7009 22.227C19.6969 22.429 19.5629 22.626 19.3689 22.718L15.3499 26.737C15.1009 26.854 14.8359 26.76 14.7579 26.527C14.7419 26.48 14.7349 26.429 14.7369 26.376L13.4539 19.978C12.6289 20.397 11.7709 20.804 10.8799 21.199V21.197ZM18.6899 9.30097C19.6659 10.277 21.2489 10.277 22.2259 9.30097C23.2029 8.32497 23.2019 6.74197 22.2259 5.76497C21.2499 4.78897 19.6669 4.78897 18.6899 5.76497C17.7129 6.74097 17.7139 8.32397 18.6899 9.30097ZM0.220917 27.903C0.194917 27.914 0.165917 27.914 0.139917 27.903C0.0899174 27.881 0.0669174 27.821 0.0889174 27.771L3.92392 19.142C3.92892 19.131 3.93592 19.121 3.94492 19.112C3.98392 19.073 4.04692 19.073 4.08592 19.112L8.87992 23.906C8.88892 23.915 8.89592 23.925 8.90092 23.936C8.92292 23.986 8.90092 24.046 8.84992 24.068L0.220917 27.903Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_127">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-campaigns-l-create-new"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_129)">
            <path
                d="M23.9999 18L23.9979 22H27.9999V24H23.9979L23.9999 28H21.9999L21.9979 24H17.9999V22H21.9979L21.9999 18H23.9999ZM4.08592 19.111L8.87992 23.905C8.88892 23.914 8.89592 23.924 8.90092 23.935C8.92292 23.985 8.90092 24.045 8.84992 24.067L0.220917 27.902C0.194917 27.913 0.165917 27.913 0.139917 27.902C0.0899174 27.88 0.0669174 27.82 0.0889174 27.77L3.92392 19.141C3.92892 19.13 3.93592 19.12 3.94492 19.111C3.98392 19.072 4.04692 19.072 4.08592 19.111ZM27.9979 0.40597C27.9969 0.42497 27.9959 0.44297 27.9929 0.46197C27.1529 6.43497 25.3319 10.822 22.5299 13.624C21.7069 14.447 20.8019 15.241 19.8159 16.006L19.8149 16.041L13.5729 20.583L13.4529 19.976C12.6279 20.395 11.7699 20.802 10.8789 21.197L6.80092 17.119C7.19692 16.225 7.60592 15.365 8.02592 14.538L1.69592 13.335C1.64392 13.337 1.59292 13.33 1.54492 13.314C1.31192 13.236 1.21692 12.971 1.33492 12.722L5.27492 8.62297C5.36592 8.42797 5.56392 8.29497 5.76592 8.29097L11.9979 8.17497C12.7609 7.19197 13.5529 6.28897 14.3739 5.46797C17.1759 2.66597 21.5629 0.84497 27.5359 0.00496966C27.7969 -0.0310303 28.0029 0.14797 27.9979 0.40697V0.40597ZM18.6899 5.76597C17.7139 6.74197 17.7139 8.32497 18.6899 9.30197C19.6659 10.279 21.2489 10.278 22.2259 9.30197C23.2019 8.32597 23.2019 6.74297 22.2259 5.76597C21.2499 4.78897 19.6669 4.78997 18.6899 5.76597Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_129">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-campaigns-s"
        viewBox="0 0 28 28">
        <path
            d="M12.5611 20.276L9.68405 17.407C9.95505 16.786 10.2361 16.189 10.5241 15.615L6.09005 14.736C6.05305 14.737 6.01805 14.732 5.98405 14.72C5.82005 14.664 5.75305 14.479 5.83305 14.306L8.56205 11.473C8.62505 11.338 8.76205 11.246 8.90305 11.244L13.2601 11.202C13.7871 10.521 14.3351 9.89697 14.9051 9.32897C16.8461 7.39297 19.9031 6.15097 24.0741 5.60197C24.2561 5.57797 24.4021 5.70497 24.3991 5.88497C24.3991 5.89797 24.3981 5.91097 24.3961 5.92397C23.8461 10.084 22.6001 13.132 20.6591 15.068C20.0891 15.637 19.4611 16.185 18.7761 16.712L18.7341 21.048C18.7331 21.189 18.6401 21.326 18.5051 21.388L15.7201 24.165C15.5461 24.245 15.3611 24.178 15.3051 24.015C15.2941 23.982 15.2881 23.946 15.2891 23.91L14.3511 19.44C13.7771 19.727 13.1801 20.006 12.5591 20.276H12.5611ZM5.91505 24.192C5.89305 24.202 5.86805 24.202 5.84605 24.192C5.80605 24.173 5.78905 24.124 5.80805 24.084L8.58505 18.247C8.58905 18.239 8.59405 18.231 8.60105 18.225C8.63205 18.193 8.68305 18.193 8.71505 18.225L11.7761 21.314C11.7831 21.321 11.7881 21.329 11.7921 21.337C11.8111 21.378 11.7931 21.426 11.7531 21.445L5.91405 24.194L5.91505 24.192ZM17.7981 12.202C18.4621 12.866 19.5381 12.866 20.2021 12.202C20.8661 11.538 20.8661 10.462 20.2021 9.79797C19.5381 9.13397 18.4621 9.13397 17.7981 9.79797C17.1341 10.462 17.1341 11.538 17.7981 12.202Z"></path>
    </symbol>
    <symbol
        id="icon-ui-campaigns-s-create-new"
        viewBox="0 0 28 28">
        <path
            d="M22.0001 16L21.9981 19.998L26.0001 20V22L21.9981 21.998L22.0001 26H20.0001L19.9981 21.998L16.0001 22V20L19.9981 19.998L20.0001 16H22.0001ZM6.7151 16.224L9.77609 19.313C9.78309 19.32 9.78809 19.328 9.79209 19.336C9.81109 19.377 9.7931 19.425 9.7531 19.444L3.9141 22.193C3.8921 22.203 3.8671 22.203 3.8451 22.193C3.8051 22.174 3.7881 22.125 3.8071 22.085L6.5841 16.248L6.6001 16.226C6.63109 16.194 6.6821 16.194 6.7141 16.226L6.7151 16.224ZM22.0751 3.60301C22.2571 3.57901 22.4031 3.70601 22.4001 3.88601L22.3971 3.92501C21.8471 8.08501 20.6011 11.133 18.6601 13.069C18.0901 13.638 17.4621 14.186 16.7771 14.713L16.7701 15.329L12.7501 19.355C12.6351 18.803 12.5031 18.165 12.3531 17.442C11.7791 17.729 11.1821 18.008 10.5611 18.278L7.6841 15.409C7.9551 14.788 8.23609 14.191 8.5241 13.617L4.0901 12.738C4.0531 12.739 4.0181 12.734 3.9841 12.722C3.8201 12.666 3.7531 12.481 3.8331 12.308L6.56209 9.47501C6.62509 9.34001 6.76209 9.24801 6.9031 9.24601L11.2601 9.20401C11.7871 8.52301 12.3351 7.89901 12.9051 7.33101C14.8461 5.39501 17.9031 4.15301 22.0741 3.60401L22.0751 3.60301ZM15.7981 7.79801C15.1341 8.46201 15.1341 9.53801 15.7981 10.202C16.4621 10.866 17.5381 10.866 18.2021 10.202C18.8661 9.53801 18.8661 8.46201 18.2021 7.79801C17.5381 7.13401 16.4621 7.13401 15.7981 7.79801Z"></path>
    </symbol>
    <symbol
        id="icon-ui-campaign-tile"
        viewBox="0 0 28 28">
        <path
            d="M4 2H22C24.209 2 26 3.791 26 6V24C26 26.209 24.209 28 22 28H4C1.791 28 0 26.209 0 24V6C0 3.791 1.791 2 4 2ZM4 4C2.895 4 2 4.895 2 6V24C2 25.105 2.895 26 4 26H22C23.105 26 24 25.105 24 24V6C24 4.895 23.105 4 22 4H4ZM20 15.029C20 16.359 19.184 17.502 18 18.05V12C19.184 12.556 20 13.699 20 15.029ZM8 12H12L16 8V22L12 18H8V12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-campaign-upload"
        viewBox="0 0 28 28">
        <path
            d="M14 13.029C14 11.699 13.184 10.556 12 10V16.05C13.184 15.501 14 14.359 14 13.029ZM24 15.447V22H22V15.448L19.224 18.224L18 17L23.001 11.999L28 17L26.776 18.224L24 15.447ZM2 10H6L10 6V20L6 16H2V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-campaign-w-frame"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_139)">
            <path
                d="M20 15.029C20 13.699 19.184 12.556 18 12V18.05C19.184 17.501 20 16.359 20 15.029ZM8 12V18H12L16 22V8L12 12H8ZM2 2V28H28V2H2ZM2.308 0H27.693C28.967 0 30.001 1.033 30.001 2.308V27.693C30.001 28.967 28.968 30.001 27.693 30.001H2.308C1.034 30.001 0 28.968 0 27.693V2.308C0 1.034 1.033 0 2.308 0Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_139">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-cancel-24"
        viewBox="0 0 28 28">
        <path
            d="M14 2.33301C7.54801 2.33301 2.33301 7.54801 2.33301 14C2.33301 20.452 7.54801 25.667 14 25.667C20.452 25.667 25.667 20.452 25.667 14C25.667 7.54801 20.452 2.33301 14 2.33301ZM14 23.333C8.85501 23.333 4.66701 19.145 4.66701 14C4.66701 8.85501 8.85501 4.66701 14 4.66701C19.145 4.66701 23.333 8.85501 23.333 14C23.333 19.145 19.145 23.333 14 23.333ZM14 12.355L18.188 8.16701L19.833 9.81201L15.645 14L19.833 18.188L18.188 19.833L14 15.645L9.81201 19.833L8.16701 18.188L12.355 14L8.16701 9.81201L9.81201 8.16701L14 12.355Z"></path>
    </symbol>
    <symbol
        id="icon-ui-carousel"
        viewBox="0 0 28 28">
        <path
            d="M4.333 22.667H6.666C6.666 23.954 7.712 25 8.999 25H18.332C19.619 25 20.665 23.953 20.665 22.667H22.998C24.285 22.667 25.331 21.621 25.331 20.334V8.66698C25.331 7.37998 24.284 6.33398 22.998 6.33398H20.665C20.665 5.04698 19.619 4.00098 18.332 4.00098H8.999C7.712 4.00098 6.666 5.04698 6.666 6.33398H4.333C3.046 6.33398 2 7.38098 2 8.66698V20.334C2 21.621 3.046 22.667 4.333 22.667ZM23 8.66698V20.334H20.667V8.66698H23ZM9 6.33298H18.333L18.334 22.666H9V6.33298ZM4.333 8.66698H6.666V20.334H4.333V8.66698Z"></path>
    </symbol>
    <symbol
        id="icon-ui-checkbox-checkmark-default"
        viewBox="0 0 28 28">
        <path
            d="M11.79 17.668L8.06098 13.939C7.47498 13.353 6.52498 13.353 5.93998 13.939C5.35498 14.525 5.35398 15.475 5.93998 16.06L10.94 21.06C11.602 21.722 12.701 21.623 13.234 20.853L22.234 7.853C22.706 7.172 22.536 6.237 21.855 5.766C21.174 5.295 20.239 5.464 19.768 6.145L11.791 17.667L11.79 17.668Z"></path>
    </symbol>
    <symbol
        id="icon-ui-checkbox-empty"
        viewBox="0 0 28 28">
        <path
            d="M6 2H22C24.209 2 26 3.791 26 6V22C26 24.209 24.209 26 22 26H6C3.791 26 2 24.209 2 22V6C2 3.791 3.791 2 6 2ZM6 4C4.895 4 4 4.895 4 6V22C4 23.105 4.895 24 6 24H22C23.105 24 24 23.105 24 22V6C24 4.895 23.105 4 22 4H6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-checkbox-false"
        viewBox="0 0 28 28">
        <path
            d="M6 2H22C24.209 2 26 3.791 26 6V22C26 24.209 24.209 26 22 26H6C3.791 26 2 24.209 2 22V6C2 3.791 3.791 2 6 2ZM6 4C4.895 4 4 4.895 4 6V22C4 23.105 4.895 24 6 24H22C23.105 24 24 23.105 24 22V6C24 4.895 23.105 4 22 4H6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-checkbox-true"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_151)">
            <path
                d="M4 0H24C26.209 0 28 1.791 28 4V24C28 26.209 26.209 28 24 28H4C1.791 28 0 26.209 0 24V4C0 1.791 1.791 0 4 0ZM12.154 18.308L8.719 14.753C8.335 14.356 7.702 14.345 7.305 14.729C6.908 15.113 6.897 15.746 7.281 16.143L11.579 20.591C12.022 21.05 12.776 20.982 13.13 20.451L21.726 7.555C22.032 7.095 21.908 6.475 21.449 6.168C20.99 5.861 20.369 5.986 20.062 6.445L12.154 18.308Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_151">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-checkmark-large"
        viewBox="0 0 28 28">
        <path
            d="M24.071 4.46901C24.394 3.98501 25.047 3.85401 25.531 4.17701C26.015 4.50001 26.146 5.15301 25.823 5.63701L12.561 25.531C12.131 26.072 11.473 26.178 10.928 25.679L4.297 18.817C3.893 18.399 3.904 17.732 4.323 17.328C4.742 16.924 5.408 16.935 5.812 17.354L11.535 23.276L24.072 4.46901H24.071Z"></path>
    </symbol>
    <symbol
        id="icon-ui-choice"
        viewBox="0 0 28 28">
        <path
            d="M8 16C10.209 16 12 17.791 12 20C12 22.209 10.209 24 8 24C5.791 24 4 22.209 4 20C4 17.791 5.791 16 8 16ZM8 18C6.895 18 6 18.895 6 20C6 21.105 6.895 22 8 22C9.105 22 10 21.105 10 20C10 18.895 9.105 18 8 18ZM26 19V21C26 21.552 25.552 22 25 22H15C14.448 22 14 21.552 14 21V19C14 18.448 14.448 18 15 18H25C25.552 18 26 18.448 26 19ZM8 4C10.209 4 12 5.791 12 8C12 10.209 10.209 12 8 12C5.791 12 4 10.209 4 8C4 5.791 5.791 4 8 4ZM26 7V9C26 9.552 25.552 10 25 10H15C14.448 10 14 9.552 14 9V7C14 6.448 14.448 6 15 6H25C25.552 6 26 6.448 26 7Z"></path>
    </symbol>
    <symbol
        id="icon-ui-clear"
        viewBox="0 0 28 28">
        <path
            d="M15 13.586L11.707 10.293C11.316 9.902 10.683 9.902 10.293 10.293C9.903 10.684 9.902 11.317 10.293 11.707L13.586 15L10.293 18.293C9.902 18.684 9.902 19.317 10.293 19.707C10.684 20.097 11.317 20.098 11.707 19.707L15 16.414L18.293 19.707C18.684 20.098 19.317 20.098 19.707 19.707C20.097 19.316 20.098 18.683 19.707 18.293L16.414 15L19.707 11.707C20.098 11.316 20.098 10.683 19.707 10.293C19.316 9.903 18.683 9.902 18.293 10.293L15 13.586ZM15 26C8.925 26 4 21.075 4 15C4 8.925 8.925 4 15 4C21.075 4 26 8.925 26 15C26 21.075 21.075 26 15 26Z"></path>
    </symbol>
    <symbol
        id="icon-ui-click"
        viewBox="0 0 28 28">
        <path
            d="M7.12888 6.30499C6.76388 5.41599 7.23388 4.39099 8.14788 4.08499C8.90488 3.83099 9.72588 4.15899 10.0939 4.86299L11.9549 8.41399L19.6209 10.038C21.0069 10.332 21.9989 11.556 21.9989 12.973V20.081C21.9989 21.044 21.3129 21.87 20.3659 22.047L14.0809 23.22C13.0049 23.421 11.9789 22.721 11.7579 21.67C11.7019 21.616 11.6449 21.561 11.5899 21.503L6.83288 16.757C6.05188 15.949 5.63788 15.067 6.41888 14.258C7.19988 13.449 8.46588 13.45 9.24688 14.258L11.0299 16.037L10.9839 15.679L7.12888 6.30499Z"></path>
    </symbol>
    <symbol
        id="icon-ui-clicks"
        viewBox="0 0 28 28">
        <path d="M8 6L18 15H12L8 19V6Z"></path>
        <path
            d="M14.8869 21.533C14.1719 21.848 13.3379 21.523 13.0229 20.808L9.03491 11.747L11.6239 10.608L15.6119 19.669C15.9269 20.384 15.6019 21.218 14.8869 21.533Z"></path>
    </symbol>
    <symbol
        id="icon-ui-close"
        viewBox="0 0 28 28">
        <path
            d="M15.572 14L23.674 5.89599C24.11 5.46199 24.11 4.75999 23.674 4.32599C23.24 3.89199 22.538 3.89199 22.104 4.32599L14 12.428L5.89799 4.32599C5.46399 3.89199 4.75999 3.89199 4.32599 4.32599C3.89199 4.75999 3.89199 5.46199 4.32599 5.89599L12.43 14L4.32599 22.104C3.89199 22.538 3.89199 23.24 4.32599 23.674C4.54399 23.89 4.82799 24 5.11199 24C5.39599 24 5.67999 23.89 5.89799 23.674L14 15.572L22.104 23.674C22.322 23.89 22.606 24 22.89 24C23.174 24 23.458 23.89 23.674 23.674C24.11 23.24 24.11 22.538 23.674 22.104L15.572 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cloud"
        viewBox="0 0 28 28">
        <path
            d="M14 16.829V24.006H9.5C6.466 24.006 4 21.54 4 18.506C4 15.903 5.811 13.718 8.246 13.154C9.056 10.184 11.773 8 15 8C18.833 8 21.947 11.081 21.999 14.902C24.257 15.187 26 17.092 26 19.423C26 21.953 23.947 24.006 21.417 24.006H16V16.828L19.364 20.193L20.778 18.779L15.001 13L9.222 18.779L10.636 20.193L14 16.829Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cloud-large"
        viewBox="0 0 28 28">
        <path
            d="M21.998 12.978C21.984 9.13 18.846 6 15 6C11.75 6 8.956 8.218 8.208 11.396L7.964 12.426L6.974 12.804C5.196 13.486 4 15.27 4 17.248C4 19.868 6.018 22 8.5 22H12V24H8.5C4.914 24 2 20.972 2 17.248C2 14.344 3.778 11.886 6.26 10.936C7.196 6.964 10.742 4 15 4C19.96 4 23.98 8.014 23.998 12.97C26.304 13.612 28 15.776 28 18.374C28 21.478 25.574 24 22.584 24H18V22H22.584C24.468 22 26 20.374 26 18.374C26 16.742 24.956 15.312 23.462 14.898L22.002 14.492L21.998 12.978ZM16 15.172V26H14V15.166L10.754 18.412L9.34 16.998L14.998 11.34L20.654 16.998L19.24 18.412L16 15.172Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cloud-l-negative"
        viewBox="0 0 28 28">
        <path
            d="M14 13.829V23.993H8.5C4.914 23.993 2 21.079 2 17.493C2 14.741 3.713 12.384 6.135 11.44C6.873 7.21302 10.562 3.99902 15 3.99902C19.971 3.99902 24 8.02802 24 12.999C24 13.124 23.997 13.249 23.992 13.373C26.302 13.988 28 16.075 28 18.576C28 21.566 25.573 23.993 22.583 23.993H16V13.828L19.364 17.193L20.778 15.779L15.001 10L9.222 15.779L10.636 17.193L14 13.829Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cloud-no-arrow-s-default"
        viewBox="0 0 28 28">
        <path
            d="M15 5.99298C18.866 5.99298 22 9.12698 22 12.993C22 13.097 21.998 13.201 21.993 13.303C24.253 13.57 26 15.39 26 17.618C26 20.033 23.947 21.993 21.417 21.993H9.5C6.466 21.993 4 19.639 4 16.743C4 14.299 5.753 12.241 8.128 11.661C8.748 8.43198 11.589 5.99298 15 5.99298Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cloud-s"
        viewBox="0 0 28 28">
        <path
            d="M15 5.99298C18.866 5.99298 22 9.12698 22 12.993C22 13.097 21.998 13.201 21.993 13.303C24.253 13.57 26 15.39 26 17.618C26 19.928 24.121 21.822 21.744 21.982L21.417 21.993H16V13.827L19.364 17.193L20.778 15.779L15.001 9.99998L9.222 15.779L10.636 17.193L14 13.827V21.993H9.5C6.466 21.993 4 19.639 4 16.743C4 14.299 5.753 12.241 8.128 11.661C8.748 8.43198 11.589 5.99298 15 5.99298Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cloud-warning-s-error"
        viewBox="0 0 28 28">
        <path
            d="M23 22C23.552 22 24 22.448 24 23V25C24 25.552 23.552 26 23 26H21C20.448 26 20 25.552 20 25V23C20 22.448 20.448 22 21 22H23ZM15 5.99298C16.907 5.99298 18.636 6.75598 19.898 7.99198L19 7.99298C18.448 7.99298 18 8.44098 18 8.99298V21.993H9.5C6.583 21.993 4.191 19.817 4.011 17.075L4 16.743C4 14.299 5.753 12.241 8.128 11.661C8.748 8.43198 11.589 5.99298 15 5.99298ZM23 9.99998C23.552 9.99998 24 10.448 24 11V19C24 19.552 23.552 20 23 20H21C20.448 20 20 19.552 20 19V11C20 10.448 20.448 9.99998 21 9.99998H23Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cloud-warning-s-error1"
        viewBox="0 0 28 28">
        <path
            d="M23 22C23.552 22 24 22.448 24 23V25C24 25.552 23.552 26 23 26H21C20.448 26 20 25.552 20 25V23C20 22.448 20.448 22 21 22H23ZM15 5.99298C16.907 5.99298 18.636 6.75598 19.898 7.99198L19 7.99298C18.448 7.99298 18 8.44098 18 8.99298V21.993H9.5C6.583 21.993 4.191 19.817 4.011 17.075L4 16.743C4 14.299 5.753 12.241 8.128 11.661C8.748 8.43198 11.589 5.99298 15 5.99298ZM23 9.99998C23.552 9.99998 24 10.448 24 11V19C24 19.552 23.552 20 23 20H21C20.448 20 20 19.552 20 19V11C20 10.448 20.448 9.99998 21 9.99998H23Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cm-published"
        viewBox="0 0 28 28">
        <path
            d="M23.992 13.374C23.997 13.25 24 13.125 24 13C24 8.029 19.971 4 15 4C10.561 4 6.873 7.213 6.135 11.441C3.714 12.385 2 14.742 2 17.494C2 21.08 4.914 23.994 8.5 23.994H22.583C25.573 23.994 28 21.567 28 18.577C28 16.076 26.302 13.99 23.992 13.374Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cm-published-changed"
        viewBox="0 0 28 28">
        <path
            d="M15 4.00002C16.325 4.00002 17.583 4.28602 18.715 4.80002C17.654 5.88202 17 7.36502 17 9.00002C17 12.314 19.686 15 23 15C24.033 15 25.005 14.739 25.854 14.279C27.158 15.26 28 16.816 28 18.576C28 21.566 25.573 23.993 22.583 23.993H8.5C4.914 23.993 2 21.079 2 17.493C2 14.741 3.713 12.384 6.135 11.44C6.873 7.21302 10.562 4.00002 15 4.00002ZM23 12C24.657 12 26 10.657 26 9.00002C26 7.34302 24.657 6.00002 23 6.00002C21.343 6.00002 20 7.34302 20 9.00002C20 10.657 21.343 12 23 12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-code"
        viewBox="0 0 28 28">
        <path
            d="M24 13V15L18 18V16L22 14L18 12V10L24 13ZM4 13L10 10V12L6 14L10 16V18L4 15V13ZM12 22L14 6H16L14 22H12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-code-large"
        viewBox="0 0 28 28">
        <path
            d="M16 4H18L12 24H10L16 4ZM28 13V15L20 20V18L26 14L20 10V8L28 13ZM0 13L8 8V10L2 14L8 18V20L0 15V13Z"></path>
    </symbol>
    <symbol
        id="icon-ui-collapse"
        viewBox="0 0 28 28">
        <path
            d="M6.97697 4.75102C7.30597 4.42202 7.83797 4.42202 8.16697 4.75102L13.461 10.045L18.755 4.75102C19.084 4.42202 19.616 4.42202 19.945 4.75102C20.274 5.08002 20.274 5.61202 19.945 5.94102L14.056 11.83C13.727 12.159 13.195 12.159 12.866 11.83L6.97697 5.94102C6.64797 5.61202 6.64797 5.08002 6.97697 4.75102Z"></path>
        <path
            d="M12.867 16.83C13.196 16.501 13.728 16.501 14.057 16.83L19.946 22.719C20.275 23.048 20.275 23.58 19.946 23.909C19.617 24.238 19.085 24.238 18.756 23.909L13.462 18.615L8.16795 23.909C7.83895 24.238 7.30695 24.238 6.97795 23.909C6.64895 23.58 6.64895 23.048 6.97795 22.719L12.867 16.83Z"></path>
    </symbol>
    <symbol
        id="icon-ui-color-picker"
        viewBox="0 0 28 28">
        <path
            d="M23.676 6.92499L21.076 4.32499C20.643 3.89199 19.943 3.89199 19.509 4.32499L16.043 7.79099L13.899 5.66899L12.332 7.23599L13.91 8.81399L4 18.724V24.001H9.277L19.187 14.091L20.765 15.669L22.332 14.102L20.199 11.969L23.665 8.50299C24.109 8.05899 24.109 7.35899 23.676 6.92499ZM8.355 21.779L6.222 19.646L15.177 10.691L17.31 12.824L8.355 21.779Z"></path>
    </symbol>
    <symbol
        id="icon-ui-columns-grid"
        viewBox="0 0 28 28">
        <path d="M12 16V24H4V16H12ZM24 16V24H16V16H24ZM12 4V12H4V4H12ZM24 4V12H16V4H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-comment-filled"
        viewBox="0 0 28 28">
        <path
            d="M24 8C24 5.791 22.209 4 20 4H10C7.791 4 6 5.791 6 8V14C6 16.209 7.791 18 10 18V22.793C10 23.239 10.539 23.462 10.854 23.147L16 18.001H20C22.209 18.001 24 16.21 24 14.001V8.001V8Z"></path>
    </symbol>
    <symbol
        id="icon-ui-comments"
        viewBox="0 0 28 28">
        <path
            d="M24 18C24 19.105 23.105 20 22 20H14L8.85398 25.146C8.65898 25.341 8.34198 25.341 8.14698 25.146C8.05298 25.052 8.00098 24.925 8.00098 24.792V19.999C6.89598 19.999 6.00098 19.104 6.00098 17.999V7.99902C6.00098 6.89402 6.89598 5.99902 8.00098 5.99902H22.001C23.106 5.99902 24.001 6.89402 24.001 7.99902V17.999L24 18ZM9.99998 18V20.669C9.99998 20.779 10.09 20.869 10.2 20.869C10.255 20.869 10.308 20.846 10.345 20.806L13 17.999H22V7.99902H7.99998V17.999L9.99998 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-comments-add"
        viewBox="0 0 28 28">
        <path
            d="M22 7.99999H5.99998V18H7.99998V20.669C7.99998 20.779 8.08998 20.869 8.19998 20.869C8.25498 20.869 8.30798 20.846 8.34498 20.806L10.998 17.999H12L14 19.999H12L6.85398 25.145C6.65898 25.34 6.34198 25.34 6.14698 25.145C6.05298 25.051 6.00098 24.924 6.00098 24.791V19.998C4.89598 19.998 4.00098 19.103 4.00098 17.998V7.99799C4.00098 6.89299 4.89598 5.99799 6.00098 5.99799H20.001C21.106 5.99799 22.001 6.89299 22.001 7.99799L22 7.99999ZM26 18H22.002L22 22H20V18H16V16H20V12H22V16H26V18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-comments-checkmark"
        viewBox="0 0 28 28">
        <path
            d="M21.465 7.99999H8C6.974 7.99999 6.129 8.77199 6.013 9.76699L6 9.99999V16C6 17.026 6.772 17.871 7.767 17.987L8 18H10V20.669C10 20.779 10.09 20.869 10.2 20.869C10.255 20.869 10.308 20.846 10.345 20.806L12.514 18.513L14 19.999L8.853 25.145C8.658 25.34 8.341 25.34 8.146 25.145C8.052 25.051 8 24.924 8 24.791V19.998C5.791 19.998 4 18.207 4 15.998V9.99799C4 7.78899 5.791 5.99799 8 5.99799H18C19.48 5.99799 20.773 6.80199 21.465 7.99799V7.99999ZM16.722 14.585L15.308 15.999L20.123 20.814L27.815 10.892L26.215 9.69199L19.907 17.77L16.722 14.585Z"></path>
    </symbol>
    <symbol
        id="icon-ui-comments-user"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_203)">
            <path
                d="M21.465 7.99999H7.99998C6.97398 7.99999 6.12898 8.77199 6.01298 9.76699L5.99998 9.99999V16C5.99998 17.026 6.77198 17.871 7.76698 17.987L7.99998 18H9.99998V20.669C9.99998 20.779 10.09 20.869 10.2 20.869C10.255 20.869 10.308 20.846 10.345 20.806L12.514 18.513L14 19.999L8.85398 25.145C8.65898 25.34 8.34198 25.34 8.14698 25.145C8.05298 25.051 8.00098 24.924 8.00098 24.791V19.998C5.79198 19.998 4.00098 18.207 4.00098 15.998V9.99799C4.00098 7.78899 5.79198 5.99799 8.00098 5.99799H18.001C19.481 5.99799 20.774 6.80199 21.466 7.99799L21.465 7.99999ZM28 22H18V20.78C18 18.341 21.333 17 23 17C24.667 17 28 18.341 28 20.78V22ZM25.5 13C25.5 14.383 24.383 15.5 23 15.5C21.617 15.5 20.5 14.383 20.5 13C20.5 11.617 21.617 10.5 23 10.5C24.383 10.5 25.5 11.617 25.5 13Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_203">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-composition"
        viewBox="0 0 28 28">
        <path
            d="M4 26V4H26V26H4ZM6 20H24V10H6V20ZM8 8H10V6H8V8ZM14 8H16V6H14V8ZM20 8H22V6H20V8ZM8 24H10V22H8V24ZM14 24H16V22H14V24ZM20 24H22V22H20V24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-composition-new"
        viewBox="0 0 28 28">
        <path
            d="M22 20H26V22H22V26H20V22H16V20H20V16H22V20ZM26 14H24V10H6V24H14V26H4V4H26V14ZM8 8H10V6H8V8ZM14 8H16V6H14V8ZM20 8H22V6H20V8Z"></path>
    </symbol>
    <symbol
        id="icon-ui-connect"
        viewBox="0 0 28 28">
        <path
            d="M12.046 14.553L18.588 8.01103L14.344 8.00403L14.341 6.00403L22 6.01603L22.003 8.01603L22.012 13.674L20.012 13.671L20.005 9.42703L13.451 15.981C13.794 16.572 13.99 17.259 13.99 17.992C13.99 20.205 12.201 21.999 9.995 21.999C7.789 21.999 6 20.205 6 17.992C6 15.779 7.789 13.985 9.995 13.985C10.745 13.985 11.446 14.192 12.046 14.553Z"></path>
    </symbol>
    <symbol
        id="icon-ui-copy"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_211)">
            <path
                d="M24 6C26.209 6 28 7.791 28 10V24C28 26.209 26.209 28 24 28H10C7.791 28 6 26.209 6 24V10C6 7.791 7.791 6 10 6H24ZM24 8H10C8.895 8 8 8.895 8 10V24C8 25.105 8.895 26 10 26H24C25.105 26 26 25.105 26 24V10C26 8.895 25.105 8 24 8ZM18 0C20.209 0 22 1.791 22 4H20C20 2.895 19.105 2 18 2H4C2.895 2 2 2.895 2 4V18C2 19.105 2.895 20 4 20V22C1.791 22 0 20.209 0 18V4C0 1.791 1.791 0 4 0H18Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_211">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-copy-s"
        viewBox="0 0 28 28">
        <path
            d="M20 8C21.105 8 22 8.895 22 10V20C22 21.105 21.105 22 20 22H10C8.895 22 8 21.105 8 20V10C8 8.895 8.895 8 10 8H20ZM20 10H10V20H20V10ZM16 4C17.105 4 18 4.895 18 6H6V18C4.895 18 4 17.105 4 16V6C4 4.895 4.895 4 6 4H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-corner-b-l"
        viewBox="0 0 28 28">
        <path
            d="M18 21C11.925 21 7 16.075 7 10V5H23V21H18Z"
            stroke="black"
            stroke-width="2"
            fill="none"></path>
    </symbol>
    <symbol
        id="icon-ui-corner-b-r"
        viewBox="0 0 28 28">
        <path
            d="M23 10C23 16.075 18.075 21 12 21H7V5H23V10Z"
            stroke="black"
            stroke-width="2"
            fill="none"></path>
    </symbol>
    <symbol
        id="icon-ui-corner-separate"
        viewBox="0 0 28 28">
        <path
            d="M8 4H10V6H8C6.895 6 6 6.895 6 8V10H4V8C4 5.791 5.791 4 8 4ZM4 18V20C4 22.209 5.791 24 8 24H10V22H8C6.895 22 6 21.105 6 20V18H4ZM22 18V20C22 21.105 21.105 22 20 22H18V24H20C22.209 24 24 22.209 24 20V18H22ZM24 10V8C24 5.791 22.209 4 20 4H18V6H20C21.105 6 22 6.895 22 8V10H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-corner-t-l"
        viewBox="0 0 28 28">
        <path
            d="M7 16C7 9.925 11.925 5 18 5H23V21H7V16Z"
            stroke="black"
            stroke-width="2"
            fill="none"></path>
    </symbol>
    <symbol
        id="icon-ui-corner-t-r"
        viewBox="0 0 28 28">
        <path
            d="M12 5C18.075 5 23 9.925 23 16V21H7V5H12Z"
            stroke="black"
            stroke-width="2"
            fill="none"></path>
    </symbol>
    <symbol
        id="icon-ui-creative_300x60"
        viewBox="0 0 28 28">
        <path d="M26.353 11.529H1.64697V16.47H26.353V11.529Z"></path>
    </symbol>
    <symbol
        id="icon-ui-creative_600x900"
        viewBox="0 0 28 28">
        <path
            d="M21.625 2.43799H6.31201V25.501H21.625V2.43799ZM10.87 14.228C11.213 13.9 11.446 13.655 11.569 13.491C11.698 13.321 11.763 13.151 11.763 12.982C11.763 12.8 11.689 12.648 11.54 12.527C11.398 12.4 11.216 12.336 10.996 12.336C10.595 12.336 10.271 12.524 10.026 12.9L9.37601 12.545C9.59601 12.242 9.83201 12.02 10.084 11.881C10.343 11.736 10.663 11.663 11.045 11.663C11.453 11.663 11.802 11.784 12.093 12.027C12.384 12.27 12.53 12.588 12.53 12.982C12.53 13.206 12.465 13.425 12.336 13.637C12.213 13.843 11.98 14.11 11.637 14.438L10.521 15.502H12.676V16.221H9.43501V15.584L10.871 14.228H10.87ZM15.544 12.436V11.772H18.32V12.354L17.175 13.555C17.602 13.567 17.939 13.695 18.184 13.937C18.436 14.174 18.562 14.468 18.562 14.819C18.562 15.268 18.397 15.623 18.067 15.883C17.744 16.144 17.32 16.274 16.796 16.274C16.285 16.274 15.78 16.119 15.282 15.81L15.622 15.21C16.01 15.465 16.418 15.592 16.845 15.592C17.13 15.592 17.359 15.531 17.534 15.41C17.709 15.283 17.796 15.107 17.796 14.882C17.796 14.651 17.696 14.469 17.495 14.336C17.294 14.203 17.019 14.136 16.67 14.136C16.502 14.136 16.334 14.16 16.165 14.209V13.636L17.262 12.435L15.544 12.436ZM13.969 12.432H14.735V13.201H13.969V12.432ZM13.969 13.969H14.735V14.738H13.969V13.969Z"></path>
    </symbol>
    <symbol
        id="icon-ui-creative_1080x1080"
        viewBox="0 0 28 28">
        <path
            d="M22.2349 5.76501H5.76392V22.236H22.2349V5.76501ZM10.7059 11.529H11.5299V16.47H10.7059V12.693L10.1239 13.275L9.54192 12.693L10.7069 11.528L10.7059 11.529ZM16.4709 11.529H17.2949V16.47H16.4709V12.693L15.8889 13.275L15.3069 12.693L16.4719 11.528L16.4709 11.529ZM13.1759 13.176H13.9999V14H13.1759V13.176ZM13.1759 14.824H13.9999V15.648H13.1759V14.824Z"></path>
    </symbol>
    <symbol
        id="icon-ui-creative_1080x1350"
        viewBox="0 0 28 28">
        <path d="M11.5291 14.824V12.706L10.0471 14.824H11.5291Z"></path>
        <path
            d="M5.76489 4.11798H22.2359V24.706H5.76489V4.11798ZM12.3529 14.824V11.53H11.5289L9.05789 14.824L9.46989 15.648H11.5289V16.472H12.3529V15.648H13.1769V14.824H12.3529ZM14.8239 14.824H13.9999V15.648H14.8239V14.824ZM18.5289 11.529H15.6469V14H17.2939C17.7489 14 18.1179 14.369 18.1179 14.824C18.1179 15.279 17.7489 15.648 17.2939 15.648H15.6469V16.472H17.2939C18.2039 16.472 18.9409 15.735 18.9409 14.825C18.9409 13.915 18.2039 13.178 17.2939 13.178H16.4699V12.354H18.5289V11.529ZM14.8239 13.176H13.9999V14H14.8239V13.176Z"></path>
    </symbol>
    <symbol
        id="icon-ui-creative_1080x1920"
        viewBox="0 0 28 28">
        <path
            d="M14.824 8.23501C14.824 8.69001 14.455 9.05901 14 9.05901C13.545 9.05901 13.176 8.69001 13.176 8.23501C13.176 7.78001 13.545 7.41101 14 7.41101C14.455 7.41101 14.824 7.78001 14.824 8.23501Z"></path>
        <path
            d="M15.647 18.118C15.192 18.118 14.823 18.487 14.823 18.942C14.823 19.397 15.192 19.766 15.647 19.766C16.102 19.766 16.471 19.397 16.471 18.942C16.471 18.487 16.102 18.118 15.647 18.118Z"></path>
        <path
            d="M20.5881 2.47101H7.41211V25.53H20.5881V2.47101ZM15.6471 8.23501C15.6471 8.53501 15.5671 8.81601 15.4271 9.05901L14.0001 11.53H13.1761L14.0001 9.88301C13.0901 9.88301 12.3531 9.14601 12.3531 8.23601C12.3531 7.32601 13.0901 6.58901 14.0001 6.58901C14.9101 6.58901 15.6471 7.32601 15.6471 8.23601V8.23501ZM11.1881 16.812L12.3531 15.647H13.1771V20.588H12.3531V16.811L11.7711 17.393L11.1891 16.811L11.1881 16.812ZM14.2201 18.118L15.6471 15.647H16.4711L15.6471 17.294C16.5571 17.294 17.2941 18.031 17.2941 18.941C17.2941 19.851 16.5571 20.588 15.6471 20.588C14.7371 20.588 14.0001 19.851 14.0001 18.941C14.0001 18.641 14.0801 18.361 14.2201 18.118ZM11.5291 13.176H16.4701V14H11.5291V13.176Z"></path>
    </symbol>
    <symbol
        id="icon-ui-creative_1200x628"
        viewBox="0 0 28 28">
        <path
            d="M12.3531 14C12.8081 14 13.1771 13.631 13.1771 13.176C13.1771 12.721 12.8081 12.352 12.3531 12.352C11.8981 12.352 11.5291 12.721 11.5291 13.176C11.5291 13.631 11.8981 14 12.3531 14Z"></path>
        <path
            d="M25.529 8.23499V19.764H2.46997V8.23499H25.529ZM7.41197 11.529H6.58797L5.42297 12.694L6.00497 13.276L6.58697 12.694V16.471H7.41097V11.53L7.41197 11.529ZM20.247 12.694L20.829 13.276L21.411 12.694V16.471H22.235V11.53H21.411L20.246 12.695L20.247 12.694ZM18.941 13.176H18.117V14H18.941V13.176ZM18.941 14.824H18.117V15.648H18.941V14.824ZM9.05897 15.647V16.471H9.88297V15.647H9.05897ZM13.78 14C13.92 13.758 14 13.476 14 13.176C14 12.266 13.263 11.529 12.353 11.529C11.443 11.529 10.706 12.266 10.706 13.176C10.706 14.086 11.443 14.823 12.353 14.823L11.529 16.47H12.353L13.78 13.999V14ZM15.647 11.529L14.482 12.694L15.064 13.276L15.646 12.694V16.471H16.47V11.53H15.646L15.647 11.529Z"></path>
    </symbol>
    <symbol
        id="icon-ui-creative_1920x1080"
        viewBox="0 0 28 28">
        <path
            d="M10.7061 14.824C10.7061 14.369 11.0751 14 11.5301 14C11.9851 14 12.3541 14.369 12.3541 14.824C12.3541 15.279 11.9851 15.648 11.5301 15.648C11.0751 15.648 10.7061 15.279 10.7061 14.824Z"></path>
        <path
            d="M19.7649 13.176C19.7649 13.631 19.3959 14 18.9409 14C18.4859 14 18.1169 13.631 18.1169 13.176C18.1169 12.721 18.4859 12.352 18.9409 12.352C19.3959 12.352 19.7649 12.721 19.7649 13.176Z"></path>
        <path
            d="M25.529 7.41199H2.46997V20.588H25.529V7.41199ZM9.88197 14.824C9.88197 14.524 9.96197 14.243 10.102 14L11.529 11.529H12.353L11.529 13.176C12.439 13.176 13.176 13.913 13.176 14.823C13.176 15.733 12.439 16.47 11.529 16.47C10.619 16.47 9.88197 15.733 9.88197 14.823V14.824ZM7.41197 11.529H8.23597V16.47H7.41197V12.693L6.82997 13.275L6.24797 12.693L7.41297 11.528L7.41197 11.529ZM20.588 13.176C20.588 13.476 20.508 13.757 20.368 14L18.941 16.471H18.117L18.941 14.824C18.031 14.824 17.294 14.087 17.294 13.177C17.294 12.267 18.031 11.53 18.941 11.53C19.851 11.53 20.588 12.267 20.588 13.177V13.176ZM15.647 12.353V13.177H14.823V12.353H15.647ZM15.647 14V14.824H14.823V14H15.647Z"></path>
    </symbol>
    <symbol
        id="icon-ui-creative-set"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_245)">
            <path
                d="M1.4 0C0.627 0 0 0.627 0 1.4V15.4C0 16.173 0.627 16.8 1.4 16.8H11.2C11.973 16.8 12.6 16.173 12.6 15.4V1.4C12.6 0.627 11.973 0 11.2 0L1.4 0ZM16.8 11.2C16.027 11.2 15.4 11.827 15.4 12.6V26.6C15.4 27.373 16.027 28 16.8 28H26.6C27.373 28 28 27.373 28 26.6V12.6C28 11.827 27.373 11.2 26.6 11.2H16.8ZM15.4 1.4C15.4 0.627 16.027 0 16.8 0H26.6C27.373 0 28 0.627 28 1.4V7C28 7.773 27.373 8.4 26.6 8.4H16.8C16.027 8.4 15.4 7.773 15.4 7V1.4ZM1.4 19.6C0.627 19.6 0 20.227 0 21V26.6C0 27.373 0.627 28 1.4 28H11.2C11.973 28 12.6 27.373 12.6 26.6V21C12.6 20.227 11.973 19.6 11.2 19.6H1.4Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_245">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-creative-set-new-s"
        viewBox="0 0 28 28">
        <path
            d="M24 18V22H28V24H24V28H22V24H18V22H22V18H24ZM7 12C7.552 12 8 12.448 8 13V17C8 17.552 7.552 18 7 18H3C2.448 18 2 17.552 2 17V13C2 12.448 2.448 12 3 12H7ZM17 10C17.552 10 18 10.448 18 11V17C18 17.552 17.552 18 17 18H11C10.448 18 10 17.552 10 17V11C10 10.448 10.448 10 11 10H17ZM7 2C7.552 2 8 2.448 8 3V9C8 9.552 7.552 10 7 10H3C2.448 10 2 9.552 2 9V3C2 2.448 2.448 2 3 2H7ZM17 2C17.552 2 18 2.448 18 3V7C18 7.552 17.552 8 17 8H11C10.448 8 10 7.552 10 7V3C10 2.448 10.448 2 11 2H17Z"></path>
    </symbol>
    <symbol
        id="icon-ui-cross-small"
        viewBox="0 0 28 28">
        <path
            d="M16.414 15L22.071 20.657L20.657 22.071L15 16.414L9.34296 22.071L7.92896 20.657L13.586 15L7.92896 9.34302L9.34296 7.92902L15 13.586L20.657 7.92902L22.071 9.34302L16.414 15Z"></path>
    </symbol>
    <symbol
        id="icon-ui-crown"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_251)">
            <path
                d="M15.096 5.673C15.64 5.316 16 4.7 16 4C16 2.895 15.105 2 14 2C12.895 2 12 2.895 12 4C12 4.7 12.359 5.316 12.904 5.673C11.316 8.018 8.413 12 7 12C5.84 12 4.345 10.656 3.293 9.526C3.726 9.159 4 8.612 4 8C4 6.895 3.105 6 2 6C0.895 6 0 6.895 0 8C0 9.105 0.895 10 2 10C2.122 10 2.242 9.989 2.358 9.968L3.926 18.589C3.969 18.827 4.176 19 4.418 19H23.584C23.826 19 24.033 18.827 24.076 18.589L25.644 9.968C25.76 9.989 25.88 10 26.002 10C27.107 10 28.002 9.105 28.002 8C28.002 6.895 27.107 6 26.002 6C24.897 6 24.002 6.895 24.002 8C24.002 8.612 24.277 9.16 24.71 9.527C23.659 10.657 22.164 12 21.002 12C19.587 12 16.685 8.019 15.098 5.673H15.096ZM4 20.5C4 20.224 4.224 20 4.5 20H23.5C23.776 20 24 20.224 24 20.5V23.5C24 23.776 23.776 24 23.5 24H4.5C4.224 24 4 23.776 4 23.5V20.5Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_251">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-cs-choices"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_253)">
            <path
                d="M1.4 0C0.627 0 0 0.627 0 1.4V12.6C0 13.373 0.627 14 1.4 14H9.8C10.573 14 11.2 13.373 11.2 12.6V1.4C11.2 0.627 10.573 0 9.8 0L1.4 0ZM16.8 1.4C16.8 0.627 17.427 0 18.2 0H26.6C27.373 0 28 0.627 28 1.4V7C28 7.773 27.373 8.4 26.6 8.4H18.2C17.427 8.4 16.8 7.773 16.8 7V1.4ZM0 21C0 20.227 0.627 19.6 1.4 19.6H9.8C10.573 19.6 11.2 20.227 11.2 21V26.6C11.2 27.373 10.573 28 9.8 28H1.4C0.627 28 0 27.373 0 26.6L0 21ZM18.2 16.771C18.25 14.298 19.695 12.88 22.782 12.88C25.658 12.88 27.558 14.479 27.558 16.771C27.558 18.289 26.824 19.345 25.406 20.18C24.069 20.954 23.8 21.415 23.8 22.4H21.033C21 21 21.435 19.898 22.823 19.084C24.12 18.31 24.512 17.817 24.512 16.862C24.512 15.907 23.748 15.213 22.602 15.213C21.446 15.213 21.094 15.635 21.033 16.771H18.2ZM22.4 28C21.495 28 20.761 27.306 20.761 26.421C20.761 25.536 21.495 24.842 22.4 24.842C23.315 24.842 24.049 25.536 24.049 26.421C24.049 27.306 23.315 28 22.4 28Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_253">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-ctr"
        viewBox="0 0 28 28">
        <path d="M6 12H12V14H6V12ZM18 12H24V14H18V12ZM14 4H16V10H14V4ZM14 16H16V22H14V16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-customized"
        viewBox="0 0 28 28">
        <path
            d="M12.0001 4H16.0001V9.536L20.7941 6.768L22.7941 10.232L18.0001 13L22.7941 15.768L20.7941 19.232L16.0001 16.464V22H12.0001V16.464L7.20605 19.232L5.20605 15.768L10.0001 13L5.20605 10.232L7.20605 6.768L12.0001 9.536V4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-de-action"
        viewBox="0 0 28 28">
        <path d="M14.571 12L16 2L8 16H13.429L12 26L20 12H14.571Z"></path>
    </symbol>
    <symbol
        id="icon-ui-decision-tree"
        viewBox="0 0 28 28">
        <path
            d="M23 6C24.657 6 26 7.343 26 9C26 10.657 24.657 12 23 12C21.694 12 20.583 11.166 20.171 10.001L19.42 10C17.437 10 16.407 10.551 14.589 12.331L13.823 13.093C12.975 13.923 12.241 14.547 11.505 15C12.24 15.451 12.975 16.075 13.823 16.905L14.215 17.295C16.275 19.372 17.306 19.999 19.421 19.999L20.172 20C20.584 18.834 21.695 17.999 23.002 17.999C24.659 17.999 26.002 19.342 26.002 20.999C26.002 22.656 24.659 23.999 23.002 23.999C21.696 23.999 20.585 23.165 20.173 22L19.422 21.999C16.79 21.999 15.362 21.22 13.188 19.093L12.796 18.703C10.736 16.626 9.70495 15.999 7.58995 15.999H3.00195C2.44995 15.999 2.00195 15.551 2.00195 14.999C2.00195 14.447 2.44995 13.999 3.00195 13.999H7.58995C9.57295 13.999 10.603 13.448 12.421 11.668L13.187 10.906C15.233 8.904 16.618 8.096 18.969 8.008L19.421 8L20.172 8.001C20.584 6.836 21.695 6 23.002 6H23Z"></path>
    </symbol>
    <symbol
        id="icon-ui-degrees"
        viewBox="0 0 28 28">
        <path
            d="M19 12C20.657 12 22 10.657 22 9C22 7.343 20.657 6 19 6C17.343 6 16 7.343 16 9C16 10.657 17.343 12 19 12ZM19 14C16.239 14 14 11.761 14 9C14 6.239 16.239 4 19 4C21.761 4 24 6.239 24 9C24 11.761 21.761 14 19 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-delete"
        viewBox="0 0 28 28">
        <path
            d="M8 8V22H22V8H8ZM10 6V2H20V6H26V8H24V24H6V8H4V6H10ZM12 4V6H18V4H12ZM10 10H12V20H10V10ZM18 10H20V20H18V10ZM14 10H16V20H14V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-delete-lar"
        viewBox="0 0 28 28">
        <path
            d="M6 8V26H24V8H6ZM4 6H26V26C26 27.105 25.105 28 24 28H6C4.895 28 4 27.105 4 26V6ZM8 6V4C8 2.895 8.895 2 10 2H20C21.105 2 22 2.895 22 4V6H28V8H2V6H8ZM10 4V6H20V4H10ZM10 12H12V22H10V12ZM18 12H20V22H18V12ZM14 12H16V22H14V12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-de-reserved-action"
        viewBox="0 0 28 28">
        <path
            d="M10.571 12L12 2L4 16H9.429L8 26L14 15.5V12H10.571ZM18 12H21C21.552 12 22 12.448 22 13C22 13.552 21.552 14 21 14H18V12ZM18 16H19.6L22 20H24L21.568 15.946C22.953 15.681 24 14.462 24 13C24 11.343 22.657 10 21 10H16V20H18V16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-direction_ltr"
        viewBox="0 0 28 28">
        <path d="M4 8L10 14L4 20V8Z"></path>
        <path
            d="M14.464 7.464C15.402 6.526 16.673 6 18 6H26V8H24V22H22V8H20V22H18V16C16.674 16 15.402 15.473 14.464 14.536C13.526 13.599 13 12.327 13 11C13 9.674 13.527 8.402 14.464 7.464Z"></path>
    </symbol>
    <symbol
        id="icon-ui-direction_rtl"
        viewBox="0 0 28 28">
        <path d="M24 8L18 14L24 20V8Z"></path>
        <path
            d="M4.464 7.464C5.402 6.526 6.673 6 8 6H16V8H14V22H12V8H10V22H8V16C6.674 16 5.402 15.473 4.464 14.536C3.526 13.599 3 12.327 3 11C3 9.674 3.527 8.402 4.464 7.464Z"></path>
    </symbol>
    <symbol
        id="icon-ui-direction-down"
        viewBox="0 0 28 28">
        <path
            d="M16 16.553V8H14V16.552L11.224 13.776L10 15L15.001 20.001L20 15L18.776 13.776L16 16.553Z"></path>
    </symbol>
    <symbol
        id="icon-ui-direction-left"
        viewBox="0 0 28 28">
        <path
            d="M11.447 16H20V14H11.448L14.224 11.224L13 10L7.99902 15.001L13 20L14.224 18.776L11.447 16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-direction-right"
        viewBox="0 0 28 28">
        <path
            d="M16.553 16H8V14H16.552L13.776 11.224L15 10L20.001 15.001L15 20L13.776 18.776L16.553 16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-direction-up"
        viewBox="0 0 28 28">
        <path
            d="M16 11.447V20H14V11.448L11.224 14.224L10 13L15.001 7.99899L20 13L18.776 14.224L16 11.447Z"></path>
    </symbol>
    <symbol
        id="icon-ui-disabled"
        viewBox="0 0 28 28">
        <path
            d="M14 4C19.523 4 24 8.477 24 14C24 19.523 19.523 24 14 24C8.477 24 4 19.523 4 14C4 8.477 8.477 4 14 4ZM20.321 9.096L9.096 20.321C10.45 21.374 12.152 22 14 22C18.418 22 22 18.418 22 14C22 12.152 21.373 10.45 20.321 9.096ZM14 6C9.582 6 6 9.582 6 14C6 15.849 6.627 17.552 7.681 18.906L18.907 7.68C17.552 6.627 15.85 5.999 14.001 5.999L14 6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-discard-changes"
        viewBox="0 0 28 28">
        <path
            d="M26 15C26 21.075 21.075 26 15 26C10.355 26 6.38195 23.121 4.76995 19.05L6.58695 18.203C7.87795 21.592 11.158 24 15.001 24C19.972 24 24.001 19.971 24.001 15C24.001 10.029 19.972 6 15.001 6C12.18 6 9.66295 7.298 8.01295 9.328L10.655 11.52L4.00195 12.585V6L6.47395 8.051C8.49095 5.579 11.562 4 15.002 4C21.077 4 26.002 8.925 26.002 15H26Z"></path>
    </symbol>
    <symbol
        id="icon-ui-display-campaign"
        viewBox="0 0 28 28">
        <path
            d="M22 8V18H6V8H22ZM16 20H22C23.105 20 24 19.105 24 18V8C24 6.895 23.105 6 22 6H6C4.895 6 4 6.895 4 8V18C4 19.105 4.895 20 6 20H12V22H8V24H20V22H16V20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-distribute-canvas-horisontally"
        viewBox="0 0 28 28">
        <path d="M26 6V26H4V4H26V6ZM24 6H6V24H24V6ZM8 12H14V18H8V12ZM16 12H22V18H16V12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-distribute-canvas-vertically"
        viewBox="0 0 28 28">
        <path d="M24 26H4V4H26V26H24ZM24 24V6H6V24H24ZM18 8V14H12V8H18ZM18 16V22H12V16H18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-distribute-horisontally"
        viewBox="0 0 28 28">
        <path d="M4 4H6V26H4V4ZM24 4H26V26H24V4ZM10 10H20V20H10V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-distribute-vertically"
        viewBox="0 0 28 28">
        <path d="M26 4V6H4V4H26ZM26 24V26H4V24H26ZM20 10V20H10V10H20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-download"
        viewBox="0 0 28 28">
        <path
            d="M16 16.385L20.728 11.657L22.142 13.071L15.071 20.142L8 13.071L9.414 11.657L14 16.243V2H16V16.385ZM2 24H28V26H2V24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-drag-drop"
        viewBox="0 0 28 28">
        <path
            d="M14 26L9.359 21.359L10.846 19.872L12.949 21.975V15.051H6.025L8.128 17.154L6.641 18.641L2 14L6.641 9.359L8.128 10.846L6.025 12.949H12.949V6.025L10.846 8.128L9.359 6.641L14 2L18.641 6.641L17.154 8.128L15.051 6.025V12.949H21.975L19.872 10.846L21.359 9.359L26 14L21.359 18.641L19.872 17.154L21.975 15.051H15.051V21.975L17.154 19.872L18.641 21.359L14 26Z"></path>
    </symbol>
    <symbol
        id="icon-ui-dropdown-tiny-triangle"
        viewBox="0 0 28 28">
        <path d="M15 18L10 12H20L15 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-duplicate-s"
        viewBox="0 0 28 28">
        <path
            d="M20 14V18H24V20H20V24H18V20H14V18H18V14H20ZM20 8C21.105 8 22 8.895 22 10V12H20V10H10V20H12V22H10C8.895 22 8 21.105 8 20V10C8 8.895 8.895 8 10 8H20ZM16 4C17.105 4 18 4.895 18 6H6V18C4.895 18 4 17.105 4 16V6C4 4.895 4.895 4 6 4H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-dynamic-feed"
        viewBox="0 0 28 28">
        <path
            d="M4.333 25C3.691 25 3.142 24.772 2.686 24.315C2.23 23.858 2.001 23.309 2 22.666V14.499H4.333V22.666H14.833V24.999L4.333 25ZM9 20.333C8.358 20.333 7.809 20.105 7.353 19.648C6.897 19.191 6.668 18.642 6.667 18V9.833H9V18H19.5V20.333H9ZM13.667 15.667C13.025 15.667 12.476 15.439 12.02 14.982C11.564 14.525 11.335 13.976 11.334 13.333V6.333C11.334 5.691 11.563 5.142 12.02 4.686C12.477 4.23 13.026 4.001 13.667 4H23C23.642 4 24.191 4.229 24.648 4.686C25.105 5.143 25.334 5.692 25.333 6.333V13.333C25.333 13.975 25.105 14.524 24.648 14.982C24.191 15.44 23.642 15.668 23 15.667H13.667ZM13.667 13.333H23V8.666H13.667V13.333Z"></path>
    </symbol>
    <symbol
        id="icon-ui-edit"
        viewBox="0 0 28 28">
        <path
            d="M4 20L14 10L18 14L8 24H4V20ZM20 12L16 8L18.586 5.414C19.367 4.633 20.633 4.633 21.414 5.414L22.586 6.586C23.367 7.367 23.367 8.633 22.586 9.414L20 12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-error"
        viewBox="0 0 24 24">
        <path
            d="M11.9999 20.016C14.1872 20.016 16.0699 19.227 17.6479 17.649C19.2259 16.071 20.0149 14.1883 20.0149 12.001C20.0149 9.81366 19.2259 7.93099 17.6479 6.35299C16.0699 4.77499 14.1872 3.98599 11.9999 3.98599C9.81256 3.98599 7.92989 4.77499 6.35189 6.35299C4.77389 7.93099 3.98489 9.81366 3.98489 12.001C3.98489 14.1883 4.77389 16.071 6.35189 17.649C7.92989 19.227 9.81256 20.016 11.9999 20.016ZM11.9999 2.01599C14.7499 2.01599 17.1016 2.99266 19.0549 4.94599C21.0082 6.89932 21.9849 9.25099 21.9849 12.001C21.9849 14.751 21.0082 17.1027 19.0549 19.056C17.1016 21.0093 14.7499 21.986 11.9999 21.986C9.24989 21.986 6.89823 21.0093 4.94489 19.056C2.99156 17.1027 2.01489 14.751 2.01489 12.001C2.01489 9.25099 2.99156 6.89932 4.94489 4.94599C6.89823 2.99266 9.24989 2.01599 11.9999 2.01599ZM11.0159 6.98399H12.9849V12.984H11.0159V6.98399ZM11.0159 15H12.9849V17.016H11.0159V15Z"></path>
    </symbol>
    <symbol
        id="icon-ui-error-l-negative"
        viewBox="0 0 28 28">
        <path
            d="M14 26C7.373 26 2 20.627 2 14C2 7.373 7.373 2 14 2C20.627 2 26 7.373 26 14C26 20.627 20.627 26 14 26ZM14 6C12.895 6 12 6.895 12 8V14C12 15.105 12.895 16 14 16C15.105 16 16 15.105 16 14V8C16 6.895 15.105 6 14 6ZM14 18C12.895 18 12 18.895 12 20C12 21.105 12.895 22 14 22C15.105 22 16 21.105 16 20C16 18.895 15.105 18 14 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-error-l-negative1"
        viewBox="0 0 28 28">
        <path
            d="M14 26C7.373 26 2 20.627 2 14C2 7.373 7.373 2 14 2C20.627 2 26 7.373 26 14C26 20.627 20.627 26 14 26ZM14 6C12.895 6 12 6.895 12 8V14C12 15.105 12.895 16 14 16C15.105 16 16 15.105 16 14V8C16 6.895 15.105 6 14 6ZM14 18C12.895 18 12 18.895 12 20C12 21.105 12.895 22 14 22C15.105 22 16 21.105 16 20C16 18.895 15.105 18 14 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-exclamation_mark"
        viewBox="0 0 28 28">
        <path
            d="M12 4C12 2.895 12.895 2 14 2C15.105 2 16 2.895 16 4V18C16 19.105 15.105 20 14 20C12.895 20 12 19.105 12 18V4Z"></path>
        <path
            d="M16 24C16 25.105 15.105 26 14 26C12.895 26 12 25.105 12 24C12 22.895 12.895 22 14 22C15.105 22 16 22.895 16 24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-expand"
        viewBox="0 0 28 28">
        <path
            d="M12.867 4.15001C13.196 3.82101 13.728 3.82101 14.057 4.15001L19.946 10.039C20.275 10.368 20.275 10.9 19.946 11.229C19.617 11.558 19.085 11.558 18.756 11.229L13.462 5.93501L8.16797 11.229C7.83897 11.558 7.30697 11.558 6.97797 11.229C6.64897 10.9 6.64897 10.368 6.97797 10.039L12.867 4.15001ZM6.97697 16.77C7.30597 16.441 7.83797 16.441 8.16697 16.77L13.461 22.064L18.755 16.77C19.084 16.441 19.616 16.441 19.945 16.77C20.274 17.099 20.274 17.631 19.945 17.96L14.056 23.849C13.727 24.178 13.195 24.178 12.866 23.849L6.97697 17.96C6.64797 17.631 6.64797 17.099 6.97697 16.77Z"></path>
    </symbol>
    <symbol
        id="icon-ui-export"
        viewBox="0 0 28 28">
        <path
            d="M16 8.828V18H14V8.829L10.636 12.193L9.222 10.779L15.001 5L20.778 10.779L19.364 12.193L16 8.828ZM24 22V24H6V22H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-facebook"
        viewBox="0 0 28 28">
        <path
            d="M16 25.834C21.675 24.882 26 19.946 26 14C26 7.373 20.627 2 14 2C7.373 2 2 7.373 2 14C2 19.946 6.325 24.882 12 25.834V18H9V14H12V12C12 4 20 7 20 7V10H18C16.895 10 16 10.895 16 12V14H20L19 18H16V25.834Z"></path>
    </symbol>
    <symbol
        id="icon-ui-fallback"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_326)">
            <path
                d="M0 3V9C0 10.657 1.343 12 3 12H9C10.657 12 12 10.657 12 9V3C12 1.343 10.657 0 9 0H3C1.343 0 0 1.343 0 3ZM3 2H9C9.552 2 10 2.448 10 3V9C10 9.552 9.552 10 9 10H3C2.448 10 2 9.552 2 9V3C2 2.448 2.448 2 3 2Z"></path>
            <path
                d="M3 16C1.343 16 0 17.343 0 19V25C0 26.657 1.343 28 3 28H9C10.657 28 12 26.657 12 25V19C12 17.343 10.657 16 9 16H3Z"></path>
            <path
                d="M20 20V16L14 21L20 26V22H22C25.314 22 28 19.314 28 16V12C28 8.686 25.314 6 22 6H16V8H22C24.209 8 26 9.791 26 12V16C26 18.209 24.209 20 22 20H20Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_326">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-fallback-cs"
        viewBox="0 0 28 28">
        <path
            d="M5 4C4.448 4 4 4.448 4 5V13C4 13.552 4.448 14 5 14H11C11.552 14 12 13.552 12 13V5C12 4.448 11.552 4 11 4H5Z"></path>
        <path
            d="M24 21L23.986 21.288C23.85 22.714 22.715 23.849 21.289 23.985L21 23.999L16 24V26L21 25.999L21.329 25.988C23.828 25.826 25.827 23.827 25.99 21.327L26.001 20.998C26 18.348 23.937 16.18 21.33 16.011L21.001 16H20.001V12.999L14.001 16.999L20.001 20.999V18H21.001C22.658 18 24.001 19.342 24.001 20.999L24 21Z"></path>
        <path
            d="M16 5C16 4.448 16.448 4 17 4H23C23.552 4 24 4.448 24 5V9C24 9.552 23.552 10 23 10H17C16.448 10 16 9.552 16 9V5Z"></path>
        <path
            d="M5 18C4.448 18 4 18.448 4 19V23C4 23.552 4.448 24 5 24H11C11.552 24 12 23.552 12 23V19C12 18.448 11.552 18 11 18H5Z"></path>
    </symbol>
    <symbol
        id="icon-ui-fallback-default"
        viewBox="0 0 28 28">
        <path
            d="M11 16C11.552 16 12 16.358 12 16.8V23.2C12 23.642 11.552 24 11 24H5C4.448 24 4 23.642 4 23.2V16.8C4 16.358 4.448 16 5 16H11ZM21 8.001L21.329 8.012C23.828 8.174 25.827 10.173 25.99 12.673L26.001 13.002V15C26.001 17.651 23.938 19.82 21.33 19.989L21.001 20L20.001 19.999V23.001L14.001 19.001L20.001 15.001V17.999L21.001 18C22.658 18 24.001 16.657 24.001 15V13.001L23.987 12.713C23.851 11.287 22.716 10.152 21.29 10.016L21.001 10.002L14.001 10.001V8.001L21.001 8.002L21 8.001ZM11 4C11.552 4 12 4.358 12 4.8V11.2C12 11.642 11.552 12 11 12H5C4.448 12 4 11.642 4 11.2V4.8C4 4.358 4.448 4 5 4H11ZM10 6H6V10H10V6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-fallback-missing"
        viewBox="0 0 28 28">
        <path
            d="M9 18C9.552 18 10 18.448 10 19V21C10 21.552 9.552 22 9 22H7C6.448 22 6 21.552 6 21V19C6 18.448 6.448 18 7 18H9ZM21 7.999C23.761 7.999 26 10.238 26 12.999C26 15.65 23.937 17.819 21.329 17.988L21 17.999H20V21L14 17L20 13V15.999H21C22.657 15.999 24 14.656 24 12.999C24 11.44 22.81 10.158 21.289 10.013L21 9.999L14 10V8L21 7.999ZM9 6C9.552 6 10 6.448 10 7V15C10 15.552 9.552 16 9 16H7C6.448 16 6 15.552 6 15V7C6 6.448 6.448 6 7 6H9Z"></path>
    </symbol>
    <symbol
        id="icon-ui-fallback-warning"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_339)">
            <path
                d="M14 26.6C7.041 26.6 1.4 20.959 1.4 14C1.4 7.041 7.041 1.4 14 1.4C20.959 1.4 26.6 7.041 26.6 14C26.6 20.959 20.959 26.6 14 26.6ZM14 28C21.732 28 28 21.732 28 14C28 6.268 21.732 0 14 0C6.268 0 0 6.268 0 14C0 21.732 6.268 28 14 28ZM11.2 5.6C10.169 5.6 9.333 6.436 9.333 7.467V14.934C9.333 15.965 10.169 16.801 11.2 16.801C12.231 16.801 13.067 15.965 13.067 14.934V7.467C13.067 6.436 12.231 5.6 11.2 5.6ZM11.2 22.4C12.231 22.4 13.067 21.564 13.067 20.533C13.067 19.502 12.231 18.666 11.2 18.666C10.169 18.666 9.333 19.502 9.333 20.533C9.333 21.564 10.169 22.4 11.2 22.4ZM21.156 12.444L21.147 12.265C21.062 11.378 20.356 10.671 19.469 10.587L19.289 10.578L14.933 10.577V9.333L19.289 9.334L19.494 9.341C21.049 9.442 22.293 10.686 22.394 12.241L22.401 12.446V13.689C22.401 15.338 21.117 16.688 19.494 16.793L19.289 16.8H18.667V18.667L14.934 16.178L18.667 13.689V15.555H19.289C20.32 15.555 21.156 14.719 21.156 13.688V12.444Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_339">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-feed"
        viewBox="0 0 28 28">
        <path
            d="M24 22H20C20 14.268 13.732 8 6 8V4C15.941 4 24 12.059 24 22ZM16 22H12C12 18.686 9.314 16 6 16V12C11.523 12 16 16.477 16 22ZM6 24C4.895 24 4 23.105 4 22C4 20.895 4.895 20 6 20C7.105 20 8 20.895 8 22C8 23.105 7.105 24 6 24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-feeds"
        viewBox="0 0 28 28">
        <path
            d="M8 8C14.627 8 20 13.373 20 20H23C23 11.716 16.284 5 8 5V8ZM8 11C12.971 11 17 15.029 17 20H14C14 16.686 11.314 14 8 14V11ZM10 19.971C10 21.076 9.105 21.971 8 21.971C6.895 21.971 6 21.076 6 19.971C6 18.866 6.895 17.971 8 17.971C9.105 17.971 10 18.866 10 19.971Z"></path>
    </symbol>
    <symbol
        id="icon-ui-files"
        viewBox="0 0 28 28">
        <path d="M16 6H8V22H20V10H16V6ZM6 4H17L22 9V24H6V4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-file-size"
        viewBox="0 0 28 28">
        <path
            d="M13.566 20H10.7L7.133 14.566L6 15.51V20H4V7.99999H6V13.455C6.539 12.798 6.845 12.441 7.378 11.833L10.634 7.99999H13.442C11.337 10.462 9.763 12.223 8.783 13.261L13.566 20ZM16 7.99999H19.52C21.153 7.99999 22.333 8.24099 23.06 8.72199C23.787 9.20299 24.151 9.96399 24.151 11.004C24.151 11.704 23.973 12.287 23.616 12.752C23.259 13.217 22.745 13.51 22.075 13.63V13.712C22.908 13.871 23.52 14.184 23.912 14.652C24.304 15.12 24.5 15.753 24.5 16.552C24.5 17.63 24.128 18.474 23.385 19.084C22.642 19.694 21.607 19.999 20.283 19.999H16.001V7.99899L16 7.99999ZM18 12.756H19.797C20.578 12.756 21.149 12.638 21.508 12.403C21.867 12.168 22.047 11.768 22.047 11.204C22.047 10.694 21.853 10.325 21.465 10.098C21.077 9.87099 20.461 9.75599 19.617 9.75599H18V12.756ZM18 14.812V17.992H19.984C20.765 17.992 21.355 17.86 21.754 17.597C22.153 17.334 22.352 16.918 22.352 16.35C22.352 15.828 22.149 15.441 21.743 15.189C21.337 14.937 20.72 14.811 19.891 14.811H18V14.812Z"></path>
    </symbol>
    <symbol
        id="icon-ui-filter"
        viewBox="0 0 28 28">
        <path d="M4 8H24V10H4V8ZM8 14H20V16H8V14ZM12 20H16V22H12V20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-filter-2"
        viewBox="0 0 28 28">
        <path
            d="M14.002 21.333L12.002 20V15.414L6.29496 9.707C5.66496 9.077 6.11096 8 7.00196 8H23.002C23.893 8 24.339 9.077 23.709 9.707L18.002 15.414V24L16.002 22.667V15C16.002 14.735 16.107 14.48 16.295 14.293L20.588 10H9.41596L13.709 14.293C13.897 14.481 14.002 14.735 14.002 15V21.333Z"></path>
    </symbol>
    <symbol
        id="icon-ui-filter-blur"
        viewBox="0 0 28 28">
        <path
            d="M22 16.667C22 20.717 18.418 24 14 24C9.582 24 6 20.717 6 16.667C6 13.046 10.263 8.08399 13.072 3.57999C13.491 2.90799 14.509 2.90799 14.928 3.57999C17.737 8.08399 22 13.046 22 16.667Z"></path>
    </symbol>
    <symbol
        id="icon-ui-filter-clear"
        viewBox="0 0 28 28">
        <path
            d="M6.586 8.00001L4.454 5.86801L5.868 4.45401L23.546 22.132L22.132 23.546L14.586 16H8V14H12.586L8.586 10H4V8.00001H6.586ZM12.821 8.00001H24V10H14.821L12.821 8.00001ZM18.821 14H20V15.179L18.821 14ZM12 20H16V22H12V20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-filter-contrast"
        viewBox="0 0 28 28">
        <path
            d="M14 24C19.523 24 24 19.523 24 14C24 8.477 19.523 4 14 4C8.477 4 4 8.477 4 14C4 19.523 8.477 24 14 24ZM8.343 8.343C9.843 6.843 11.878 6 14 6V22C11.878 22 9.843 21.157 8.343 19.657C6.843 18.157 6 16.122 6 14C6 11.878 6.843 9.843 8.343 8.343Z"></path>
    </symbol>
    <symbol
        id="icon-ui-filter-grayscale"
        viewBox="0 0 28 28">
        <path
            d="M24 14C24 19.523 19.523 24 14 24C8.477 24 4 19.523 4 14C4 8.477 8.477 4 14 4C19.523 4 24 8.477 24 14ZM8.708 20C9.369 20.583 10.122 21.053 10.938 21.391C11.909 21.793 12.949 22 13.999 22C15.049 22 16.09 21.793 17.06 21.391C18.031 20.989 18.913 20.4 19.655 19.657C19.773 19.539 19.888 19.417 19.998 19.292V18.001H20.926C21.1 17.699 21.255 17.386 21.389 17.062C21.532 16.716 21.651 16.361 21.744 16.001H19.998V14.001H21.998C21.998 13.325 21.912 12.653 21.744 12.001H19.998V10.001H20.926C20.577 9.397 20.15 8.84 19.655 8.344L17.998 10.001V12.001H15.998L13.998 14.001V16.001H11.998L9.998 18.001V20.001H8.707L8.708 20ZM18 18H16V20H18V18ZM16 14H18V16H16V14ZM14 18H12V20H14V18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-filter-invert"
        viewBox="0 0 28 28">
        <path
            d="M14 24C19.523 24 24 19.523 24 14C24 8.477 19.523 4 14 4C8.477 4 4 8.477 4 14C4 19.523 8.477 24 14 24ZM8.343 8.343C9.843 6.843 11.878 6 14 6V10C12.939 10 11.922 10.421 11.172 11.172C10.422 11.923 10 12.94 10 14C10 15.061 10.421 16.078 11.172 16.828C11.923 17.578 12.94 18 14 18V22C11.878 22 9.843 21.157 8.343 19.657C6.843 18.157 6 16.122 6 14C6 11.878 6.843 9.843 8.343 8.343ZM14 18V10C16.209 10 18 11.791 18 14C18 16.209 16.209 18 14 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-filter-saturate"
        viewBox="0 0 28 28">
        <path
            d="M14 24C18.418 24 22 20.717 22 16.667C22 13.4 16.796 5.86201 14.782 3.06801C14.393 2.52901 13.606 2.52901 13.218 3.06801C11.205 5.86201 6 13.401 6 16.667C6 20.717 9.582 24 14 24ZM8 16.333C8 13.203 14 5.00001 14 5.00001V22C10.686 22 8 19.463 8 16.333Z"></path>
    </symbol>
    <symbol
        id="icon-ui-filter-sepia"
        viewBox="0 0 28 28">
        <path
            d="M2 6V20C2 21.105 2.895 22 4 22H22C23.105 22 24 21.105 24 20V6C24 4.895 23.105 4 22 4H4C2.895 4 2 4.895 2 6ZM4 6H6V8H4V6ZM22 6V8H20V6H22ZM4 10H6V12H4V10ZM22 10V12H20V10H22ZM4 14H6V16H4V14ZM22 14V16H20V14H22ZM4 18H6V20H4V18ZM22 18V20H20V18H22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-flip-h"
        viewBox="0 0 28 28">
        <path
            d="M12 10H9C8.448 10 8 10.448 8 11V17C8 17.552 8.448 18 9 18H12V20H9C7.343 20 6 18.657 6 17V11C6 9.343 7.343 8 9 8H12V10ZM14 24V4H16V24H14ZM18 20V8H21C22.657 8 24 9.343 24 11V17C24 18.657 22.657 20 21 20H18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-flip-v"
        viewBox="0 0 28 28">
        <path
            d="M18 12V9C18 8.448 17.552 8 17 8H11C10.448 8 10 8.448 10 9V12H8V9C8 7.343 9.343 6 11 6H17C18.657 6 20 7.343 20 9V12H18ZM4 14H24V16H4V14ZM8 18H20V21C20 22.657 18.657 24 17 24H11C9.343 24 8 22.657 8 21V18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-folder"
        viewBox="0 0 28 28">
        <path
            d="M6.00002 6V24H24V10H14.913L12.226 6H6.00002ZM4.00002 4H13.291L15.978 8H25.999V26H3.99902L4.00002 4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-folder-add"
        viewBox="0 0 28 28">
        <path
            d="M22 20H26V22H22V26H20V22H16V20H20V16H22V20ZM26 14H24V10H14.913L12.226 6H6V24H14V26H4V4H13.291L15.978 8H25.999L26 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-folder-move"
        viewBox="0 0 28 28">
        <path
            d="M13.291 4L15.978 8H25.999V26H15.999V24H23.999V10H14.912L12.225 6H5.99902V14H3.99902V4H13.291ZM10.999 14L16 19.001L10.999 24L9.77502 22.776L12.554 20H4.00002V18H12.554L9.77502 15.224L10.999 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-folder-multiple"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_377)">
            <path
                d="M2.00002 6V24H18V10H10.913L8.22602 6H2.00002ZM2.34375e-05 4H9.29102L11.978 8H19.999V26H-0.000976562V4H2.34375e-05ZM22 8H24V26H22V8ZM26 8H28V26H26V8Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_377">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-folder-open"
        viewBox="0 0 28 28">
        <path
            d="M4.651 24H22.491L25.348 14H7.508L4.651 24ZM24 26H2V4H11.291L13.978 8H23.999V12H27.999L24 26ZM22 12V10H12.913L10.226 6H4V19L6 12H22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-folder-shared"
        viewBox="0 0 28 28">
        <path
            d="M13.291 4L15.978 8H25.999V26H3.99902V4H13.291ZM12.226 6H6.00002V24H24V10H14.913L12.226 6ZM12 18C13.667 18 17 19.073 17 21.024V22H8.00002L8.00102 19.314C9.11902 18.456 10.913 18 12 18ZM12 12C13.107 12 14 12.893 14 14C14 15.107 13.107 16 12 16C10.893 16 10 15.107 10 14C10 12.893 10.893 12 12 12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-font-file"
        viewBox="0 0 28 28">
        <path
            d="M20 18V24H22V26H16V24H18V18H16V20H14V16H24V20H22V18H20ZM24 14H22V6H13L8 11V22H12V24H6V10L12 4H24V14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-font-folder"
        viewBox="0 0 28 28">
        <path
            d="M13.291 4L15.978 8H25.999V14H23.999V10H14.912L12.225 6H5.99902V24H13.999V26H3.99902V4H13.291ZM22 24H24V26H18V24H20V18H18V20H16V16H26V20H24V18H22V24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-gif-frame"
        viewBox="0 0 28 28">
        <path
            d="M4 24H26V20H24V22H6V6H24V8H26V4H4V24ZM10 10H14V12H10V18H12V14H14V20H8V10H10ZM18 10H16V20H18V10ZM20 10H26V12H22V14H26V16H22V20H20V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-gif-frame-small"
        viewBox="0 0 24 28">
        <g clip-path="url(#clip0_5317_389)">
            <path d="M0 0H24V16L12 28L0 16V0Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_389">
                <rect
                    width="24"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-global-app-bundle"
        viewBox="0 0 28 28">
        <path
            d="M14.439 12.602C14.991 12.602 15.439 13.05 15.439 13.602V21.602C15.439 22.154 14.991 22.602 14.439 22.602H6.43896C5.88696 22.602 5.43896 22.154 5.43896 21.602V13.602C5.43896 13.05 5.88696 12.602 6.43896 12.602H14.439ZM6.43896 11.602C5.33396 11.602 4.43896 12.497 4.43896 13.602V21.602C4.43896 22.707 5.33396 23.602 6.43896 23.602H14.439C15.544 23.602 16.439 22.707 16.439 21.602V13.602C16.439 12.497 15.544 11.602 14.439 11.602H6.43896Z"></path>
        <path
            d="M18.0389 9.00201C18.5909 9.00201 19.0389 9.45001 19.0389 10.002V18.002C19.0389 18.554 18.5909 19.002 18.0389 19.002H10.0389C9.48694 19.002 9.03894 18.554 9.03894 18.002V10.002C9.03894 9.45001 9.48694 9.00201 10.0389 9.00201H18.0389ZM10.0389 8.00201C8.93394 8.00201 8.03894 8.89701 8.03894 10.002V18.002C8.03894 19.107 8.93394 20.002 10.0389 20.002H18.0389C19.1439 20.002 20.0389 19.107 20.0389 18.002V10.002C20.0389 8.89701 19.1439 8.00201 18.0389 8.00201H10.0389Z"></path>
        <path
            d="M21.639 5.40201C22.191 5.40201 22.639 5.85001 22.639 6.40201V14.402C22.639 14.954 22.191 15.402 21.639 15.402H13.639C13.087 15.402 12.639 14.954 12.639 14.402V6.40201C12.639 5.85001 13.087 5.40201 13.639 5.40201H21.639ZM13.639 4.40201C12.534 4.40201 11.639 5.29701 11.639 6.40201V14.402C11.639 15.507 12.534 16.402 13.639 16.402H21.639C22.744 16.402 23.639 15.507 23.639 14.402V6.40201C23.639 5.29701 22.744 4.40201 21.639 4.40201H13.639Z"></path>
        <path
            d="M26.216 5.539L26.217 5.541C26.218 5.543 26.219 5.549 26.221 5.56C26.225 5.581 26.229 5.626 26.223 5.703C26.21 5.864 26.151 6.122 25.992 6.488C25.67 7.229 25.036 8.19 24.064 9.309C22.133 11.532 19.102 14.11 15.422 16.47C11.742 18.83 8.20899 20.461 5.49899 21.216C4.13399 21.596 3.06099 21.729 2.31599 21.673C1.94799 21.645 1.71499 21.574 1.58099 21.507C1.51699 21.475 1.48399 21.449 1.46899 21.435C1.46199 21.428 1.45799 21.424 1.45599 21.422L1.45499 21.42L1.45399 21.417C1.45299 21.415 1.45099 21.409 1.44999 21.398C1.44599 21.377 1.44199 21.332 1.44799 21.255C1.46099 21.094 1.51999 20.836 1.67899 20.47C2.00099 19.729 2.63499 18.768 3.60699 17.649C3.70099 17.541 3.79699 17.432 3.89599 17.323C3.86099 17.249 3.82899 17.176 3.79999 17.102C3.60699 16.614 3.52599 16.083 3.64499 15.524C3.65199 15.492 3.65899 15.461 3.66699 15.429C0.871985 18.28 -0.542015 20.841 0.193985 22.228C1.45899 24.612 8.59199 22.627 16.127 17.794C23.662 12.961 28.745 7.112 27.48 4.728C26.951 3.731 25.394 3.498 23.211 3.919C23.369 3.963 23.523 4.025 23.67 4.107C24.097 4.346 24.388 4.713 24.579 5.129C24.602 5.179 24.624 5.231 24.644 5.283C24.907 5.267 25.145 5.268 25.356 5.284C25.724 5.312 25.957 5.383 26.091 5.45C26.155 5.482 26.188 5.508 26.203 5.522C26.21 5.529 26.214 5.533 26.216 5.535L26.218 5.538L26.216 5.539Z"></path>
    </symbol>
    <symbol
        id="icon-ui-go-to-url"
        viewBox="0 0 28 28">
        <path d="M18 2H26V10H24V5.317L13.903 15.414L12.489 14L22.489 4H18V2Z"></path>
        <path d="M4 2H12V4H6V22H24V16H26V24H4V2Z"></path>
    </symbol>
    <symbol
        id="icon-ui-go-to-url-large"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_399)">
            <path d="M18 0H28V10H26V3.317L13.903 15.414L12.489 14L24.489 2H18V0Z"></path>
            <path d="M0 0H12V2H2V26H26V16H28V28H0V0Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_399">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-hamburger"
        viewBox="0 0 28 28">
        <path d="M0 8V6H28V8H0ZM0 16V14H28V16H0ZM0 24V22H28V24H0Z"></path>
    </symbol>
    <symbol
        id="icon-ui-heart-outline"
        viewBox="0 0 28 28">
        <path
            d="M14 12.185L15.669 9.655C16.946 7.719 19.01 7.551 20.561 8.783C22.373 10.221 22.645 13.734 20.383 16.019C19.002 17.415 17.123 19.001 15.552 20.263C14.97 20.731 14.438 21.148 14 21.487C13.562 21.148 13.03 20.731 12.448 20.263C10.877 19.001 8.99801 17.415 7.61701 16.019C5.35501 13.734 5.62701 10.221 7.43901 8.783C8.99001 7.552 11.054 7.719 12.331 9.655L14 12.185ZM12.613 7.048C10.667 5.564 8.12001 5.688 6.19501 7.216C3.26801 9.539 3.26801 14.468 6.19501 17.426C9.12201 20.384 14 24 14 24C14 24 18.878 20.383 21.805 17.426C24.732 14.469 24.732 9.539 21.805 7.216C19.88 5.688 17.332 5.564 15.387 7.048C14.876 7.438 14.406 7.938 14 8.554C13.594 7.939 13.125 7.438 12.614 7.048H12.613Z"></path>
    </symbol>
    <symbol
        id="icon-ui-html"
        viewBox="0 0 28 28">
        <path
            d="M24 4L23 21.5L15 24.5L7 21.5L6 4H24ZM10 8V14H18V17L15 18L12 17V16H10V18.5L15 20.5L20 18.5V12H12V10H20V8H10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-html-crossed"
        viewBox="0 0 28 28">
        <path
            d="M3.99998 1.99999L5.10498 21.332L8.78098 17.656V16.341H10.096L12.486 13.951H8.78098V6.77999H19.657L24.438 1.99899H4.00098L3.99998 1.99999ZM20.732 12.777L25.149 8.35999L24.317 22.915L14.756 26.5L9.12098 24.387L12.636 20.872L14.756 21.72L20.732 19.33V12.777ZM14.787 18.722L18.342 17.537V15.167L14.787 18.722ZM17.266 9.17099L14.876 11.561H11.171V9.17099H17.266ZM27.335 4.07999C27.725 3.68899 27.725 3.05599 27.335 2.66599C26.945 2.27599 26.311 2.27499 25.921 2.66599L3.29398 25.293C2.90298 25.684 2.90298 26.317 3.29398 26.707C3.68498 27.097 4.31798 27.098 4.70798 26.707L27.336 4.07999H27.335Z"></path>
    </symbol>
    <symbol
        id="icon-ui-image"
        viewBox="0 0 28 28">
        <path
            d="M4 20.857V4H26V24H4V20.857ZM20.286 22H24V6H6V17.714L9 13L13.443 19.983L16 17L20.286 22ZM18 14C16.895 14 16 13.105 16 12C16 10.895 16.895 10 18 10C19.105 10 20 10.895 20 12C20 13.105 19.105 14 18 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-image-add"
        viewBox="0 0 28 28">
        <path
            d="M22 20H26V22H22V26H20V22H16V20H20V16H22V20ZM4 22.667V4H26V14H24V6H6V20L9 16L15 24H4V22.667ZM16 14C14.895 14 14 13.105 14 12C14 10.895 14.895 10 16 10C17.105 10 18 10.895 18 12C18 13.105 17.105 14 16 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-image-frames"
        viewBox="0 0 28 28">
        <path
            d="M12 22V12H24V22H12ZM22 20V14H14V20H22ZM20 8V10H10V18H8V8H20ZM16 4V6H6V14H4V4H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-image-frames1"
        viewBox="0 0 28 28">
        <path
            d="M12 22V12H24V22H12ZM22 20V14H14V20H22ZM20 8V10H10V18H8V8H20ZM16 4V6H6V14H4V4H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-image-upload"
        viewBox="0 0 28 28">
        <path
            d="M22 19.447V26H20V19.448L17.224 22.224L16 21L21.001 15.999L26 21L24.776 22.224L22 19.447ZM4 22.667V4H26V14H24V6H6V20L9 16L15 24H4V22.667ZM16 14C14.895 14 14 13.105 14 12C14 10.895 14.895 10 16 10C17.105 10 18 10.895 18 12C18 13.105 17.105 14 16 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-impressions"
        viewBox="0 0 28 28">
        <path
            d="M14 8C10.463 8 6.51599 11.632 4.43799 13.997L4.97299 14.587C7.15099 16.921 10.759 20 14 20C17.536 20 21.484 16.366 23.56 14.001L23.026 13.412C20.849 11.078 17.24 8.001 14 8.001V8ZM14 11C15.654 11 17 12.345 17 14C17 15.655 15.654 17 14 17C12.345 17 11 15.655 11 14C11 12.345 12.345 11 14 11Z"></path>
    </symbol>
    <symbol
        id="icon-ui-indeterminate-checkmark"
        viewBox="0 0 28 28">
        <path
            d="M8 12H20C21.105 12 22 12.895 22 14C22 15.105 21.105 16 20 16H8C6.895 16 6 15.105 6 14C6 12.895 6.895 12 8 12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-indeterminate-checkmark-l"
        viewBox="0 0 28 28">
        <path
            d="M4 12H24C25.105 12 26 12.895 26 14C26 15.105 25.105 16 24 16H4C2.895 16 2 15.105 2 14C2 12.895 2.895 12 4 12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-infinity"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_426)">
            <path
                d="M26.208 9.756C25.07 8.632 23.526 8.001 21.917 8.001C20.308 8.001 18.764 8.632 17.625 9.756L14.993 12.355L12.361 9.756C11.512 8.918 10.431 8.347 9.25302 8.116C8.07502 7.885 6.85502 8.003 5.74602 8.457C4.63702 8.911 3.68902 9.679 3.02202 10.664C2.35502 11.649 1.99902 12.808 1.99902 13.993C1.99902 15.178 2.35502 16.337 3.02202 17.322C3.68902 18.307 4.63702 19.076 5.74602 19.529C6.85502 19.983 8.07502 20.101 9.25302 19.87C10.431 19.639 11.512 19.068 12.361 18.23L14.993 15.631L17.625 18.23C18.188 18.79 18.857 19.234 19.594 19.538C20.331 19.842 21.122 19.999 21.921 20C22.72 20.001 23.511 19.847 24.249 19.546C24.987 19.245 25.658 18.803 26.223 18.245C26.788 17.687 27.236 17.025 27.541 16.296C27.846 15.567 28.002 14.786 28.001 13.997C28 13.208 27.841 12.428 27.533 11.7C27.225 10.972 26.774 10.311 26.208 9.756ZM11.135 17.02C10.529 17.619 9.75602 18.026 8.91502 18.191C8.07402 18.356 7.20202 18.271 6.41002 17.947C5.61802 17.623 4.94102 17.074 4.46402 16.37C3.98702 15.666 3.73302 14.839 3.73302 13.992C3.73302 13.145 3.98702 12.318 4.46402 11.614C4.94102 10.91 5.61702 10.361 6.41002 10.037C7.20202 9.713 8.07402 9.628 8.91502 9.793C9.75602 9.958 10.528 10.366 11.135 10.964L14.126 13.918V14.065L11.135 17.018V17.02ZM24.981 17.02C24.168 17.823 23.065 18.274 21.916 18.274C20.767 18.274 19.664 17.823 18.851 17.02L15.86 14.066V13.919L18.851 10.965C19.254 10.568 19.731 10.252 20.258 10.037C20.785 9.822 21.348 9.711 21.917 9.711C22.486 9.711 23.05 9.822 23.576 10.037C24.102 10.252 24.58 10.567 24.982 10.965C25.385 11.362 25.704 11.834 25.922 12.354C26.14 12.874 26.252 13.43 26.252 13.992C26.252 14.554 26.14 15.111 25.922 15.63C25.704 16.149 25.385 16.621 24.982 17.019L24.981 17.02Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_426">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-info-l"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_428)">
            <path
                d="M14 0C21.732 0 28 6.268 28 14C28 21.732 21.732 28 14 28C6.268 28 0 21.732 0 14C0 6.268 6.268 0 14 0ZM14 12C12.895 12 12 12.895 12 14V20C12 21.105 12.895 22 14 22C15.105 22 16 21.105 16 20V14C16 12.895 15.105 12 14 12ZM14 6C12.895 6 12 6.895 12 8C12 9.105 12.895 10 14 10C15.105 10 16 9.105 16 8C16 6.895 15.105 6 14 6Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_428">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-info-large"
        viewBox="0 0 32 32">
        <g clip-path="url(#clip0_5317_430)">
            <path
                d="M16 32C7.163 32 0 24.837 0 16C0 7.163 7.163 0 16 0C24.837 0 32 7.163 32 16C32 24.837 24.837 32 16 32ZM16 30.5C24.008 30.5 30.5 24.008 30.5 16C30.5 7.992 24.008 1.5 16 1.5C7.992 1.5 1.5 7.992 1.5 16C1.5 24.008 7.992 30.5 16 30.5ZM16 25C14.895 25 14 24.105 14 23V15C14 13.895 14.895 13 16 13C17.105 13 18 13.895 18 15V23C18 24.105 17.105 25 16 25ZM16 11C14.895 11 14 10.105 14 9C14 7.895 14.895 7 16 7C17.105 7 18 7.895 18 9C18 10.105 17.105 11 16 11Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_430">
                <rect
                    width="32"
                    height="32"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-instagram"
        viewBox="0 0 28 28">
        <path
            d="M9.759 23.929C8.745 23.86 8.155 23.73 7.704 23.544C6.234 22.935 5.066 21.767 4.457 20.297C4.27 19.846 4.141 19.256 4.072 18.242C4.002 17.21 4.001 15.892 4.001 14.001C4.001 12.11 4.002 10.792 4.072 9.76C4.141 8.746 4.271 8.156 4.457 7.705C5.066 6.235 6.234 5.067 7.704 4.458C8.155 4.271 8.745 4.142 9.759 4.073C10.791 4.003 12.109 4.002 14 4.002C15.891 4.002 17.209 4.003 18.241 4.073C19.255 4.142 19.845 4.272 20.296 4.458C21.766 5.067 22.934 6.235 23.543 7.705C23.73 8.156 23.859 8.746 23.928 9.76C23.998 10.792 23.999 12.11 23.999 14.001C23.999 15.892 23.998 17.21 23.928 18.242C23.859 19.256 23.729 19.846 23.543 20.297C22.934 21.767 21.766 22.935 20.296 23.544C19.845 23.731 19.255 23.86 18.241 23.929C17.209 23.999 15.891 24 14 24C12.109 24 10.791 23.999 9.759 23.929ZM2.609 6.939C2 8.409 2 10.273 2 14C2 17.727 2 19.591 2.609 21.061C3.421 23.021 4.978 24.579 6.939 25.391C8.409 26 10.273 26 14 26C17.727 26 19.591 26 21.061 25.391C23.021 24.579 24.579 23.022 25.391 21.061C26 19.591 26 17.727 26 14C26 10.273 26 8.409 25.391 6.939C24.579 4.979 23.022 3.421 21.061 2.609C19.591 2 17.727 2 14 2C10.273 2 8.409 2 6.939 2.609C4.979 3.421 3.421 4.978 2.609 6.939ZM14 18C11.791 18 10 16.209 10 14C10 11.791 11.791 10 14 10C16.209 10 18 11.791 18 14C18 16.209 16.209 18 14 18ZM14 20C17.314 20 20 17.314 20 14C20 10.686 17.314 8 14 8C10.686 8 8 10.686 8 14C8 17.314 10.686 20 14 20ZM20 9C20.828 9 21.5 8.328 21.5 7.5C21.5 6.672 20.828 6 20 6C19.172 6 18.5 6.672 18.5 7.5C18.5 8.328 19.172 9 20 9Z"></path>
    </symbol>
    <symbol
        id="icon-ui-kebab"
        viewBox="0 0 28 28">
        <path
            d="M14 8C12.895 8 12 7.105 12 6C12 4.895 12.895 4 14 4C15.105 4 16 4.895 16 6C16 7.105 15.105 8 14 8ZM14 16C12.895 16 12 15.105 12 14C12 12.895 12.895 12 14 12C15.105 12 16 12.895 16 14C16 15.105 15.105 16 14 16ZM14 24C12.895 24 12 23.105 12 22C12 20.895 12.895 20 14 20C15.105 20 16 20.895 16 22C16 23.105 15.105 24 14 24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-keyboard"
        viewBox="0 0 28 28">
        <path
            d="M4.4 6C3.763 6 3.153 6.241 2.703 6.669C2.253 7.097 2 7.679 2 8.285V19.714C2 20.32 2.253 20.902 2.703 21.33C3.153 21.758 3.764 21.999 4.4 21.999H23.6C24.237 21.999 24.847 21.758 25.297 21.33C25.747 20.902 26 20.32 26 19.714V8.285C26 7.679 25.747 7.097 25.297 6.669C24.847 6.241 24.237 6 23.6 6H4.4ZM4.4 8.286H23.6V19.715H4.4V8.286ZM5.6 9.429V11.715H8V9.429H5.6ZM9.2 9.429V11.715H11.6V9.429H9.2ZM12.8 9.429V11.715H15.2V9.429H12.8ZM16.4 9.429V11.715H18.8V9.429H16.4ZM20 9.429V11.715H22.4V9.429H20ZM5.6 12.857V15.143H8V12.857H5.6ZM9.2 12.857V15.143H11.6V12.857H9.2ZM12.8 12.857V15.143H15.2V12.857H12.8ZM16.4 12.857V15.143H18.8V12.857H16.4ZM20 12.857V15.143H22.4V12.857H20ZM9.2 16.286V18.572H18.8V16.286H9.2Z"></path>
    </symbol>
    <symbol
        id="icon-ui-like-filled"
        viewBox="0 0 28 28">
        <path
            d="M12.569 3.15L10 10V24H19.766C21.652 24 23.282 22.682 23.677 20.838L24.963 14.838C25.497 12.348 23.598 10 21.052 10H16V3.772C16 2.793 15.207 2 14.228 2C13.489 2 12.828 2.458 12.569 3.15ZM6 10C4.895 10 4 10.895 4 12V22C4 23.105 4.895 24 6 24H8V10H6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-like-outline"
        viewBox="0 0 28 28">
        <path
            d="M18 10V4C18 2.895 17.105 2 16 2H14.386C13.552 2 12.806 2.517 12.513 3.298L10 10V24H19.766C21.652 24 23.282 22.682 23.677 20.838L24.963 14.838C25.497 12.348 23.598 10 21.052 10H18ZM19.766 22H12V10.363L14.386 4H16V10C16 11.105 16.895 12 18 12H21.052C22.325 12 23.274 13.174 23.008 14.419L21.722 20.419C21.524 21.341 20.709 22 19.766 22ZM6 10C4.895 10 4 10.895 4 12V22C4 23.105 4.895 24 6 24H8V10H6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-lines"
        viewBox="0 0 28 28">
        <path d="M24 12H4V4H24V12ZM24 24H4V16H24V24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-link"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_444)">
            <path
                d="M11.384 9.906C11.818 9.331 12.152 8.942 12.386 8.739C12.61 8.546 12.852 8.358 13.111 8.176C13.138 8.157 13.159 8.12 13.111 8.099C12.725 8.021 12.408 8 11.999 8H7.99902C4.68502 8 1.99902 10.686 1.99902 14C1.99902 17.314 4.68502 20 7.99902 20H11.999C15.313 20 17.999 17.314 17.999 14C17.999 13.39 17.908 12.802 17.739 12.248C17.724 12.2 17.641 12.2 17.58 12.248C17.58 12.248 16.522 13.228 16.047 13.671C15.996 13.718 15.995 13.804 15.995 13.804C15.998 13.869 16 13.934 16 14C16 16.209 14.209 18 12 18H8.00002C5.79102 18 4.00002 16.209 4.00002 14C4.00002 11.791 5.79102 10 8.00002 10H11.237C11.313 10 11.36 9.937 11.384 9.906ZM18.616 18.094C18.182 18.669 17.848 19.058 17.614 19.261C17.39 19.454 17.149 19.642 16.889 19.824C16.862 19.843 16.841 19.88 16.889 19.901C17.275 19.979 17.592 20 18.001 20H22.001C25.315 20 28.001 17.314 28.001 14C28.001 10.686 25.315 8 22.001 8H18.001C14.687 8 12.001 10.686 12.001 14C12.001 14.61 12.092 15.198 12.261 15.752C12.276 15.8 12.359 15.8 12.42 15.752C13.126 15.099 13.637 14.625 13.953 14.329C13.987 14.298 14.004 14.253 14.005 14.196C14.002 14.131 14 14.066 14 14C14 11.791 15.791 10 18 10H22C24.209 10 26 11.791 26 14C26 16.209 24.209 18 22 18H18.763C18.687 18 18.64 18.063 18.616 18.094Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_444">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-linkedin"
        viewBox="0 0 28 28">
        <path
            d="M2 2V26H26V2H2ZM9.465 21.939H5.904V11.226H9.465V21.939ZM7.685 9.764H7.661C6.467 9.764 5.692 8.941 5.692 7.913C5.692 6.862 6.489 6.062 7.708 6.062C8.927 6.062 9.676 6.862 9.699 7.913C9.699 8.942 8.928 9.764 7.685 9.764ZM22.308 21.939H18.746V16.208C18.746 14.768 18.231 13.786 16.942 13.786C15.958 13.786 15.372 14.448 15.115 15.088C15.021 15.317 14.997 15.635 14.997 15.956V21.939H11.435C11.435 21.939 11.483 12.231 11.435 11.226H14.997V12.744C15.47 12.016 16.315 10.974 18.207 10.974C20.551 10.974 22.308 12.505 22.308 15.795V21.939Z"></path>
    </symbol>
    <symbol
        id="icon-ui-linkedin_comment"
        viewBox="0 0 28 28">
        <path
            d="M7.636 8.363H20.363V9.636H7.636V8.363ZM7.636 13.454H16.545V12.181H7.636V13.454ZM27.999 10.909C28.018 12.302 27.699 13.68 27.07 14.923C26.441 16.166 25.519 17.239 24.385 18.049L14 24.909V19.818H8.909C6.546 19.818 4.28 18.879 2.609 17.209C0.938 15.539 0 13.272 0 10.909C0 8.546 0.939 6.28 2.609 4.609C4.279 2.938 6.546 2 8.909 2H19.091C21.454 2 23.72 2.939 25.39 4.609C27.06 6.279 27.999 8.546 27.999 10.909ZM25.454 10.909C25.454 9.221 24.784 7.603 23.59 6.409C22.396 5.215 20.778 4.545 19.09 4.545H8.908C7.22 4.545 5.602 5.215 4.408 6.409C3.214 7.603 2.544 9.221 2.544 10.909C2.544 12.597 3.214 14.215 4.408 15.409C5.602 16.603 7.22 17.273 8.908 17.273H16.544V20.175L22.907 16.001C23.713 15.424 24.367 14.658 24.81 13.771C25.253 12.884 25.474 11.902 25.452 10.91L25.454 10.909Z"></path>
    </symbol>
    <symbol
        id="icon-ui-linkedin_like"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_450)">
            <path
                d="M25.28 13.333L20.067 8.12C19.042 7.094 18.271 5.843 17.814 4.467L17.161 2.507C16.916 1.778 16.448 1.144 15.824 0.694001C15.2 0.244001 14.45 0.00200107 13.681 1.06721e-06C13.199 -0.00199893 12.722 0.0910011 12.277 0.274001C11.832 0.457001 11.426 0.725001 11.085 1.065C10.743 1.404 10.472 1.807 10.286 2.252C10.1 2.697 10.004 3.173 10.002 3.654V5.147C10.005 6.438 10.212 7.721 10.615 8.947L11.188 10.667H4.82798C4.07798 10.667 3.35898 10.965 2.82898 11.495C2.29898 12.025 2.00098 12.744 2.00098 13.494C2.00298 13.955 2.11498 14.408 2.32898 14.817C2.54298 15.226 2.85098 15.576 3.22798 15.841C2.84998 16.099 2.54098 16.445 2.32798 16.849C2.11498 17.253 2.00198 17.703 2.00198 18.161C1.99098 18.724 2.14798 19.278 2.45198 19.753C2.75598 20.228 3.19298 20.602 3.70898 20.828C3.46898 21.232 3.34098 21.692 3.33598 22.161C3.33498 22.884 3.61098 23.58 4.10698 24.105C4.60298 24.63 5.28098 24.947 6.00298 24.987V25.174C6.00298 25.924 6.30098 26.643 6.83098 27.173C7.36098 27.703 8.07998 28.001 8.82998 28.001H18.817C20.473 28 22.106 27.616 23.59 26.881L24.003 26.668H27.336V13.335H25.283L25.28 13.333ZM24.667 24H23.334L22.361 24.493C21.245 25.042 20.018 25.329 18.774 25.333H9.62698C9.32898 25.345 9.03698 25.257 8.79498 25.083C8.55298 24.909 8.37698 24.659 8.29398 24.373L7.96098 23.213L6.82798 22.666C6.56698 22.56 6.34598 22.373 6.19798 22.134C6.04998 21.895 5.98098 21.614 6.00198 21.333L6.22898 20L5.21598 19.013C4.99598 18.798 4.85598 18.513 4.82198 18.206C4.78798 17.899 4.86098 17.591 5.02898 17.333L5.90898 15.88L4.93598 14.413C4.87998 14.345 4.83898 14.267 4.81398 14.183C4.78898 14.099 4.78098 14.011 4.79098 13.924C4.80098 13.837 4.82798 13.753 4.87098 13.676C4.91398 13.599 4.97198 13.533 5.04198 13.48C5.16898 13.375 5.33098 13.322 5.49498 13.333H14.895L13.148 8.106C12.829 7.152 12.667 6.152 12.668 5.146V3.666C12.675 3.403 12.782 3.152 12.968 2.966C13.154 2.78 13.405 2.672 13.668 2.666C13.877 2.666 14.081 2.732 14.251 2.854C14.421 2.976 14.548 3.148 14.615 3.346L15.335 5.333C15.91 7.086 16.882 8.683 18.175 10L24.175 16H24.668L24.667 24Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_450">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-linkedin_repost"
        viewBox="0 0 28 28">
        <path
            d="M19.355 8.129L22.065 4.215L19.355 0H17.549L19.484 3.355H9.16198C7.80198 3.355 6.49698 3.892 5.53098 4.848C4.56498 5.804 4.01498 7.104 4.00098 8.464V10.01V18.967H5.72098V9.588C5.72098 9.442 5.72098 9.311 5.72098 9.187C5.72098 8.957 5.71998 8.751 5.72098 8.516V8.378C5.72998 7.935 5.82598 7.498 6.00398 7.093C6.18198 6.688 6.43798 6.321 6.75698 6.014C7.07698 5.707 7.45298 5.466 7.86598 5.305C8.27898 5.144 8.71898 5.066 9.16198 5.075H19.484L17.549 8.128L19.355 8.129ZM10.322 19.871L7.61198 23.785L10.322 28H12.128L10.193 24.645H20.515C21.875 24.645 23.18 24.108 24.146 23.152C25.112 22.196 25.662 20.896 25.676 19.536V9.033H23.956V18.412C23.956 18.558 23.956 18.689 23.957 18.813C23.957 19.043 23.958 19.249 23.956 19.484V19.622C23.947 20.065 23.851 20.502 23.673 20.907C23.495 21.312 23.239 21.679 22.92 21.986C22.6 22.293 22.224 22.534 21.811 22.695C21.398 22.856 20.958 22.934 20.515 22.925H10.193L12.128 19.871H10.322Z"></path>
    </symbol>
    <symbol
        id="icon-ui-linkedin_send"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_454)">
            <path
                d="M28 -7.08003e-06L0 9.33299L10.213 15.013L21.333 6.66599L12.986 17.786L18.666 27.999L27.999 -0.00100708L28 -7.08003e-06Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_454">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-link-l"
        viewBox="0 0 28 28">
        <path
            d="M12.387 8.739C12.152 8.942 11.818 9.331 11.385 9.906C11.362 9.937 11.315 10 11.238 10C11.187 10 10.108 10 8.00098 10C5.79198 10 4.00098 11.791 4.00098 14C4.00098 16.209 5.79198 18 8.00098 18H12.001C14.21 18 16.001 16.209 16.001 14C16.001 13.934 15.999 13.869 15.996 13.804C15.997 13.747 16.014 13.702 16.048 13.671C16.365 13.376 16.876 12.901 17.582 12.248C17.644 12.2 17.727 12.2 17.741 12.248C17.91 12.802 18.001 13.391 18.001 14C18.001 17.314 15.315 20 12.001 20H8.00098C4.68698 20 2.00098 17.314 2.00098 14C2.00098 10.686 4.68698 8 8.00098 8H12.001C12.41 8 12.727 8.021 13.113 8.099C13.161 8.12 13.14 8.157 13.113 8.176C12.853 8.358 12.61 8.545 12.387 8.739ZM17.613 19.261C17.848 19.058 18.182 18.669 18.615 18.094C18.638 18.063 18.685 18 18.762 18H21.999C24.208 18 25.999 16.209 25.999 14C25.999 11.791 24.208 10 21.999 10H17.999C15.79 10 13.999 11.791 13.999 14C13.999 14.066 14.001 14.131 14.004 14.196C14.003 14.253 13.986 14.298 13.952 14.329C13.635 14.624 13.124 15.099 12.418 15.752C12.356 15.8 12.273 15.8 12.259 15.752C12.09 15.198 11.999 14.609 11.999 14C11.999 10.686 14.685 8 17.999 8H21.999C25.313 8 27.999 10.686 27.999 14C27.999 17.314 25.313 20 21.999 20H17.999C17.59 20 17.273 19.979 16.887 19.901C16.839 19.88 16.86 19.843 16.887 19.824C17.147 19.642 17.389 19.455 17.612 19.261H17.613Z"></path>
    </symbol>
    <symbol
        id="icon-ui-link-s"
        viewBox="0 0 28 28">
        <path
            d="M17.464 19.818C17.649 19.702 17.827 19.563 18 19.402C18.361 19.064 18.847 18.333 19.012 18.077C19.035 18.042 19.106 18 19.194 18C19.361 18 19.963 18 21 18C22.657 18 24 16.657 24 15C24 13.343 22.657 12 21 12H17C15.343 12 14 13.343 14 15C14 15.425 13.98 15.634 14.139 16C14.127 16.179 13.866 16.357 13.357 16.534C12.848 16.711 12.52 16.749 12.375 16.649C12.267 16.359 12 15.982 12 15C12 12.239 14.239 10 17 10H21C23.761 10 26 12.239 26 15C26 17.761 23.761 20 21 20L17.516 19.997C17.462 19.997 17.419 19.954 17.419 19.9C17.419 19.867 17.435 19.835 17.464 19.818ZM12.536 10.182C12.351 10.298 12.173 10.437 12 10.598C11.639 10.936 11.153 11.667 10.988 11.923C10.965 11.958 10.894 12 10.806 12C10.639 12 10.037 12 9 12C7.343 12 6 13.343 6 15C6 16.657 7.343 18 9 18H13C14.657 18 16 16.657 16 15C16 14.575 16.02 14.366 15.861 14C15.873 13.821 16.134 13.643 16.643 13.466C17.152 13.289 17.48 13.251 17.625 13.351C17.733 13.641 18 14.018 18 15C18 17.761 15.761 20 13 20H9C6.239 20 4 17.761 4 15C4 12.239 6.239 10 9 10L12.484 10.003C12.538 10.003 12.581 10.046 12.581 10.1C12.581 10.133 12.564 10.165 12.535 10.182H12.536Z"></path>
    </symbol>
    <symbol
        id="icon-ui-list"
        viewBox="0 0 28 28">
        <path d="M4 8V4H24V8H4ZM4 16V12H24V16H4ZM4 24V20H24V24H4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-list1"
        viewBox="0 0 28 28">
        <path d="M24 22V24H4V22H24ZM24 16V18H4V16H24ZM24 10V12H4V10H24ZM24 4V6H4V4H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-live-icon"
        viewBox="0 0 28 28">
        <path
            d="M7.63396 5.83401C7.54096 5.73901 7.42896 5.66301 7.30596 5.61001C7.18296 5.55701 7.05096 5.53001 6.91796 5.52901C6.78396 5.52801 6.65196 5.55301 6.52796 5.60301C6.40396 5.65301 6.29096 5.72701 6.19596 5.82001C5.11796 6.89201 4.26296 8.16701 3.67996 9.57101C3.09696 10.975 2.79796 12.48 2.79896 14C2.79696 15.579 3.11996 17.141 3.74696 18.589C4.37396 20.037 5.29196 21.342 6.44396 22.421C6.63796 22.6 6.89396 22.697 7.15796 22.69C7.42196 22.683 7.67296 22.574 7.85796 22.386C8.29996 21.944 8.24596 21.239 7.81996 20.832C6.89496 19.951 6.15896 18.891 5.65696 17.716C5.15496 16.541 4.89596 15.277 4.89796 14C4.89796 11.416 5.93496 9.07201 7.61796 7.36701C8.02396 6.95401 8.06596 6.26801 7.63196 5.83401H7.63396ZM10.1 8.30201C9.91596 8.11201 9.66396 8.00301 9.39896 7.99901C9.13396 7.99501 8.87896 8.09601 8.68896 8.27901C7.93096 9.02601 7.32996 9.91701 6.91996 10.899C6.50996 11.881 6.29896 12.935 6.30096 13.999C6.30096 16.368 7.32296 18.497 8.95096 19.97C9.14296 20.14 9.39396 20.229 9.64996 20.219C9.90596 20.209 10.149 20.101 10.327 19.917C10.786 19.458 10.701 18.735 10.27 18.329C9.67896 17.773 9.20796 17.102 8.88696 16.357C8.56596 15.612 8.39996 14.81 8.40096 13.998C8.40096 12.388 9.04096 10.926 10.081 9.85401C10.481 9.44201 10.547 8.74501 10.101 8.30001L10.1 8.30201ZM17.9 8.30101C18.084 8.11101 18.336 8.00201 18.601 7.99801C18.866 7.99401 19.121 8.09501 19.311 8.27801C20.069 9.02601 20.67 9.91601 21.08 10.899C21.49 11.882 21.7 12.935 21.699 14C21.699 16.369 20.677 18.498 19.049 19.971C18.857 20.141 18.606 20.23 18.35 20.22C18.094 20.21 17.851 20.102 17.673 19.918C17.214 19.459 17.299 18.736 17.73 18.33C18.321 17.774 18.792 17.103 19.113 16.358C19.434 15.613 19.6 14.811 19.599 13.999C19.599 12.389 18.959 10.927 17.919 9.85501C17.519 9.44301 17.453 8.74501 17.899 8.30001L17.9 8.30101ZM20.366 5.83401C20.459 5.73901 20.571 5.66301 20.694 5.61001C20.817 5.55701 20.949 5.53001 21.082 5.52901C21.215 5.52801 21.348 5.55301 21.472 5.60301C21.596 5.65301 21.709 5.72701 21.804 5.82001C22.882 6.89201 23.737 8.16701 24.32 9.57101C24.903 10.975 25.202 12.48 25.201 14C25.203 15.579 24.88 17.141 24.253 18.589C23.626 20.037 22.708 21.342 21.556 22.421C21.362 22.6 21.106 22.697 20.842 22.69C20.578 22.683 20.327 22.574 20.142 22.386C19.7 21.944 19.754 21.239 20.181 20.832C21.105 19.951 21.841 18.891 22.343 17.716C22.845 16.541 23.103 15.277 23.101 14C23.101 11.416 22.064 9.07201 20.381 7.36701C19.975 6.95401 19.933 6.26801 20.367 5.83401H20.366ZM14 11.9C13.443 11.9 12.909 12.121 12.515 12.515C12.121 12.909 11.9 13.443 11.9 14C11.9 14.557 12.121 15.091 12.515 15.485C12.909 15.879 13.443 16.1 14 16.1C14.557 16.1 15.091 15.879 15.485 15.485C15.879 15.091 16.1 14.557 16.1 14C16.1 13.443 15.879 12.909 15.485 12.515C15.091 12.121 14.557 11.9 14 11.9Z"></path>
    </symbol>
    <symbol
        id="icon-ui-localized"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_466)">
            <path
                d="M14.072 23.629L17.923 14H20.077L23.928 23.629C23.977 23.751 24 23.877 24 24H21.923L21.123 22H16.877L16.077 24H14C14 23.876 14.023 23.75 14.072 23.629ZM19 16.693L17.677 20H20.323L19 16.693Z"></path>
            <path
                d="M8 3.99999H10V5.99999H14V7.99999H12C12 9.27699 11.4 9.87199 10.552 10.711C10.46 10.802 10.365 10.896 10.268 10.994L10.305 11.015C11.006 11.404 11.761 11.743 12.447 11.981C12.967 12.161 13.395 12.089 13.705 12.036C13.82 12.017 13.919 12 14 12V14C13.3 14 12.465 13.793 11.678 13.519C10.864 13.236 9.995 12.846 9.195 12.401C9.069 12.331 8.945 12.26 8.822 12.187C8.023 12.733 7.162 13.173 6.354 13.481C5.546 13.789 4.707 13.999 4 13.999V11.965C4.081 11.965 4.181 11.985 4.298 12.009C4.602 12.071 5.021 12.156 5.521 11.965C6.079 11.752 6.684 11.454 7.265 11.087C7.196 11.027 7.129 10.967 7.065 10.907C6.523 10.399 6 9.73299 6 8.99899H8C8 9.09899 8.101 9.36999 8.56 9.79999C8.61 9.84699 8.663 9.89399 8.718 9.94199C8.876 9.78399 9.022 9.64799 9.155 9.52399C9.682 9.03499 10 8.73999 10 7.99899H4V5.99899H8V3.99999Z"></path>
            <path
                d="M2 18C0.895 18 0 17.105 0 16V2C0 0.895 0.895 0 2 0H16C17.105 0 18 0.895 18 2V10H26C27.105 10 28 10.895 28 12V26C28 27.105 27.105 28 26 28H12C10.895 28 10 27.105 10 26V18H2ZM12 16V26H26V12H16V2H2V16H12Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_466">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-lock-closed"
        viewBox="0 0 28 28">
        <path
            d="M18 12C19.105 12 20 12.895 20 14V20C20 21.105 19.105 22 18 22H10C8.895 22 8 21.105 8 20V14C8 12.895 8.895 12 10 12V10C10 7.791 11.791 6 14 6C16.209 6 18 7.791 18 10V12ZM16 12V10C16 8.895 15.105 8 14 8C12.895 8 12 8.895 12 10V12H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-lock-open"
        viewBox="0 0 28 28">
        <path
            d="M17.874 9H15.732C15.386 8.402 14.74 8 14 8C12.895 8 12 8.895 12 10V12H18C19.105 12 20 12.895 20 14V20C20 21.105 19.105 22 18 22H10C8.895 22 8 21.105 8 20V14C8 12.895 8.895 12 10 12V10C10 7.791 11.791 6 14 6C15.864 6 17.43 7.275 17.874 9Z"></path>
    </symbol>
    <symbol
        id="icon-ui-log"
        viewBox="0 0 28 28">
        <path
            d="M24 4V24H4V4H24ZM22 6H6V22H22V6ZM20 16V18H8V16H20ZM20 12V14H8V12H20ZM16 8V10H8V8H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-loop-forever"
        viewBox="0 0 28 28">
        <path
            d="M16 20.007H19.167C21.836 20.007 24 17.673 24 15.004C24 12.335 21.836 10.001 19.167 10.001V8.00099C22.941 8.00099 26 11.23 26 15.004C26 18.778 22.941 22.007 19.167 22.007H16V25.499L12 21L16 16.499V20.007ZM12 9.99999H8.833C6.164 9.99999 4 12.334 4 15.003C4 17.672 6.164 20.006 8.833 20.006V22.006C5.059 22.006 2 18.777 2 15.003C2 11.229 5.059 7.99999 8.833 7.99999H12V4.49899L16 8.99999L12 13.499V9.99999Z"></path>
    </symbol>
    <symbol
        id="icon-ui-loop-x-times"
        viewBox="0 0 28 28">
        <path
            d="M16 22.007H19.167C21.836 22.007 24 19.673 24 17.004C24 14.335 21.836 12.001 19.167 12.001V10.001C22.941 10.001 26 13.23 26 17.004C26 20.778 22.941 24.007 19.167 24.007H16V27.499L12 23L16 18.499V22.007Z"></path>
    </symbol>
    <symbol
        id="icon-ui-mail"
        viewBox="0 0 28 28">
        <path
            d="M3.441 6L14.054 13.127L24.571 6H3.441ZM26 7.447L14.617 15.161C14.279 15.39 13.837 15.391 13.499 15.163L2 7.441V21.999H26V7.447ZM2 4H26C27.105 4 28 4.895 28 6V22C28 23.105 27.105 24 26 24H2C0.895 24 0 23.105 0 22V6C0 4.895 0.895 4 2 4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-mask"
        viewBox="0 0 28 28">
        <path
            d="M4 22V6C4 4.895 4.895 4 6 4H22C23.105 4 24 4.895 24 6V22C24 23.105 23.105 24 22 24H6C4.895 24 4 23.105 4 22ZM10 14C10 16.209 11.791 18 14 18C16.209 18 18 16.209 18 14C18 11.791 16.209 10 14 10C11.791 10 10 11.791 10 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-menu-checked"
        viewBox="0 0 28 28">
        <path
            d="M12.154 18.308L20.061 6.44499C20.367 5.98499 20.988 5.86099 21.448 6.16799C21.908 6.47499 22.032 7.09499 21.725 7.55499L13.129 20.451C12.775 20.982 12.021 21.05 11.578 20.591L7.28005 16.143C6.89605 15.746 6.90705 15.113 7.30405 14.729C7.70105 14.345 8.33405 14.356 8.71805 14.753L12.153 18.308H12.154Z"></path>
    </symbol>
    <symbol
        id="icon-ui-messenger"
        viewBox="0 0 28 28">
        <path
            d="M2 13.64C2 6.952 7.24 2 14 2C20.76 2 26 6.952 26 13.64C26 20.328 20.76 25.28 14 25.28C12.786 25.28 11.621 25.12 10.526 24.819C10.313 24.76 10.087 24.777 9.885 24.866L7.503 25.917C6.88 26.192 6.177 25.749 6.156 25.068L6.091 22.933C6.083 22.67 5.965 22.424 5.769 22.249C3.434 20.161 2 17.138 2 13.639V13.64ZM9.965 11.402L6.101 17.104C5.73 17.651 6.453 18.268 7.007 17.877L11.157 14.947C11.438 14.749 11.826 14.748 12.108 14.944L15.181 17.088C16.103 17.731 17.419 17.505 18.034 16.598L21.898 10.896C22.269 10.349 21.546 9.732 20.992 10.123L16.842 13.053C16.561 13.251 16.173 13.252 15.891 13.056L12.818 10.912C11.896 10.269 10.58 10.495 9.965 11.402Z"></path>
    </symbol>
    <symbol
        id="icon-ui-meta"
        viewBox="0 0 28 28">
        <path
            d="M4.59205 16.513C4.59205 14.291 5.22205 11.978 6.25105 10.425C6.97905 9.326 7.84805 8.607 8.87205 8.607C10.137 8.607 10.93 9.398 11.547 10.053C11.855 10.38 12.284 10.92 12.782 11.63L11.762 13.198C11.539 13.541 11.283 13.944 11.01 14.376C10.356 15.408 9.59905 16.604 8.92605 17.536C7.73405 19.184 7.11605 19.352 6.44005 19.352C5.91605 19.352 5.40205 19.116 5.05705 18.558C4.79405 18.132 4.59305 17.429 4.59305 16.512L4.59205 16.513ZM2.00005 16.42C2.00005 17.655 2.21305 18.758 2.64705 19.646C2.70905 19.773 2.77505 19.896 2.84605 20.014C3.54105 21.172 4.66405 21.941 6.43905 21.941C7.93505 21.941 9.07205 21.269 10.403 19.496C11.162 18.484 11.547 17.87 13.066 15.177L14.008 13.508C14.069 13.608 14.13 13.709 14.191 13.811L16.343 17.406C17.067 18.616 18.007 19.962 18.812 20.72C19.859 21.707 20.805 21.939 21.873 21.939C23.591 21.939 24.613 21.032 25.137 20.124C25.68 19.185 25.998 17.997 25.998 16.379C25.998 13.658 25.317 11.022 23.914 8.928C22.632 7.017 20.957 5.998 19.198 5.998C18.151 5.998 17.11 6.465 16.145 7.307C15.493 7.876 14.887 8.594 14.325 9.353C13.633 8.477 12.99 7.81 12.367 7.301C11.184 6.335 10.052 5.998 8.91305 5.998C7.19205 5.998 5.66305 6.979 4.51205 8.451C4.34805 8.661 4.19105 8.882 4.04205 9.111C2.70205 11.177 1.99805 13.852 1.99805 16.418L2.00005 16.42ZM16.762 12.962C16.322 12.229 15.905 11.571 15.505 10.978C15.576 10.868 15.647 10.76 15.718 10.655C16.839 8.988 17.836 8.054 19.076 8.054C20.222 8.054 21.264 8.812 22.067 10.052C23.2 11.8 23.714 14.248 23.714 16.453C23.714 18 23.347 19.352 21.875 19.352C21.295 19.352 20.848 19.122 20.211 18.349C19.715 17.747 18.868 16.471 17.379 13.991L16.762 12.963V12.962Z"></path>
    </symbol>
    <symbol
        id="icon-ui-migrated"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_490)">
            <path
                d="M24.794 14.696L26.124 17C27.664 19.667 25.739 23 22.66 23H16.414L18.707 25.293L17.293 26.707L12.586 22L17.293 17.293L18.707 18.707L16.414 21H22.66C24.2 21 25.162 19.333 24.392 18L23.062 15.696L24.794 14.696ZM5.34 23H8V21H5.34C3.8 21 2.83801 19.333 3.60801 18L6.731 12.591L7.57 15.723L9.502 15.205L7.779 8.77501L1.349 10.498L1.867 12.43L4.99901 11.591L1.876 17C0.336005 19.667 2.261 23 5.34 23ZM21.426 4.27701L20.587 7.40901L17.464 2.00001C15.924 -0.666994 12.075 -0.666994 10.536 2.00001L9.20601 4.30401L10.938 5.30401L12.268 3.00001C13.038 1.66701 14.962 1.66701 15.732 3.00001L18.855 8.40901L15.723 7.57001L15.205 9.50201L21.635 11.225L23.358 4.79501L21.426 4.27701Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_490">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-minus-small"
        viewBox="0 0 28 28">
        <path d="M6 14H24V16H6V14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-overlap"
        viewBox="0 0 28 28">
        <path
            d="M8 8V16H16V8H8ZM10 18H8C6.895 18 6 17.105 6 16V8C6 6.895 6.895 6 8 6H16C17.105 6 18 6.895 18 8V10H20C21.105 10 22 10.895 22 12V20C22 21.105 21.105 22 20 22H12C10.895 22 10 21.105 10 20V18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-override"
        viewBox="0 0 28 28">
        <path
            d="M6 4V10H12V8H9.609C10.521 6.786 11.974 6 13.61 6C16.029 6 18.048 7.718 18.511 10.001H20.541C20.056 6.608 17.138 4 13.61 4C11.315 4 9.277 5.104 8.001 6.811V4H6Z"></path>
        <path
            d="M6.923 14L3.072 23.629C3.023 23.751 3 23.877 3 24H5.077L5.877 22H10.123L10.923 24H13C13 23.876 12.977 23.75 12.928 23.629L9.077 14H6.923ZM9.323 20H6.677L8 16.693L9.323 20Z"></path>
        <path
            d="M16.072 23.629L19.923 14H22.077L25.928 23.629C25.977 23.751 26 23.877 26 24H23.923L23.123 22H18.877L18.077 24H16C16 23.876 16.023 23.75 16.072 23.629ZM21 16.693L19.677 20H22.323L21 16.693Z"></path>
    </symbol>
    <symbol
        id="icon-ui-padding_bottom"
        viewBox="0 0 28 28">
        <path d="M8 20V18H20V20H8Z"></path>
        <path d="M13 18V12H15V18H13Z"></path>
    </symbol>
    <symbol
        id="icon-ui-padding_left"
        viewBox="0 0 28 28">
        <path d="M8 8H10V20H8V8Z"></path>
        <path d="M10 13H16V15H10V13Z"></path>
    </symbol>
    <symbol
        id="icon-ui-padding_right"
        viewBox="0 0 28 28">
        <path d="M20 8H18V20H20V8Z"></path>
        <path d="M18 13H12V15H18V13Z"></path>
    </symbol>
    <symbol
        id="icon-ui-padding_separate"
        viewBox="0 0 28 28">
        <path d="M10 4H18V6H10V4Z"></path>
        <path d="M10 22H18V24H10V22Z"></path>
        <path d="M4 10H6V18H4V10Z"></path>
        <path d="M22 10H24V18H22V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-padding_top"
        viewBox="0 0 28 28">
        <path d="M20 8V10H8V8H20Z"></path>
        <path d="M15 10V16H13V10H15Z"></path>
    </symbol>
    <symbol
        id="icon-ui-padding-bottom"
        viewBox="0 0 28 28">
        <path
            d="M15.485 20.06L17.845 10.622C17.912 10.354 17.749 10.083 17.481 10.016C17.441 10.006 17.401 10.001 17.36 10.001H12.641C12.365 10.001 12.141 10.225 12.141 10.501C12.141 10.542 12.146 10.583 12.156 10.622L14.516 20.06C14.583 20.328 14.854 20.491 15.122 20.424C15.301 20.379 15.441 20.239 15.486 20.06H15.485Z"></path>
    </symbol>
    <symbol
        id="icon-ui-padding-left"
        viewBox="0 0 28 28">
        <path
            d="M9.94008 15.485L19.3781 17.845C19.6461 17.912 19.9171 17.749 19.9841 17.481C19.9941 17.441 19.9991 17.401 19.9991 17.36V12.641C19.9991 12.365 19.7751 12.141 19.4991 12.141C19.4581 12.141 19.4171 12.146 19.3781 12.156L9.94008 14.516C9.67208 14.583 9.50908 14.854 9.57608 15.122C9.62108 15.301 9.76108 15.441 9.94008 15.486V15.485Z"></path>
    </symbol>
    <symbol
        id="icon-ui-padding-right"
        viewBox="0 0 28 28">
        <path
            d="M20.06 15.485L10.622 17.845C10.354 17.912 10.083 17.749 10.016 17.481C10.006 17.441 10.001 17.401 10.001 17.36V12.641C10.001 12.365 10.225 12.141 10.501 12.141C10.542 12.141 10.583 12.146 10.622 12.156L20.06 14.516C20.328 14.583 20.491 14.854 20.424 15.122C20.379 15.301 20.239 15.441 20.06 15.486V15.485Z"></path>
    </symbol>
    <symbol
        id="icon-ui-padding-top"
        viewBox="0 0 28 28">
        <path
            d="M15.4851 9.94L17.8451 19.378C17.9121 19.646 17.7491 19.917 17.4811 19.984C17.4411 19.994 17.4011 19.999 17.3601 19.999H12.6411C12.3651 19.999 12.1411 19.775 12.1411 19.499C12.1411 19.458 12.1461 19.417 12.1561 19.378L14.5161 9.94C14.5831 9.672 14.8541 9.509 15.1221 9.576C15.3011 9.621 15.4411 9.761 15.4861 9.94H15.4851Z"></path>
    </symbol>
    <symbol
        id="icon-ui-pangle"
        viewBox="0 0 28 28">
        <path
            d="M21.694 14.331L18.854 12.706C18.793 12.672 18.717 12.713 18.717 12.788V16.83C18.717 16.905 18.758 16.967 18.819 17.007L21.659 18.632C21.721 18.666 21.796 18.625 21.796 18.55V14.508C21.796 14.433 21.755 14.371 21.694 14.331Z"></path>
        <path
            d="M17.728 12.094L14.888 10.469C14.827 10.435 14.751 10.476 14.751 10.551V16.839C14.751 16.894 14.792 16.935 14.847 16.935H17.742C17.797 16.935 17.838 16.894 17.838 16.839V12.272C17.831 12.197 17.79 12.129 17.729 12.095L17.728 12.094Z"></path>
        <path
            d="M11.011 18.613L13.851 16.988C13.912 16.954 13.953 16.886 13.953 16.81V10.092C13.953 10.024 13.878 9.976 13.816 10.01L10.976 11.635C10.915 11.669 10.874 11.737 10.874 11.812V18.53C10.874 18.605 10.949 18.646 11.011 18.612V18.613Z"></path>
        <path
            d="M22.5879 15.007V16.85C22.5879 16.905 22.6289 16.946 22.6839 16.946H25.9059C26.0019 16.946 26.0359 16.816 25.9539 16.775L22.7319 14.932C22.6639 14.891 22.5889 14.939 22.5889 15.007H22.5879Z"></path>
        <path
            d="M9.93797 12.23L2.04597 16.756C1.96397 16.804 1.99797 16.927 2.09397 16.927H9.98597C10.041 16.927 10.082 16.886 10.082 16.831V12.311C10.075 12.236 9.99997 12.195 9.93897 12.229L9.93797 12.23Z"></path>
    </symbol>
    <symbol
        id="icon-ui-past"
        viewBox="0 0 28 28">
        <path
            d="M15 4C21.075 4 26 8.925 26 15C26 21.075 21.075 26 15 26C10.418 26 6.49098 23.199 4.83698 19.215L6.65298 18.368C7.99698 21.679 11.228 24 15 24C19.971 24 24 19.971 24 15C24 10.029 19.971 6 15 6C12.179 6 9.66198 7.298 8.01198 9.328L10.654 11.519L4.00098 12.584V5.999L6.47498 8.049C8.49198 5.577 11.562 3.999 15.001 3.999L15 4ZM16 8.4L15.998 14.382L20.342 16.553L19.448 18.342L14.001 15.62V8.4H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-pin"
        viewBox="0 0 28 28">
        <path d="M17 16L16 24H14L13 16H10V4H20V16H17Z"></path>
    </symbol>
    <symbol
        id="icon-ui-pinterest"
        viewBox="0 0 28 28">
        <path
            d="M14 2C7.373 2 2 7.372 2 14C2 19.084 5.163 23.425 9.627 25.174C9.523 24.224 9.428 22.769 9.669 21.732C9.887 20.796 11.076 15.767 11.076 15.767C11.076 15.767 10.718 15.048 10.718 13.986C10.718 12.317 11.685 11.072 12.889 11.072C13.912 11.072 14.407 11.84 14.407 12.762C14.407 13.791 13.752 15.33 13.414 16.758C13.131 17.952 14.013 18.926 15.191 18.926C17.324 18.926 18.963 16.677 18.963 13.431C18.963 10.558 16.899 8.549 13.951 8.549C10.537 8.549 8.532 11.11 8.532 13.757C8.532 14.788 8.929 15.894 9.425 16.495C9.524 16.614 9.538 16.719 9.509 16.839C9.418 17.219 9.215 18.033 9.175 18.201C9.123 18.42 9.001 18.467 8.774 18.361C7.275 17.664 6.338 15.473 6.338 13.712C6.338 9.927 9.088 6.451 14.267 6.451C18.43 6.451 21.665 9.417 21.665 13.382C21.665 17.517 19.058 20.845 15.438 20.845C14.223 20.845 13.079 20.214 12.688 19.467C12.688 19.467 12.086 21.759 11.941 22.32C11.67 23.362 10.939 24.669 10.45 25.466C11.573 25.813 12.766 26.001 14.003 26.001C20.63 26.001 26.003 20.628 26.003 14.001C26.003 7.374 20.63 2.001 14.003 2.001L14 2Z"></path>
    </symbol>
    <symbol
        id="icon-ui-pixel"
        viewBox="0 0 28 28">
        <path
            d="M26 22V26H22V22H26ZM10 20V26H4V20H10ZM18 22V26H14V22H18ZM18 12V18H12V12H18ZM10 12V18H4V12H10ZM26 14V18H22V14H26ZM10 4V10H4V4H10ZM18 4V10H12V4H18ZM26 4V10H20V4H26Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-end-small"
        viewBox="0 0 28 28">
        <path d="M8.00806 6V24L17.7001 15L8.00806 6ZM20.0001 24H22.0001V6H20.0001V24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-jump-sec-back"
        viewBox="0 0 28 28">
        <path
            d="M16 4.044V1L10.01 5L16 9V6.054C20.505 6.547 24.01 10.364 24.01 15C24.01 17.488 23.001 19.74 21.369 21.369L22.783 22.783C24.776 20.792 26.01 18.04 26.01 15C26.01 9.259 21.611 4.545 16 4.044ZM16 22V12.003H14C13.629 12.199 12.966 12.64 12.009 13.327L12 15.269C13.047 14.553 13.696 14.127 13.947 13.991H13.991L14 22H16ZM10 1L4.01001 5L10 9V1Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-jump-sec-forward"
        viewBox="0 0 28 28">
        <path
            d="M10 14H12V16H10V18H8V16H6V14H8V12H10V14ZM20.019 20H18.019L18.01 11.991H17.966C17.714 12.127 17.065 12.553 16.019 13.269L16.028 11.327C16.985 10.64 17.649 10.199 18.019 10.003H20.019V20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-pause"
        viewBox="0 0 28 28">
        <path d="M24 4V26H16V4H24ZM10 4V26H2V4H10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-pause-small"
        viewBox="0 0 28 28">
        <path d="M20 6V22H14V6H20ZM10 6V22H4V6H10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-play"
        viewBox="0 0 28 28">
        <path d="M2 2V28L28 15L2 2Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-play-small"
        viewBox="0 0 28 28">
        <path d="M6 6V24L24 15L6 6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-rec"
        viewBox="0 0 28 28">
        <path
            d="M22 15C22 18.866 18.866 22 15 22C11.134 22 8 18.866 8 15C8 11.134 11.134 8 15 8C18.866 8 22 11.134 22 15Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-start"
        viewBox="0 0 28 28">
        <path d="M24 2V28L10 15L24 2ZM6 28H4V2H6V28Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-start-small"
        viewBox="0 0 28 28">
        <path d="M21.992 6V24L12.3 15L21.992 6ZM10 24H8V6H10V24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-step"
        viewBox="0 0 28 28">
        <path d="M18 2V28L4 15L18 2ZM24 28H22V2H24V28Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-step-left-small"
        viewBox="0 0 28 28">
        <path d="M15.992 6V24L6.30005 15L15.992 6ZM22 24H20V6H22V24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-playback-step-right-small"
        viewBox="0 0 28 28">
        <path d="M14.008 6V24L23.7 15L14.008 6ZM8 24H10V6H8V24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-plus"
        viewBox="0 0 28 28">
        <path d="M16 14H26V16H16V26H14V16H4V14H14V4H16V14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-plus-small"
        viewBox="0 0 28 28">
        <path d="M16 14H24V16H16V24H14V16H6V14H14V6H16V14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-plus-tiny"
        viewBox="0 0 28 28">
        <path d="M16 8V14H22V16H16V22H14V16H8V14H14V8H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-preview_ads"
        viewBox="0 0 28 28">
        <path d="M4 4H12V6H6V12H4V4Z"></path>
        <path d="M4 18V26H12V24H6V18H4Z"></path>
        <path d="M24 6H18V4H26V12H24V6Z"></path>
        <path
            d="M18 24C14.686 24 12 21.314 12 18C12 14.686 14.686 12 18 12C21.314 12 24 14.686 24 18C24 19.296 23.589 20.496 22.891 21.477L25.704 24.29C26.094 24.68 26.094 25.314 25.704 25.704C25.314 26.094 24.68 26.094 24.29 25.704L21.477 22.891C20.496 23.589 19.296 24 18 24ZM18 22C20.209 22 22 20.209 22 18C22 15.791 20.209 14 18 14C15.791 14 14 15.791 14 18C14 20.209 15.791 22 18 22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-progress"
        viewBox="0 0 28 28">
        <path
            d="M8 15.5C7.172 15.5 6.5 14.828 6.5 14C6.5 13.172 7.172 12.5 8 12.5C8.828 12.5 9.5 13.172 9.5 14C9.5 14.828 8.828 15.5 8 15.5ZM14 15.5C13.172 15.5 12.5 14.828 12.5 14C12.5 13.172 13.172 12.5 14 12.5C14.828 12.5 15.5 13.172 15.5 14C15.5 14.828 14.828 15.5 14 15.5ZM20 15.5C19.172 15.5 18.5 14.828 18.5 14C18.5 13.172 19.172 12.5 20 12.5C20.828 12.5 21.5 13.172 21.5 14C21.5 14.828 20.828 15.5 20 15.5Z"></path>
    </symbol>
    <symbol
        id="icon-ui-question-mark"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_578)">
            <path
                d="M14 28C6.268 28 0 21.732 0 14C0 6.268 6.268 0 14 0C21.732 0 28 6.268 28 14C28 21.732 21.732 28 14 28ZM9.336 11.194H11.992C12.002 10.107 12.638 9.266 13.868 9.266C14.801 9.266 15.683 9.758 15.683 10.917C15.683 11.86 15.068 12.301 14.104 12.968C12.925 13.758 12.187 14.752 12.299 16.311L12.32 16.885H14.904V16.362C14.904 15.234 15.365 14.906 16.565 14.065C17.56 13.368 18.616 12.558 18.616 10.763C18.616 8.23 16.483 7 14.033 7C11.654 7 9.233 8.148 9.336 11.194ZM12.023 19.971C12.023 20.873 12.761 21.478 13.653 21.478C14.545 21.478 15.283 20.873 15.283 19.971C15.283 19.079 14.545 18.474 13.653 18.474C12.761 18.474 12.023 19.079 12.023 19.971Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_578">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-question-mark-s"
        viewBox="0 0 28 28">
        <path
            d="M15 4C21.075 4 26 8.925 26 15C26 21.075 21.075 26 15 26C8.925 26 4 21.075 4 15C4 8.925 8.925 4 15 4ZM15.038 19.657C14.247 19.657 13.605 20.263 13.605 21.037C13.605 21.811 14.247 22.417 15.038 22.417C15.838 22.417 16.479 21.811 16.479 21.037C16.479 20.263 15.837 19.657 15.038 19.657ZM15.371 9.2C12.673 9.2 11.143 10.712 11.1 12.874H13.482C13.535 11.881 14.203 11.239 15.213 11.239C16.215 11.239 16.883 11.845 16.883 12.68C16.883 13.515 16.54 13.946 15.406 14.622C14.193 15.334 13.71 16.125 13.824 17.505L13.842 18.015H16.171V17.549C16.171 16.688 16.496 16.257 17.665 15.58C18.904 14.85 19.546 13.928 19.546 12.601C19.546 10.597 17.885 9.2 15.371 9.2Z"></path>
    </symbol>
    <symbol
        id="icon-ui-rearrange"
        viewBox="0 0 28 28">
        <path d="M4 16H24V18H4V16ZM4 10H24V12H4V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-repeat"
        viewBox="0 0 28 28">
        <path
            d="M16 10V14L21 9L16 4V8H11C7.134 8 4 11.134 4 15C4 16.933 4.784 18.683 6.05 19.95L7.464 18.536C6.559 17.631 6 16.381 6 15C6 12.239 8.239 10 11 10H16Z"></path>
        <path
            d="M22.536 11.464C23.441 12.369 24 13.619 24 15C24 17.761 21.761 20 19 20H14V16L9 21L14 26V22H19C22.866 22 26 18.866 26 15C26 13.067 25.216 11.317 23.95 10.05L22.536 11.464Z"></path>
    </symbol>
    <symbol
        id="icon-ui-reply"
        viewBox="0 0 28 28">
        <path
            d="M22 8V16C22 18.209 20.209 20 18 20H8.832L12.193 23.362L10.779 24.776L5 18.997L10.779 13.22L12.193 14.634L8.824 17.999H18C19.105 17.999 20 17.104 20 15.999V7.999L22 8Z"></path>
    </symbol>
    <symbol
        id="icon-ui-restart-warning"
        viewBox="0 0 28 28">
        <path
            d="M26.0001 4H24.0001V8.675C22.8681 7.065 21.3201 5.779 19.5071 4.965C17.2191 3.937 14.6491 3.722 12.2231 4.356C9.79706 4.99 7.65906 6.433 6.16506 8.447C4.67106 10.461 3.91006 12.926 4.00906 15.432C4.10806 17.938 5.05906 20.335 6.70706 22.226C8.35406 24.117 10.5981 25.388 13.0671 25.829C15.5361 26.27 18.0811 25.854 20.2811 24.65C22.4811 23.446 24.2041 21.527 25.1631 19.21L23.3151 18.445C22.5301 20.341 21.1201 21.911 19.3201 22.896C17.5201 23.881 15.4371 24.221 13.4181 23.861C11.3981 23.5 9.56206 22.46 8.21406 20.913C6.86606 19.366 6.08706 17.405 6.00706 15.354C5.92706 13.303 6.54906 11.287 7.77106 9.639C8.99306 7.991 10.7421 6.81 12.7271 6.292C14.7121 5.774 16.8151 5.95 18.6871 6.791C20.2351 7.486 21.5481 8.602 22.4831 10.001H18.0001V12.001H26.0001V4ZM14.0001 10H16.0001V16H14.0001V10ZM14.0001 18H16.0001V20H14.0001V18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-root-folder"
        viewBox="0 0 28 28">
        <path
            d="M8 4H6V8H4V28H24V0H8V4ZM22 11.636H20V4H10V2H22V11.636ZM18 11.636H14.89L12.447 8H8V6H18V11.636ZM5.818 26.182V9.818H11.478L13.921 13.454H22.182V26.181L5.818 26.182Z"></path>
    </symbol>
    <symbol
        id="icon-ui-rotate-left"
        viewBox="0 0 28 28">
        <path
            d="M19.657 21.657L21.071 23.071C22.881 21.261 24 18.761 24 16C24 10.477 19.523 6 14 6H12V2L7 7L12 11.998V8H14C18.418 8 22 11.582 22 16C22 18.209 21.105 20.209 19.657 21.657ZM13 18C13.552 18 14 17.552 14 17C14 16.448 13.552 16 13 16C12.448 16 12 16.448 12 17C12 17.552 12.448 18 13 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-rotate-right"
        viewBox="0 0 28 28">
        <path
            d="M8.343 21.657L6.929 23.071C5.119 21.261 4 18.761 4 16C4 10.477 8.477 6 14 6H16V2L21 7L16 11.998V8H14C9.582 8 6 11.582 6 16C6 18.209 6.895 20.209 8.343 21.657ZM15 18C14.448 18 14 17.552 14 17C14 16.448 14.448 16 15 16C15.552 16 16 16.448 16 17C16 17.552 15.552 18 15 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-rotate-x"
        viewBox="0 0 28 28">
        <path
            d="M20 12H24V14H20V12ZM8.6 20L13.057 20.002C13.921 17.698 14.203 15.099 13.897 12.192C13.605 9.413 12.81 6.683 11.508 3.998H13.713C14.876 6.609 15.601 9.271 15.886 11.983C16.193 14.903 15.957 17.578 15.175 20H19.6L11.739 26L8.6 20ZM4 12H9V14H4V12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-rotate-y"
        viewBox="0 0 28 28">
        <path
            d="M16 20V24H14V20H16ZM8 8.6L7.998 13.057C10.302 13.921 12.901 14.203 15.808 13.897C18.587 13.605 21.317 12.81 24.002 11.508V13.713C21.391 14.876 18.729 15.601 16.017 15.886C13.097 16.193 10.422 15.957 8 15.175V19.6L2 11.739L8 8.6ZM16 4V9H14V4H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-rule-ab-split"
        viewBox="0 0 28 28">
        <path
            d="M24 4H18V6H22.586L15.465 13.121C14.902 13.684 14.139 14 13.344 14H4.00098V16H13.344C14.67 16 15.942 15.473 16.88 14.536L24.001 7.415V12.001H26.001V4.001H24.001L24 4ZM22.586 24L17.293 18.707L18.707 17.293L24 22.586V18H26V26H18V24H22.586Z"></path>
    </symbol>
    <symbol
        id="icon-ui-rule-rotation"
        viewBox="0 0 28 28">
        <path
            d="M13.5 4.101L13.501 6.124C9.24398 6.838 6.00098 10.54 6.00098 15C6.00098 19.971 10.03 24 15.001 24C17.737 24 20.187 22.779 21.838 20.853L23.594 21.868C21.578 24.387 18.478 26 15.001 26C8.92598 26 4.00098 21.075 4.00098 15C4.00098 9.434 8.13398 4.833 13.5 4.101ZM16.502 4.102C21.866 4.835 26 9.435 26 15C26 16.523 25.691 17.973 25.131 19.292L23.383 18.281C23.781 17.264 24 16.158 24 15C24 10.541 20.757 6.84 16.502 6.125V4.102Z"></path>
    </symbol>
    <symbol
        id="icon-ui-rule-schedule"
        viewBox="0 0 28 28">
        <path
            d="M22 6H20V4H18V6H10.001V4H8.001V6H6C4.9 6 4 6.9 4 8V24C4 25.1 4.9 26 6 26H22C23.1 26 24 25.1 24 24V8C24 6.9 23.1 6 22 6ZM22 24H6V10H22V24ZM14.02 22H16.02V12.003H14.02C13.464 12.297 12.029 13.327 12.029 13.327L12.02 15.269C12.02 15.269 13.59 14.196 13.967 13.991H14.011L14.02 22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-schedule"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_607)">
            <path
                d="M8 0V2H2C0.895 2 0 2.895 0 4V8H28V4C28 2.895 27.105 2 26 2H20V0H18V2H10V0H8ZM2 28C0.895 28 0 27.105 0 26V10H28V26C28 27.105 27.105 28 26 28H2ZM8 4H10V6H8V4ZM20 4V6H18V4H20ZM4 14V18H9V14H4ZM16.5 14H11.5V18H16.5V14ZM19 14V18H24V14H19ZM9 20H4V24H9V20ZM11.5 20V24H16.5V20H11.5ZM24 20H19V24H24V20Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_607">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-search"
        viewBox="0 0 28 28">
        <path
            d="M19.304 17.858L26 24.554L24.554 26L17.858 19.304C16.401 20.45 14.564 21.133 12.566 21.133C7.83502 21.133 3.99902 17.298 3.99902 12.566C3.99902 7.834 7.83402 3.999 12.566 3.999C17.297 3.999 21.133 7.834 21.133 12.566C21.133 14.563 20.45 16.401 19.304 17.858ZM12.567 19.133C16.194 19.133 19.134 16.193 19.134 12.566C19.134 8.939 16.194 5.999 12.567 5.999C8.94002 5.999 6.00002 8.939 6.00002 12.566C6.00002 16.193 8.94002 19.133 12.567 19.133Z"></path>
    </symbol>
    <symbol
        id="icon-ui-selection-tool"
        viewBox="0 0 28 28">
        <path d="M15.456 20L8 27.456V2L26 20H15.456Z"></path>
    </symbol>
    <symbol
        id="icon-ui-send"
        viewBox="0 0 28 28">
        <path
            d="M6.17202 6L13.049 10.814L21.301 6H6.17202ZM21.77 8.042L14 12.575V19.698L21.77 8.042ZM12 12.521L2.42602 5.82C2.06802 5.57 1.91402 5.116 2.04602 4.7C2.17802 4.284 2.56302 4.001 3.00002 4.001H25C25.369 4.001 25.708 4.204 25.882 4.529C26.056 4.854 26.037 5.249 25.832 5.556L13.832 23.556C13.588 23.923 13.132 24.086 12.71 23.958C12.288 23.83 12 23.442 12 23.001V12.521Z"></path>
    </symbol>
    <symbol
        id="icon-ui-send_fb"
        viewBox="0 0 28 28">
        <path
            d="M14.7889 4.414C14.7889 3.523 15.8659 3.077 16.4959 3.707L25.2929 12.504C25.6839 12.895 25.6839 13.528 25.2929 13.918L16.4959 22.715C15.8659 23.345 14.7889 22.899 14.7889 22.008V18.959C14.7889 18.517 14.4999 18.13 14.0649 18.05C12.3169 17.726 7.73793 17.305 4.05293 20.736C3.33493 21.405 2.00093 20.976 2.08993 19.999C3.01593 9.873 10.7979 8.645 13.7009 8.542C14.2879 8.521 14.7879 8.049 14.7879 7.461V4.415L14.7889 4.414Z"></path>
    </symbol>
    <symbol
        id="icon-ui-settings"
        viewBox="0 0 28 28">
        <path
            d="M21.641 14.98C21.682 14.66 21.713 14.34 21.713 14C21.713 13.66 21.682 13.34 21.641 13.02L23.81 11.37C24.005 11.22 24.057 10.95 23.933 10.73L21.877 7.27001C21.754 7.05001 21.476 6.97001 21.25 7.05001L18.69 8.05001C18.155 7.65001 17.58 7.32001 16.953 7.07001L16.562 4.42001C16.527 4.17701 16.311 3.99701 16.058 4.00001H11.946C11.689 4.00001 11.473 4.18001 11.442 4.42001L11.051 7.07001C10.424 7.32001 9.84797 7.66001 9.31397 8.05001L6.75397 7.05001C6.51797 6.96001 6.24997 7.05001 6.12697 7.27001L4.07097 10.73C3.93697 10.95 3.99897 11.22 4.19397 11.37L6.36297 13.02C6.32197 13.34 6.29097 13.67 6.29097 14C6.29097 14.33 6.32197 14.66 6.36297 14.98L4.19397 16.63C3.99897 16.78 3.94697 17.05 4.07097 17.27L6.12697 20.73C6.24997 20.95 6.52797 21.03 6.75397 20.95L9.31397 19.95C9.84897 20.35 10.424 20.68 11.051 20.93L11.442 23.58C11.473 23.82 11.689 24 11.946 24H16.058C16.315 24 16.531 23.82 16.562 23.58L16.953 20.93C17.58 20.68 18.156 20.34 18.69 19.95L21.25 20.95C21.486 21.04 21.754 20.95 21.877 20.73L23.933 17.27C24.056 17.05 24.005 16.78 23.81 16.63L21.641 14.98ZM14 18C11.794 18 9.99997 16.206 9.99997 14C9.99997 11.794 11.794 10 14 10C16.206 10 18 11.794 18 14C18 16.206 16.206 18 14 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-settings-filter"
        viewBox="0 0 28 28">
        <path d="M4 6H26V8H4V6Z"></path>
        <path d="M4 14H26V16H4V14Z"></path>
        <path d="M4 22H26V24H4V22Z"></path>
        <path
            d="M12 7C12 8.657 10.657 10 9 10C7.343 10 6 8.657 6 7C6 5.343 7.343 4 9 4C10.657 4 12 5.343 12 7Z"></path>
        <path
            d="M18 15C18 16.657 16.657 18 15 18C13.343 18 12 16.657 12 15C12 13.343 13.343 12 15 12C16.657 12 18 13.343 18 15Z"></path>
        <path
            d="M24 23C24 24.657 22.657 26 21 26C19.343 26 18 24.657 18 23C18 21.343 19.343 20 21 20C22.657 20 24 21.343 24 23Z"></path>
    </symbol>
    <symbol
        id="icon-ui-shape-arrow"
        viewBox="0 0 28 28">
        <path d="M4 8H10V3H12L24 14L12 25H10V20H4V8ZM6 10V18H12V22L21 14L12 6V10H6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-shape-oval"
        viewBox="0 0 28 28">
        <path
            d="M15 24C19.971 24 24 19.971 24 15C24 10.029 19.971 6 15 6C10.029 6 6 10.029 6 15C6 19.971 10.029 24 15 24ZM15 26C8.925 26 4 21.075 4 15C4 8.925 8.925 4 15 4C21.075 4 26 8.925 26 15C26 21.075 21.075 26 15 26Z"></path>
    </symbol>
    <symbol
        id="icon-ui-shape-rectangle"
        viewBox="0 0 28 28">
        <path d="M4 24V4H26V24H4ZM6 22H24V6H6V22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-shape-transition"
        viewBox="0 0 28 28">
        <path d="M22 6V22H6V6H22ZM20 8H8V20L20 8Z"></path>
    </symbol>
    <symbol
        id="icon-ui-shape-transition-clear"
        viewBox="0 0 28 28">
        <path
            d="M3.393 1.979L26.02 24.606L24.606 26.02L20.585 21.998L6 21.999L5.999 7.412L1.979 3.392L3.393 1.979ZM7.999 9.413L8 20L13.293 14.707L7.999 9.413ZM22 6L21.999 16.497L16.749 11.249L20 8L13.499 7.999L11.499 5.999L22 6Z"></path>
    </symbol>
    <symbol
        id="icon-ui-shape-triangle"
        viewBox="0 0 28 28">
        <path
            d="M15 8L6.92101 21.993H23.078L14.999 8H15ZM26.543 23.993H3.45801L15.001 4L26.544 23.993H26.543Z"></path>
    </symbol>
    <symbol
        id="icon-ui-share"
        viewBox="0 0 28 28">
        <path
            d="M6 12V24H24V12H20V14H22V22H8V14H10V12H6ZM14 18H16V7.44799L18.776 10.224L20 8.99999L14.999 3.99899L10 8.99999L11.224 10.224L14 7.44699V18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-share-alt"
        viewBox="0 0 28 28">
        <path
            d="M26 7C26 9.761 23.761 12 21 12C19.599 12 18.332 11.424 17.424 10.495L11.781 13.534C11.923 13.998 11.999 14.49 11.999 15C11.999 15.132 11.994 15.262 11.984 15.391L16.941 18.078C17.849 16.819 19.328 16 20.999 16C23.76 16 25.999 18.239 25.999 21C25.999 23.761 23.76 26 20.999 26C18.238 26 15.999 23.761 15.999 21C15.999 20.993 15.999 20.986 15.999 20.98L10.85 18.19C9.93302 19.296 8.54802 20.001 6.99902 20.001C4.23802 20.001 1.99902 17.762 1.99902 15.001C1.99902 12.24 4.23802 10.001 6.99902 10.001C8.15502 10.001 9.21902 10.393 10.065 11.051L16.065 7.819C16.021 7.553 15.998 7.279 15.998 7C15.998 4.239 18.237 2 20.998 2C23.759 2 25.998 4.239 25.998 7H26Z"></path>
    </symbol>
    <symbol
        id="icon-ui-share-blue"
        viewBox="0 0 28 28">
        <path d="M12.7271 6.364H15.2721V19.091H12.7271V6.364Z"></path>
        <path
            d="M14.001 6.79901L8.446 12.354L6.646 10.554L14.001 3.19901L21.354 10.555L19.554 12.355L14.001 6.79901Z"></path>
        <path d="M22.9089 22.909V20.364H25.4539V25.455H2.54492V20.364H5.08992V22.909H22.9089Z"></path>
    </symbol>
    <symbol
        id="icon-ui-shopping-cart"
        viewBox="0 0 28 28">
        <path
            d="M8.37101 25.637C7.78768 25.637 7.29168 25.433 6.88301 25.025C6.47435 24.617 6.27001 24.121 6.27001 23.537C6.27001 22.953 6.47435 22.4573 6.88301 22.05C7.29168 21.6427 7.78768 21.4383 8.37101 21.437C8.95435 21.4357 9.45001 21.64 9.85801 22.05C10.266 22.46 10.47 22.9557 10.47 23.537C10.47 24.1183 10.266 24.6143 9.85801 25.025C9.45001 25.4357 8.95435 25.6397 8.37101 25.637ZM20.037 25.637C19.4537 25.637 18.958 25.433 18.55 25.025C18.142 24.617 17.9377 24.121 17.937 23.537C17.9363 22.953 18.1407 22.4573 18.55 22.05C18.9593 21.6427 19.455 21.4383 20.037 21.437C20.619 21.4357 21.115 21.64 21.525 22.05C21.935 22.46 22.139 22.9557 22.137 23.537C22.135 24.1183 21.931 24.6143 21.525 25.025C21.119 25.4357 20.623 25.6397 20.037 25.637ZM6.85401 6.38799L10.062 13.038H18.462L22.108 6.38799H6.85401ZM5.97901 4.63799H23.158C23.6053 4.63799 23.9457 4.84199 24.179 5.24999C24.4123 5.65799 24.4123 6.06633 24.179 6.47499L20.241 13.562C20.027 13.9313 19.75 14.228 19.41 14.452C19.07 14.676 18.6957 14.7877 18.287 14.787H9.45001L7.81701 17.82H22.138V19.57H8.08001C7.26335 19.57 6.67501 19.2977 6.31501 18.753C5.95501 18.2083 5.96001 17.5957 6.33001 16.915L8.19701 13.473L3.76401 4.08099H1.48901V2.33099H4.90101L5.97901 4.63799Z"></path>
    </symbol>
    <symbol
        id="icon-ui-size"
        viewBox="0 0 28 28">
        <path
            d="M6 12H4L7 4L10 12H8V20H14V18L22 21L14 24V22H6V12ZM20 4C21.105 4 22 4.895 22 6V10H20V6H18V4H20ZM20 12H22V17L20 16.5V12ZM11 4H16V6H11.5L11 4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-skew"
        viewBox="0 0 28 28">
        <path
            d="M18 8H14V6H26V8H22L14 22H18V24H6V18H8V22H10L18 8ZM6 6H8V10H6V6ZM6 12H8V16H6V12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-skew-x"
        viewBox="0 0 28 28">
        <path
            d="M4 4L15.667 24H18L6.333 4H4ZM18.779 3.28L13 9.059L18.779 14.836L20.193 13.422L16.772 10H24V8H16.888L20.193 4.694L18.779 3.28ZM16 22H12V24H16V22ZM6 4H2V6H6V4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-skew-y"
        viewBox="0 0 28 28">
        <path
            d="M24 24L4 12.333V10L24 21.667V24ZM24.72 9.221L18.941 15L13.164 9.221L14.578 7.807L18 11.228V4H20V11.112L23.306 7.807L24.72 9.221ZM6 12V16H4V12H6ZM24 22V26H22V22H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-smartphone-14"
        viewBox="0 0 28 28">
        <path
            d="M19.833 1.178L8.16601 1.166C6.88301 1.166 5.83301 2.216 5.83301 3.499V24.499C5.83301 25.782 6.88301 26.832 8.16601 26.832H19.833C21.116 26.832 22.166 25.782 22.166 24.499V3.499C22.166 2.216 21.116 1.178 19.833 1.178ZM19.833 22.167H8.16601V5.834H19.833V22.167Z"></path>
    </symbol>
    <symbol
        id="icon-ui-smiley"
        viewBox="0 0 28 28">
        <path
            d="M14 4C19.523 4 24 8.477 24 14C24 19.523 19.523 24 14 24C8.477 24 4 19.523 4 14C4 8.477 8.477 4 14 4ZM14 6C9.582 6 6 9.582 6 14C6 18.418 9.582 22 14 22C18.418 22 22 18.418 22 14C22 9.582 18.418 6 14 6ZM9.293 15.093C9.684 14.702 10.317 14.702 10.707 15.093C11.867 16.253 12.961 16.8 14 16.8C15.039 16.8 16.133 16.253 17.293 15.093C17.684 14.702 18.317 14.702 18.707 15.093C19.097 15.484 19.098 16.117 18.707 16.507C17.2 18.014 15.628 18.8 14 18.8C12.372 18.8 10.799 18.014 9.293 16.507C8.902 16.116 8.902 15.483 9.293 15.093ZM11 9.7C11.718 9.7 12.3 10.282 12.3 11C12.3 11.718 11.718 12.3 11 12.3C10.282 12.3 9.7 11.718 9.7 11C9.7 10.282 10.282 9.7 11 9.7ZM17 9.7C17.718 9.7 18.3 10.282 18.3 11C18.3 11.718 17.718 12.3 17 12.3C16.282 12.3 15.7 11.718 15.7 11C15.7 10.282 16.282 9.7 17 9.7Z"></path>
    </symbol>
    <symbol
        id="icon-ui-snapchat"
        viewBox="0 0 28 28">
        <path
            d="M7.82901 5.833C7.22901 7.177 7.46601 9.585 7.56201 11.269C6.91401 11.628 6.08201 10.998 5.61101 10.998C5.12101 10.998 4.53601 11.32 4.44401 11.8C4.37801 12.146 4.53301 12.65 5.64501 13.089C6.07501 13.259 7.09801 13.459 7.33501 14.017C7.66801 14.801 5.62501 18.42 2.41701 18.948C2.16601 18.989 1.98701 19.213 2.00101 19.467C2.05701 20.442 4.24301 20.824 5.21201 20.974C5.31101 21.108 5.39101 21.674 5.51801 22.105C5.57501 22.298 5.72201 22.529 6.10001 22.529C6.59301 22.529 7.41201 22.149 8.83801 22.385C10.236 22.618 11.55 24.6 14.073 24.6C16.418 24.6 17.817 22.609 19.163 22.385C19.942 22.256 20.611 22.297 21.359 22.443C21.874 22.544 22.336 22.6 22.483 22.094C22.612 21.657 22.691 21.102 22.788 20.971C23.748 20.822 25.944 20.441 25.999 19.466C26.013 19.212 25.834 18.989 25.583 18.947C22.429 18.427 20.324 14.819 20.665 14.016C20.901 13.459 21.917 13.261 22.355 13.088C23.169 12.767 23.577 12.372 23.568 11.915C23.557 11.33 22.853 10.981 22.335 10.981C21.808 10.981 21.051 11.605 20.438 11.267C20.534 9.569 20.77 7.172 20.171 5.829C19.036 3.286 16.511 2 13.987 2C11.479 2 8.97301 3.268 7.82901 5.833Z"></path>
    </symbol>
    <symbol
        id="icon-ui-social-campaign"
        viewBox="0 0 28 28">
        <path
            d="M20 10C18.84 10 17.795 9.506 17.064 8.717L11.789 11.558C11.926 12.015 12 12.499 12 13.001C12 13.503 11.926 13.987 11.789 14.444L17.064 17.285C17.795 16.496 18.84 16.002 20 16.002C22.209 16.002 24 17.793 24 20.002C24 22.211 22.209 24.002 20 24.002C17.791 24.002 16 22.211 16 20.002C16 19.672 16.04 19.352 16.115 19.046L10.839 16.205C9.922 17.303 8.542 18.002 7 18.002C4.239 18.002 2 15.763 2 13.002C2 10.241 4.239 8.002 7 8.002C8.543 8.002 9.922 8.701 10.839 9.799L16.115 6.958C16.04 6.652 16 6.331 16 6.002C16 3.793 17.791 2.002 20 2.002C22.209 2.002 24 3.793 24 6.002C24 8.211 22.209 10.002 20 10.002V10ZM9.965 12.539C9.958 12.491 9.949 12.443 9.939 12.395C9.809 11.76 9.478 11.198 9.016 10.778C8.483 10.294 7.776 9.999 7 9.999C5.343 9.999 4 11.342 4 12.999C4 14.656 5.343 15.999 7 15.999C7.776 15.999 8.484 15.704 9.016 15.22C9.052 15.187 9.087 15.154 9.121 15.12C9.561 14.68 9.865 14.103 9.965 13.459C9.988 13.309 10 13.155 10 12.998C10 12.841 9.988 12.687 9.965 12.537V12.539Z"></path>
    </symbol>
    <symbol
        id="icon-ui-social-fx"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_664)">
            <path
                d="M6.34302 0V4H10.343V6H6.34302V10H4.34302V6H0.343018V4H4.34302V0H6.34302ZM14.343 0V2H12.343V4H14.343V6H16.343V4H18.343V2H16.343V0H14.343ZM6.34302 16V18H4.34302V20H6.34302V22H8.34302V20H10.343V18H8.34302V16H6.34302ZM11.172 8L27.657 24.485L24.829 27.314L8.34402 10.829L11.172 8.001V8Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_664">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-sort"
        viewBox="0 0 28 28">
        <path d="M24 4H4V6H24V4ZM20 10H4V12H20V10ZM4 16H16V18H4V16ZM12 22H4V24H12V22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-status-dot"
        viewBox="0 0 28 28">
        <path
            d="M10 14C10 16.209 11.791 18 14 18C16.209 18 18 16.209 18 14C18 11.791 16.209 10 14 10C11.791 10 10 11.791 10 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-strikethrough"
        viewBox="0 0 28 28">
        <path
            d="M17.209 16H2V14H26V16H20.233C20.593 16.65 20.787 17.43 20.787 18.376C20.787 22.079 17.659 24 13.774 24C8.809 24 7.07 20.928 7 18.516H9.118C9.3 20.409 10.885 22.092 14.041 22.092C16.818 22.092 18.641 20.718 18.641 18.516C18.641 17.376 18.176 16.579 17.209 16ZM8.309 12C7.859 11.31 7.589 10.462 7.589 9.428C7.589 5.922 10.703 4 14.083 4C17.295 4 20.493 5.697 20.563 9.33H18.459C18.291 7.451 16.874 5.908 14.041 5.908C11.53 5.908 9.721 7.128 9.721 9.288C9.721 10.514 10.329 11.43 11.599 12H8.309Z"></path>
    </symbol>
    <symbol
        id="icon-ui-styles-lorum-ipsum-view"
        viewBox="0 0 28 28">
        <path d="M4 4H24V8H4V4ZM4 20H24V24H4V20ZM4 10H24V18H4V10Z"></path>
    </symbol>
    <symbol
        id="icon-ui-styles-minimal-view"
        viewBox="0 0 28 28">
        <path d="M4 12V10H24V12H4ZM4 6V4H24V6H4ZM4 18V16H24V18H4ZM4 24V22H24V24H4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-swap"
        viewBox="0 0 28 28">
        <path
            d="M7.16292 13.837L3.91992 17.092C3.69792 17.325 3.69792 17.687 3.91992 17.92L7.16292 21.175C7.52492 21.548 8.15492 21.28 8.15492 20.767V18.667H15.1669C15.8089 18.667 16.3339 18.142 16.3339 17.5C16.3339 16.858 15.8089 16.333 15.1669 16.333H8.15492V14.245C8.15492 13.72 7.52492 13.463 7.16292 13.837ZM24.0919 10.092L20.8489 6.837C20.4869 6.464 19.8569 6.732 19.8569 7.245V9.333H12.8339C12.1919 9.333 11.6669 9.858 11.6669 10.5C11.6669 11.142 12.1919 11.667 12.8339 11.667H19.8459V13.755C19.8459 14.28 20.4759 14.537 20.8379 14.163L24.0809 10.908C24.3139 10.686 24.3139 10.313 24.0929 10.091L24.0919 10.092Z"></path>
    </symbol>
    <symbol
        id="icon-ui-sync"
        viewBox="0 0 28 28">
        <path
            d="M14.0071 8.335V5.8L10.6741 9.179L14.0071 12.558V10.023C16.7651 10.023 19.0071 12.296 19.0071 15.092C19.0071 15.945 18.7991 16.756 18.4241 17.458L19.6411 18.691C20.2911 17.652 20.6741 16.418 20.6741 15.092C20.6741 11.358 17.6911 8.333 14.0071 8.333V8.335ZM14.0071 20.163C11.2491 20.163 9.00709 17.89 9.00709 15.094C9.00709 14.241 9.21509 13.43 9.59009 12.728L8.37309 11.495C7.72309 12.534 7.34009 13.768 7.34009 15.094C7.34009 18.828 10.3231 21.853 14.0071 21.853V24.388L17.3401 21.009L14.0071 17.63V20.165V20.163Z"></path>
    </symbol>
    <symbol
        id="icon-ui-sync-l"
        viewBox="0 0 28 28">
        <path
            d="M5.216 9.217L6.707 10.707C6.253 11.711 6 12.826 6 14C6 18.284 9.368 21.782 13.601 21.99L14 21.998V17.999L19 22.999L14 27.999V23.999C8.477 23.999 4 19.522 4 13.999C4 12.266 4.441 10.636 5.216 9.216V9.217ZM14 0V4C19.523 4 24 8.477 24 14C24 15.733 23.559 17.363 22.784 18.783L21.293 17.293C21.747 16.289 22 15.174 22 14C22 9.582 18.418 6 14 6V10L9 5L14 0Z"></path>
    </symbol>
    <symbol
        id="icon-ui-sync-large"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_682)">
            <path
                d="M14 -7.08003e-06C15.799 -7.08003e-06 17.534 0.338993 19.206 1.01599C20.878 1.69299 22.359 2.64599 23.65 3.87299L27.551 0.896993C27.639 0.829993 27.764 0.846993 27.831 0.934993C27.863 0.976993 27.877 1.03099 27.87 1.08299L26.693 9.70699C26.678 9.81599 26.578 9.89299 26.469 9.87799L17.813 8.72999C17.704 8.71499 17.627 8.61499 17.641 8.50499C17.648 8.45199 17.676 8.40499 17.718 8.37199L22.032 5.07799C19.725 3.02499 17.048 1.99899 14 1.99899C10.698 1.99899 7.873 3.17399 5.524 5.52299C3.175 7.87199 2 10.698 2 13.999H0C0 10.147 1.37 6.85099 4.111 4.10999C6.852 1.36899 10.148 -0.00100708 14 -0.00100708V-7.08003e-06ZM1.532 18.122L10.187 19.27C10.296 19.285 10.373 19.385 10.359 19.495C10.352 19.548 10.324 19.595 10.282 19.628L5.968 22.922C6.92 23.769 8.18 24.493 9.746 25.097C11.312 25.701 12.73 26.002 14 26.002C17.302 26.002 20.127 24.827 22.476 22.478C24.825 20.129 26 17.303 26 14.002H28C28 17.854 26.63 21.15 23.889 23.891C21.148 26.632 17.852 28.002 14 28.002C12.984 28.002 11.868 27.827 10.651 27.478C9.434 27.129 8.265 26.658 7.143 26.065C6.021 25.472 5.09 24.827 4.349 24.128L0.479 27.103C0.391 27.17 0.266 27.154 0.199 27.066C0.167 27.024 0.152 26.97 0.159 26.918L1.307 18.295C1.322 18.186 1.422 18.108 1.532 18.122Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_682">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-sync-small"
        viewBox="0 0 28 28">
        <path
            d="M13.065 7.25501C14.386 7.23201 15.686 7.58401 16.816 8.26901C17.565 8.72301 18.219 9.31201 18.746 10.002H16V12.002H22V6.00201H20V8.37501C19.387 7.66501 18.664 7.05101 17.853 6.55901C16.401 5.67801 14.729 5.22601 13.03 5.25501C11.331 5.28401 9.67602 5.79301 8.25502 6.72401C6.83402 7.65401 5.70502 8.968 4.99902 10.513L6.81802 11.344C7.36702 10.142 8.24502 9.12101 9.35002 8.39701C10.455 7.67301 11.744 7.27701 13.065 7.25501Z"></path>
        <path
            d="M10 18V16H4V22H6V19.627C6.613 20.338 7.336 20.951 8.147 21.443C9.599 22.324 11.271 22.776 12.97 22.747C14.669 22.718 16.324 22.209 17.745 21.278C19.166 20.348 20.295 19.034 21.001 17.489L19.182 16.658C18.633 17.86 17.755 18.881 16.65 19.605C15.545 20.329 14.257 20.725 12.936 20.748C11.615 20.771 10.315 20.419 9.185 19.734C8.436 19.28 7.782 18.691 7.255 18.001H10.001L10 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text"
        viewBox="0 0 28 28">
        <path d="M4 4V8H6V6H14V24H12V26H18V24H16V6H24V8H26V4H4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-align-h-center"
        viewBox="0 0 28 28">
        <path d="M4 22H26V24H4V22ZM8 16H22V18H8V16ZM4 10H26V12H4V10ZM8 4H22V6H8V4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-align-h-justify"
        viewBox="0 0 28 28">
        <path d="M2 22H26V24H2V22ZM2 16H26V18H2V16ZM2 10H26V12H2V10ZM2 4H26V6H2V4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-align-h-left"
        viewBox="0 0 28 28">
        <path d="M4 10H26V12H4V10ZM4 4H20V6H4V4ZM4 16H20V18H4V16ZM4 22H26V24H4V22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-align-h-right"
        viewBox="0 0 28 28">
        <path d="M26 10H4V12H26V10ZM26 4H10V6H26V4ZM26 16H10V18H26V16ZM26 22H4V24H26V22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-align-v-bottom"
        viewBox="0 0 28 28">
        <path
            d="M16 15.172V6H14V15.171L10.636 11.807L9.222 13.221L15.001 19L20.778 13.221L19.364 11.807L16 15.172ZM24 24V22H6V24H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-align-v-full-hight"
        viewBox="0 0 28 28">
        <path
            d="M9.634 14.193L8.22 12.779L13.999 7L19.776 12.779L18.362 14.193L13.999 9.828L9.634 14.193ZM9.634 15.8L13.999 20.165L18.362 15.8L19.776 17.214L13.999 22.993L8.22 17.214L9.634 15.8ZM24 24V26H4V24H24ZM24 4V6H4V4H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-align-v-middle"
        viewBox="0 0 28 28">
        <path
            d="M10.636 26.193L9.222 24.779L15.001 19L20.778 24.779L19.364 26.193L15.001 21.828L10.636 26.193ZM10.636 3.79999L15.001 8.16499L19.364 3.79999L20.778 5.21399L15.001 10.993L9.222 5.21399L10.636 3.79999ZM24 14V16H6V14H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-align-v-top"
        viewBox="0 0 28 28">
        <path
            d="M16 14.828V24H14V14.829L10.636 18.193L9.222 16.779L15.001 11L20.778 16.779L19.364 18.193L16 14.828ZM24 6V8H6V6H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-style-apply-formatting"
        viewBox="0 0 28 28">
        <path
            d="M20.5 5C20.5 4.448 20.948 4 21.5 4H22.5C23.052 4 23.5 4.448 23.5 5V16H20.5V5ZM18 6H2V10H8.6L4.1 22H9L13.5 10H18V6ZM19.67 20.2C19.67 18.659 20.45 17.7 21.991 17.7C23.532 17.7 24.312 18.659 24.312 20.2C24.312 22.986 22.186 24.2 20.133 24.2C18.731 24.2 17.273 23.476 16.419 22.343C18.276 22.807 19.67 21.417 19.67 20.2Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-styles-character-spacing"
        viewBox="0 0 28 28">
        <path
            d="M6 4V24H4V4H6ZM24 4V24H22V4H24ZM15.228 7.5L19.5 20H17.391L16.706 18H11.244L10.57 20H8.5L12.792 7.5H15.228ZM14.012 9.615C14.004 9.683 13.904 10.027 13.711 10.649L11.94 16H16.06L14.313 10.649C14.158 10.185 14.057 9.84 14.012 9.615Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-styles-clear-formatting"
        viewBox="0 0 28 28">
        <path
            d="M6.0001 7.41401L4.4541 5.86801L5.8681 4.45401L23.5461 22.132L22.1321 23.546L15.4331 16.847L13.5011 22H9.0011L12.1611 13.574L8.5871 10H6.0011L6.0001 7.41401ZM10.1141 6.00001H24.0001V10H18.0001L16.9401 12.826L10.1141 6.00001Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-styles-line-spacing"
        viewBox="0 0 28 28">
        <path
            d="M24 22V24H4V22H24ZM15.398 8L19.5 20H17.391L16.706 18H11.244L10.57 20H8.5L12.618 8H15.398ZM14.012 9.615C14.004 9.683 13.904 10.027 13.711 10.649L11.94 16H16.06L14.313 10.649C14.158 10.185 14.057 9.84 14.012 9.615ZM24 4V6H4V4H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-styles-paragraph-spacing"
        viewBox="0 0 28 28">
        <path
            d="M24 24V26H4V24H24ZM24 20V22H4V20H24ZM18.8 14L14 18L9.2 14H18.8ZM14 8L18.8 12H9.2L14 8ZM24 4V6H4V4H24Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-styles-subscript"
        viewBox="0 0 28 28">
        <path
            d="M21.965 14.414C23.027 14.414 23.879 14.691 24.52 15.246C25.161 15.801 25.481 16.547 25.481 17.484C25.481 18 25.389 18.489 25.204 18.953C25.019 19.417 24.735 19.894 24.352 20.387C23.969 20.879 23.332 21.545 22.442 22.383L20.458 24.305V24.383H25.88V26H18.138V24.609L21.083 21.648C21.953 20.757 22.53 20.126 22.813 19.753C23.096 19.38 23.304 19.03 23.434 18.702C23.564 18.374 23.629 18.022 23.629 17.647C23.629 17.131 23.474 16.725 23.164 16.428C22.854 16.131 22.426 15.983 21.879 15.983C21.441 15.983 21.018 16.064 20.609 16.225C20.2 16.386 19.727 16.678 19.191 17.1L18.199 15.889C18.834 15.353 19.452 14.972 20.051 14.748C20.65 14.524 21.288 14.412 21.965 14.412V14.414ZM9.78898 6L16 22H13.699L12.155 18.019L5.78698 18.017L4.25898 22H2.00098L8.24498 6H9.78998H9.78898ZM8.99198 9.4C8.98298 9.469 8.86798 9.816 8.64698 10.443L6.55998 16H11.4L9.33798 10.443C9.15998 9.974 9.04498 9.626 8.99298 9.4H8.99198Z"></path>
    </symbol>
    <symbol
        id="icon-ui-text-styles-superscript"
        viewBox="0 0 28 28">
        <path
            d="M9.78898 5.99999L16 22H13.699L12.155 18.019L5.78698 18.017L4.25898 22H2.00098L8.24498 5.99999H9.78998H9.78898ZM8.99198 9.39999C8.98298 9.46899 8.86798 9.81599 8.64698 10.443L6.55998 16H11.4L9.33798 10.443C9.15998 9.97399 9.04498 9.62599 8.99298 9.39999H8.99198ZM21.965 2.41399C23.027 2.41399 23.879 2.69099 24.52 3.24599C25.161 3.80099 25.481 4.54699 25.481 5.48399C25.481 5.99999 25.389 6.48899 25.204 6.95299C25.019 7.41699 24.735 7.89399 24.352 8.38699C23.969 8.87899 23.332 9.54499 22.442 10.383L20.458 12.305V12.383H25.88V14H18.138V12.609L21.083 9.64799C21.953 8.75699 22.53 8.12599 22.813 7.75299C23.096 7.37999 23.304 7.02999 23.434 6.70199C23.564 6.37399 23.629 6.02199 23.629 5.64699C23.629 5.13099 23.474 4.72499 23.164 4.42799C22.854 4.13099 22.426 3.98299 21.879 3.98299C21.441 3.98299 21.018 4.06399 20.609 4.22499C20.2 4.38599 19.727 4.67799 19.191 5.09999L18.199 3.88899C18.834 3.35299 19.452 2.97199 20.051 2.74799C20.65 2.52399 21.288 2.41199 21.965 2.41199V2.41399Z"></path>
    </symbol>
    <symbol
        id="icon-ui-thumbnails"
        viewBox="0 0 28 28">
        <path
            d="M4 8V4H8V8H4ZM12 7.999V4H16V7.999H12ZM20 8V4H24V8H20ZM12 16V12H16V16H12ZM20 16V12H24V16H20ZM4 16V12H8V16H4ZM4 24V20H8V24H4ZM12 23.999V20H16V23.999H12ZM20 24V20H24V24H20Z"></path>
    </symbol>
    <symbol
        id="icon-ui-thumbnails-with-preview"
        viewBox="0 0 28 28">
        <path d="M4 10V6H8V10H4ZM12 20V8H24V20H12ZM4 22V18H8V22H4ZM4 16V12H8V16H4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-tiktok"
        viewBox="0 0 28 28">
        <path
            d="M22.128 7.13301C21.966 7.04901 21.808 6.95801 21.655 6.85801C21.211 6.56401 20.803 6.21801 20.442 5.82701C19.537 4.79201 19.199 3.74101 19.075 3.00601H19.08C18.976 2.39601 19.019 2.00101 19.026 2.00101H14.904V17.939C14.904 18.153 14.904 18.364 14.895 18.573C14.895 18.599 14.893 18.623 14.891 18.651C14.891 18.663 14.891 18.674 14.889 18.686C14.889 18.689 14.889 18.692 14.889 18.695C14.846 19.267 14.662 19.819 14.355 20.304C14.048 20.789 13.627 21.19 13.128 21.473C12.608 21.769 12.02 21.924 11.423 21.923C9.50303 21.923 7.94603 20.357 7.94603 18.423C7.94603 16.489 9.50203 14.923 11.423 14.923C11.787 14.923 12.148 14.98 12.493 15.092L12.498 10.895C11.449 10.759 10.383 10.843 9.36703 11.14C8.35103 11.437 7.40903 11.941 6.59803 12.621C5.88803 13.238 5.29003 13.975 4.83303 14.797C4.65903 15.097 4.00303 16.302 3.92303 18.259C3.87303 19.369 4.20603 20.52 4.36503 20.995V21.005C4.46503 21.285 4.85203 22.24 5.48403 23.046C5.99303 23.692 6.59503 24.26 7.26903 24.73V24.72L7.27903 24.73C9.27403 26.086 11.487 25.997 11.487 25.997C11.87 25.982 13.153 25.997 14.61 25.307C16.226 24.541 17.146 23.401 17.146 23.401C17.734 22.72 18.201 21.943 18.528 21.105C18.901 20.125 19.025 18.949 19.025 18.479V10.023C19.075 10.053 19.741 10.493 19.741 10.493C19.741 10.493 20.7 11.108 22.197 11.508C23.271 11.793 24.718 11.853 24.718 11.853V7.76101C24.211 7.81601 23.182 7.65601 22.128 7.13101V7.13301Z"></path>
    </symbol>
    <symbol
        id="icon-ui-tiktok_heart"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_725)">
            <path
                d="M10.85 26.046C-11.396 9.613 6.19395 -3.629 14.055 4.424C21.532 -3.628 39.473 9.613 17.259 26.045C15.366 27.445 12.744 27.445 10.85 26.046Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_725">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-tiktok_more"
        viewBox="0 0 28 28">
        <path
            d="M6.844 13.422C6.844 15.312 5.312 16.844 3.422 16.844C1.532 16.844 0 15.312 0 13.422C0 11.532 1.532 10 3.422 10C5.312 10 6.844 11.532 6.844 13.422ZM17.422 13.422C17.422 15.312 15.89 16.844 14 16.844C12.11 16.844 10.578 15.312 10.578 13.422C10.578 11.532 12.11 10 14 10C15.89 10 17.422 11.532 17.422 13.422ZM24.577 16.844C26.467 16.844 27.999 15.312 27.999 13.422C27.999 11.532 26.467 10 24.577 10C22.687 10 21.155 11.532 21.155 13.422C21.155 15.312 22.687 16.844 24.577 16.844Z"></path>
    </symbol>
    <symbol
        id="icon-ui-tiktok_saved"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_729)">
            <path
                d="M2.33301 3.799C2.33301 1.701 4.04201 0 6.15101 0H21.424C23.533 0 25.242 1.701 25.242 3.799V26.151C25.242 27.687 23.467 28.55 22.249 27.608L13.788 21.059L5.32701 27.608C4.10901 28.551 2.33401 27.687 2.33401 26.151V3.799H2.33301Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_729">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-tiktok_share"
        viewBox="0 0 28 28">
        <path
            d="M14.921 6.29901C14.921 4.41901 17.201 3.48601 18.519 4.82701L26.554 13.003C27.357 13.82 27.357 15.13 26.554 15.947L18.519 24.123C17.201 25.464 14.921 24.531 14.921 22.651V20.413C14.921 20.413 6.87903 17.976 1.36703 24.499C0.922032 25.026 -0.00696761 24.747 0.0150324 24.058C0.531032 7.63401 14.921 8.94801 14.921 8.94801V6.30001V6.29901Z"></path>
    </symbol>
    <symbol
        id="icon-ui-time"
        viewBox="0 0 28 28">
        <path
            d="M14.989 4C21.072 4 26 8.928 26 15C26 21.072 21.072 26 14.989 26C8.917 26 4 21.072 4 15C4 8.928 8.917 4 14.989 4ZM15 6C10.028 6 6 10.027 6 15C6 19.973 10.027 24 15 24C19.972 24 24 19.973 24 15C24 10.027 19.973 6 15 6ZM16 8V14.838L20.196 17.26L19.196 18.992L14.014 16H14V8H16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-translation"
        viewBox="0 0 24 24">
        <path
            d="M15.891 17.016H19.125L17.484 12.657L15.891 17.016ZM18.516 9.98401L23.016 21.984H21L19.875 18.984H15.141L14.016 21.984H12L16.5 9.98401H18.516ZM12.891 15.047L12.094 17.11L8.99999 14.016L3.98399 18.985L2.57799 17.579L7.68699 12.563C6.43699 11.1877 5.43699 9.67201 4.68699 8.01601H6.70299C7.35899 9.26601 8.12465 10.3753 8.99999 11.344C10.4373 9.75001 11.5 7.96868 12.188 6.00001H0.984985V3.98401H8.01599V2.01501H9.98499V3.98401H17.016V6.00001H14.063C13.7503 7.00001 13.2347 8.13268 12.516 9.39801C11.7973 10.6633 11.0787 11.7023 10.36 12.515L10.313 12.562L12.891 15.047Z"></path>
    </symbol>
    <symbol
        id="icon-ui-tt-instant-page"
        viewBox="0 0 28 28">
        <path
            d="M24.5 9.333H3.5M24.5 7.583V11.083M3.5 8.167V11.667M9.333 9.333V24.5M11.083 24.5H7.583M22.75 3.5H5.25C4.284 3.5 3.5 4.284 3.5 5.25V22.75C3.5 23.716 4.284 24.5 5.25 24.5H22.75C23.716 24.5 24.5 23.716 24.5 22.75V5.25C24.5 4.284 23.716 3.5 22.75 3.5Z"
            stroke="black"
            stroke-width="2.3333"
            stroke-linecap="round"
            stroke-linejoin="round"
            fill="none"></path>
    </symbol>
    <symbol
        id="icon-ui-tt-website"
        viewBox="0 0 28 28">
        <path d="M12 22H16V20H12V22Z"></path>
        <path
            d="M24.158 25.325C24.377 25.106 24.5 24.81 24.5 24.5V3.50001C24.5 3.19101 24.377 2.89401 24.158 2.67501C23.939 2.45601 23.643 2.33301 23.333 2.33301H4.66602C4.35702 2.33301 4.06002 2.45601 3.84102 2.67501C3.62202 2.89401 3.49902 3.19101 3.49902 3.50001V24.5C3.49902 24.809 3.62202 25.106 3.84102 25.325C4.06002 25.544 4.35702 25.667 4.66602 25.667H23.333C23.642 25.667 23.939 25.544 24.158 25.325ZM22.167 19V23.333H5.83402V19H22.167ZM22.167 4.66701V17H5.83402V4.66701H22.167Z"></path>
    </symbol>
    <symbol
        id="icon-ui-twitter"
        viewBox="0 0 28 28">
        <path
            d="M25.456 6.268C25.079 6.435 24.691 6.576 24.295 6.691C24.764 6.161 25.121 5.537 25.34 4.854C25.389 4.701 25.338 4.533 25.212 4.433C25.086 4.333 24.912 4.321 24.773 4.403C23.932 4.902 23.024 5.26 22.073 5.47C21.115 4.533 19.813 4 18.467 4C15.626 4 13.315 6.311 13.315 9.152C13.315 9.376 13.329 9.598 13.357 9.818C9.83202 9.508 6.55402 7.776 4.30402 5.015C4.22402 4.917 4.10002 4.864 3.97402 4.874C3.84802 4.884 3.73402 4.955 3.67002 5.065C3.21402 5.848 2.97202 6.744 2.97202 7.656C2.97202 8.897 3.41502 10.075 4.19802 10.996C3.96002 10.914 3.72902 10.811 3.50802 10.688C3.39002 10.622 3.24502 10.623 3.12802 10.691C3.01102 10.759 2.93702 10.882 2.93302 11.018C2.93202 11.041 2.93202 11.064 2.93202 11.087C2.93202 12.94 3.92902 14.608 5.45402 15.518C5.32302 15.505 5.19202 15.486 5.06202 15.461C4.92802 15.435 4.79002 15.482 4.70002 15.585C4.61002 15.688 4.57902 15.83 4.62102 15.96C5.18502 17.722 6.63802 19.018 8.39502 19.413C6.93802 20.326 5.27202 20.804 3.52302 20.804C3.15802 20.804 2.79102 20.783 2.43202 20.74C2.25402 20.719 2.08302 20.824 2.02202 20.994C1.96102 21.164 2.02602 21.353 2.17702 21.45C4.42402 22.891 7.02202 23.652 9.69002 23.652C14.935 23.652 18.217 21.178 20.046 19.103C22.327 16.516 23.635 13.091 23.635 9.707C23.635 9.566 23.633 9.423 23.628 9.281C24.528 8.603 25.303 7.783 25.933 6.84C26.029 6.697 26.018 6.507 25.908 6.376C25.798 6.245 25.612 6.201 25.455 6.271L25.456 6.268Z"></path>
    </symbol>
    <symbol
        id="icon-ui-underline"
        viewBox="0 0 28 28">
        <path
            d="M10 4V12.234C10 14.784 11.45 16 14 16C16.55 16 18.013 14.784 18.013 12.234V4H19.847V12.452C19.847 15.703 17.676 18 14.001 18C10.337 18 8.155 15.703 8.155 12.452V4H10.001H10ZM4 22H24V24H4V22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-undo-arrow"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_746)">
            <path
                d="M0.326982 9.27599C-0.108018 8.82699 -0.108018 8.09999 0.326982 7.65099L7.42298 0.336994C7.85798 -0.112006 8.56398 -0.112006 8.99998 0.336994C9.43598 0.785994 9.43498 1.51299 8.99998 1.96199L3.80698 7.31399H17.965C23.507 7.31399 28 11.945 28 17.657C28 23.369 23.507 28 17.965 28V25.701C22.276 25.701 25.77 22.099 25.77 17.656C25.77 13.213 22.275 9.61099 17.965 9.61099H3.80698L8.99998 14.963C9.43498 15.412 9.43498 16.139 8.99998 16.588C8.56498 17.037 7.85898 17.037 7.42298 16.588L0.326982 9.27399V9.27599Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_746">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-unlink"
        viewBox="0 0 28 28">
        <path d="M24 5.538L22.462 4L4 22.462L5.538 24L24 5.538Z"></path>
        <path
            d="M8.00002 8H13.586L11.586 10H8.00002C5.79102 10 4.00002 11.791 4.00002 14C4.00002 15.512 4.83902 16.829 6.07702 17.508L4.62402 18.961C3.04002 17.881 1.99902 16.062 1.99902 14C1.99902 10.686 4.68602 8 8.00002 8Z"></path>
        <path
            d="M20 18H16.071L14.071 20H20C23.314 20 26 17.314 26 14C26 11.849 24.868 9.96302 23.168 8.90302L21.695 10.376C23.057 11.014 24 12.397 24 14C24 16.209 22.209 18 20 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-uplift-report"
        viewBox="0 0 28 28">
        <path
            d="M25.825 8.32501C26.281 7.86901 26.281 7.13101 25.825 6.67501C25.369 6.21901 24.631 6.21901 24.175 6.67501L25.825 8.32501ZM7.84201 16.008C7.38601 16.464 7.38601 17.202 7.84201 17.658C8.29801 18.114 9.03601 18.114 9.49201 17.658L7.84201 16.008ZM5.16701 4.00001C5.16701 3.35601 4.64501 2.83301 4.00001 2.83301C3.35501 2.83301 2.83301 3.35501 2.83301 4.00001H5.16701ZM25 26.167C25.644 26.167 26.167 25.645 26.167 25C26.167 24.355 25.645 23.833 25 23.833V26.167ZM24.175 6.67501L18 12.85L19.65 14.5L25.825 8.32501L24.175 6.67501ZM18 12.85V15.183C18.619 15.183 19.212 14.937 19.65 14.5L18 12.85ZM18 12.85L16.35 14.5C16.788 14.937 17.381 15.183 18 15.183V12.85ZM18 12.85L16.15 11L14.5 12.65L16.35 14.5L18 12.85ZM16.15 11C15.712 10.563 15.119 10.317 14.5 10.317V12.65L16.15 11ZM14.5 10.317C13.881 10.317 13.288 10.563 12.85 11L14.5 12.65V10.317ZM12.85 11L7.84201 16.008L9.49201 17.658L14.501 12.649L12.851 10.999L12.85 11ZM2.83301 4.00001V21.267H5.16601L5.16701 4.00001H2.83301ZM2.83301 21.267C2.83301 21.901 2.83201 22.447 2.86901 22.894C2.90701 23.355 2.99001 23.814 3.21501 24.256L5.29401 23.197C5.26501 23.139 5.22101 23.022 5.19501 22.705C5.16801 22.375 5.16701 21.94 5.16701 21.268H2.83401L2.83301 21.267ZM3.21501 24.256C3.55101 24.915 4.08601 25.45 4.74501 25.786L5.80401 23.707C5.58501 23.595 5.40601 23.417 5.29401 23.197L3.21501 24.256ZM4.74401 25.785C5.18501 26.01 5.64401 26.093 6.10501 26.131C6.55301 26.168 7.09801 26.167 7.73201 26.167V23.834C7.05901 23.834 6.62501 23.833 6.29501 23.806C5.97801 23.78 5.86101 23.736 5.80401 23.707L4.74501 25.786L4.74401 25.785ZM7.73201 26.167H25V23.833L7.73201 23.834V26.167Z"></path>
    </symbol>
    <symbol
        id="icon-ui-upload-file"
        viewBox="0 0 28 28">
        <path
            d="M20 19.447V26H18V19.448L15.224 22.224L14 21L19.001 15.999L24 21L22.776 22.224L20 19.447ZM24 14H22V6H13L8 11V22H12V24H6V10L12 4H24V14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-upload-media"
        viewBox="0 0 28 28">
        <path
            d="M22 19.447V26H20V19.448L17.224 22.224L16 21L21.001 15.999L26 21L24.776 22.224L22 19.447ZM4 22.667V4H26V14H24V6H6V20L9 16L15 24H4V22.667ZM16 14C14.895 14 14 13.105 14 12C14 10.895 14.895 10 16 10C17.105 10 18 10.895 18 12C18 13.105 17.105 14 16 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-uppercase"
        viewBox="0 0 28 28">
        <path d="M22 10V20H20V10H16V8H26V10H22ZM8 10V20H6V10H2V8H12V10H8Z"></path>
    </symbol>
    <symbol
        id="icon-ui-user"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_760)">
            <path
                d="M17.507 13.61C19.656 12.355 21.125 10.011 21.125 7.294C21.125 3.267 17.934 0 14.001 0C10.065 0 6.875 3.267 6.875 7.294C6.875 10.011 8.341 12.355 10.493 13.61C6.716 15.076 4 18.796 4 23.16V24.732C4 26.537 5.43 28.001 7.195 28.001H20.807C22.57 28.001 24 26.537 24 24.732V23.16C24 18.796 21.284 15.077 17.507 13.61Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_760">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-users"
        viewBox="0 0 28 28">
        <path
            d="M16 22H4V20.415C4 17.244 8 15.5 10 15.5C11.926 15.5 15.706 17.117 15.984 20.068L16 20.414V22ZM13.3 10C13.3 11.823 11.823 13.3 10 13.3C8.177 13.3 6.7 11.823 6.7 10C6.7 8.17701 8.177 6.70001 10 6.70001C11.823 6.70001 13.3 8.17701 13.3 10ZM24 20H17.985C17.907 18.959 17.54 18.001 16.975 17.159C17.871 16.401 19.185 16 20.001 16C21.334 16 24.001 17.073 24.001 19.024L24 20ZM22 12C22 13.107 21.107 14 20 14C18.893 14 18 13.107 18 12C18 10.893 18.893 10 20 10C21.107 10 22 10.893 22 12Z"></path>
    </symbol>
    <symbol
        id="icon-ui-version"
        viewBox="0 0 28 28">
        <path
            d="M8 6H10C11.105 6 12 6.895 12 8V10C12 11.105 11.105 12 10 12H8C6.895 12 6 11.105 6 10V8C6 6.895 6.895 6 8 6ZM18 6H20C21.105 6 22 6.895 22 8V10C22 11.105 21.105 12 20 12H18C16.895 12 16 11.105 16 10V8C16 6.895 16.895 6 18 6ZM18 16H20C21.105 16 22 16.895 22 18V20C22 21.105 21.105 22 20 22H18C16.895 22 16 21.105 16 20V18C16 16.895 16.895 16 18 16ZM8 16H10C11.105 16 12 16.895 12 18V20C12 21.105 11.105 22 10 22H8C6.895 22 6 21.105 6 20V18C6 16.895 6.895 16 8 16Z"></path>
    </symbol>
    <symbol
        id="icon-ui-video"
        viewBox="0 0 28 28">
        <path d="M4 4H26V24H4V4ZM6 6V22H24V6H6ZM12 9.5L20 14L12 18.5V9.5Z"></path>
    </symbol>
    <symbol
        id="icon-ui-video-heavy"
        viewBox="0 0 28 28">
        <g clip-path="url(#clip0_5317_768)">
            <path
                d="M4.00003 4H26V24H12V22H24V6H6.00003V12H4.00003V4ZM20 14L12 18.5V9.5L20 14ZM1.00003 14C0.616027 14 0.265027 14.22 0.0990266 14.567C-0.0669734 14.914 -0.0209734 15.325 0.219027 15.625L3.71903 20L0.219027 24.375C-0.0209734 24.675 -0.0679734 25.086 0.0990266 25.433C0.266027 25.78 0.616027 26 1.00003 26H9.00003C9.38403 26 9.73503 25.78 9.90103 25.433C10.067 25.086 10.021 24.675 9.78103 24.375L6.28103 20L9.78103 15.625C10.021 15.325 10.068 14.914 9.90103 14.567C9.73403 14.22 9.38403 14 9.00003 14H1.00003ZM6.91903 16L5.00003 18.399L3.08103 16H6.91903Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_768">
                <rect
                    width="28"
                    height="28"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-view-collapse"
        viewBox="0 0 28 28">
        <path d="M3.41 26L10 19.41V24H12V16H4V18H8.581L1.995 24.586L3.409 26H3.41Z"></path>
        <path d="M24.581 2L18 8.581V4H16V12H24V10H19.41L25.996 3.414L24.582 2H24.581Z"></path>
    </symbol>
    <symbol
        id="icon-ui-view-expand"
        viewBox="0 0 28 28">
        <path d="M10.586 16.004L4 22.59V18H2V26H10V24H5.419L12 17.419L10.586 16.004Z"></path>
        <path d="M17.419 12L24 5.419V10H26V2H18V4H22.59L16.004 10.586L17.418 12H17.419Z"></path>
    </symbol>
    <symbol
        id="icon-ui-visibility-hidden"
        viewBox="0 0 28 28">
        <path
            d="M20.578 8.62799L25.306 5.61899L26.38 7.30599L22.213 9.95799C24.486 11.971 26 13.999 26 13.999C26 13.999 20.026 22 14 22C11.688 22 9.38402 20.822 7.42202 19.371L2.69302 22.381L1.61902 20.694L5.78702 18.042C3.51402 16.028 2.00002 14 2.00002 14C2.00002 14 7.97402 6.00099 14 6.00099C16.312 6.00099 18.616 7.17699 20.578 8.62799ZM9.19702 18.242C10.746 19.266 12.417 20 14 20C17.536 20 21.484 16.366 23.56 14.001C22.773 13.106 21.717 12.03 20.518 11.037L17.367 13.042C17.454 13.346 17.5 13.668 17.5 14C17.5 15.931 15.929 17.5 14 17.5C13.124 17.5 12.322 17.177 11.708 16.644L9.19702 18.242ZM7.48202 16.962L10.633 14.957C10.546 14.653 10.5 14.332 10.5 14C10.5 12.069 12.069 10.5 14 10.5C14.875 10.5 15.677 10.823 16.291 11.356L18.803 9.75799C17.254 8.73399 15.583 7.99999 14 7.99999C10.463 7.99999 6.51602 11.632 4.43802 13.997C5.22602 14.892 6.28202 15.969 7.48202 16.962Z"></path>
    </symbol>
    <symbol
        id="icon-ui-visibility-visible"
        viewBox="0 0 28 28">
        <path
            d="M14 20C10.476 20 6.521 16.362 4.438 13.997C6.516 11.632 10.463 8 14 8C17.522 8 21.479 11.636 23.56 14.001C21.484 16.366 17.535 20 14 20ZM2 13.999C2 13.999 7.974 22 14 22C20.026 22 26 13.999 26 13.999C26 13.999 20.026 6 14 6C7.974 6 2 13.999 2 13.999ZM10.5 14C10.5 15.931 12.069 17.5 14 17.5C15.929 17.5 17.5 15.931 17.5 14C17.5 12.069 15.929 10.5 14 10.5C12.069 10.5 10.5 12.069 10.5 14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-volume-on"
        viewBox="0 0 28 28">
        <path
            d="M4 10H8L14 4V24L8 18H4V10ZM21.701 9.982C21.173 8.708 20.4 7.551 19.425 6.576L20.486 5.515C21.6 6.629 22.484 7.952 23.087 9.408C23.69 10.864 24 12.424 24 14C24 15.576 23.69 17.136 23.087 18.592C22.484 20.048 21.6 21.371 20.486 22.485L19.425 21.424C20.4 20.449 21.173 19.291 21.701 18.018C22.229 16.745 22.5 15.379 22.5 14C22.5 12.621 22.228 11.256 21.701 9.982ZM16.596 9.404C17.2 10.008 17.678 10.724 18.005 11.513C18.332 12.302 18.5 13.147 18.5 14C18.5 14.854 18.332 15.699 18.005 16.487C17.678 17.275 17.2 17.992 16.596 18.596L17.657 19.657C18.4 18.914 18.989 18.032 19.391 17.062C19.793 16.092 20 15.051 20 14.001C20 12.95 19.793 11.91 19.391 10.94C18.989 9.97 18.4 9.087 17.657 8.345L16.596 9.406V9.404Z"></path>
    </symbol>
    <symbol
        id="icon-ui-warning"
        viewBox="0 0 28 28">
        <path
            d="M16.724 6.55299L24.037 18.986C24.597 19.938 24.279 21.164 23.327 21.724C23.02 21.905 22.67 22 22.313 22H7.68604C6.58104 22 5.68604 21.105 5.68604 20C5.68604 19.643 5.78104 19.293 5.96204 18.986L13.275 6.55299C13.835 5.60099 15.061 5.28299 16.013 5.84299C16.306 6.01499 16.55 6.25999 16.723 6.55299H16.724ZM14 9.99999V16H16V9.99999H14ZM14 18V20H16V18H14Z"></path>
    </symbol>
    <symbol
        id="icon-ui-warning-large"
        viewBox="0 0 32 32">
        <g clip-path="url(#clip0_5317_784)">
            <path
                d="M16 32C7.163 32 0 24.837 0 16C0 7.163 7.163 0 16 0C24.837 0 32 7.163 32 16C32 24.837 24.837 32 16 32ZM16 30.5C24.008 30.5 30.5 24.008 30.5 16C30.5 7.992 24.008 1.5 16 1.5C7.992 1.5 1.5 7.992 1.5 16C1.5 24.008 7.992 30.5 16 30.5ZM16 19C14.895 19 14 18.105 14 17V9C14 7.895 14.895 7 16 7C17.105 7 18 7.895 18 9V17C18 18.105 17.105 19 16 19ZM16 25C14.895 25 14 24.105 14 23C14 21.895 14.895 21 16 21C17.105 21 18 21.895 18 23C18 24.105 17.105 25 16 25Z"></path>
        </g>
        <defs>
            <clipPath id="clip0_5317_784">
                <rect
                    width="32"
                    height="32"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-warning-l-negative"
        viewBox="0 0 28 28">
        <path
            d="M17.4011 3.893L27.3101 19.894C28.4731 21.772 27.8931 24.238 26.0151 25.401C25.3821 25.793 24.6531 26 23.9091 26H4.09106C1.88206 26 0.0910645 24.209 0.0910645 22C0.0910645 21.256 0.299064 20.527 0.690064 19.894L10.5991 3.893C11.7621 2.015 14.2281 1.435 16.1061 2.598C16.6321 2.924 17.0751 3.367 17.4011 3.893ZM14.0001 8C12.8951 8 12.0001 8.895 12.0001 10V14C12.0001 15.105 12.8951 16 14.0001 16C15.1051 16 16.0001 15.105 16.0001 14V10C16.0001 8.895 15.1051 8 14.0001 8ZM14.0001 18C12.8951 18 12.0001 18.895 12.0001 20C12.0001 21.105 12.8951 22 14.0001 22C15.1051 22 16.0001 21.105 16.0001 20C16.0001 18.895 15.1051 18 14.0001 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-warning-l-outlines"
        viewBox="0 0 28 28">
        <path
            d="M15.7001 4.946C15.5371 4.683 15.3161 4.461 15.0531 4.299C14.1141 3.717 12.8811 4.007 12.3001 4.946L2.39106 20.947C2.19506 21.263 2.09106 21.628 2.09106 22C2.09106 23.105 2.98606 24 4.09106 24H23.9091C24.2811 24 24.6461 23.896 24.9621 23.7C25.9011 23.118 26.1911 21.886 25.6091 20.947L15.7001 4.946ZM17.4011 3.893L27.3101 19.894C28.4731 21.772 27.8931 24.238 26.0151 25.401C25.3821 25.793 24.6531 26 23.9091 26H4.09106C1.88206 26 0.0910645 24.209 0.0910645 22C0.0910645 21.256 0.299064 20.527 0.690064 19.894L10.5991 3.893C11.7621 2.015 14.2281 1.435 16.1061 2.598C16.6321 2.924 17.0751 3.367 17.4011 3.893ZM14.0001 8C12.8951 8 12.0001 8.895 12.0001 10V14C12.0001 15.105 12.8951 16 14.0001 16C15.1051 16 16.0001 15.105 16.0001 14V10C16.0001 8.895 15.1051 8 14.0001 8ZM14.0001 18C12.8951 18 12.0001 18.895 12.0001 20C12.0001 21.105 12.8951 22 14.0001 22C15.1051 22 16.0001 21.105 16.0001 20C16.0001 18.895 15.1051 18 14.0001 18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-weight"
        viewBox="0 0 28 28">
        <path
            d="M20.534 22.098C19.008 23.29 17.087 24 15 24C10.029 24 6 19.971 6 15C6 10.367 9.5 6.55199 14 6.05499V10.1C11.718 10.563 10 12.581 10 15C10 17.761 12.239 20 15 20C15.98 20 16.895 19.718 17.666 19.231L20.534 22.099V22.098ZM22.01 20.645L19.152 17.787C19.688 16.991 20 16.032 20 15C20 12.581 18.282 10.563 16 10.1V6.05499C20.5 6.55199 24 10.368 24 15C24 17.138 23.255 19.102 22.01 20.645Z"></path>
    </symbol>
    <symbol
        id="icon-ui-widget"
        viewBox="0 0 28 28">
        <path
            d="M4 26V4H26V26H4ZM6 24H24V6H6V24ZM16.348 12.442C15.746 13.956 14.604 15.606 12.442 16.44C11.88 16.658 11.906 17.444 12.468 17.668C13.992 18.274 15.658 19.42 16.5 21.588C16.72 22.152 17.506 22.12 17.73 21.558C18.332 20.04 19.47 18.384 21.626 17.544C22.188 17.324 22.158 16.538 21.596 16.316C20.076 15.714 18.418 14.572 17.578 12.414C17.36 11.85 16.572 11.88 16.348 12.442ZM10.647 8.268C10.285 9.178 9.599 10.168 8.301 10.67C7.961 10.8 7.979 11.272 8.315 11.406C9.231 11.77 10.231 12.46 10.737 13.762C10.869 14.1 11.343 14.082 11.477 13.744C11.837 12.832 12.521 11.838 13.815 11.332C14.153 11.2 14.137 10.728 13.799 10.594C12.885 10.232 11.889 9.548 11.385 8.252C11.253 7.912 10.781 7.932 10.647 8.268Z"></path>
    </symbol>
    <symbol
        id="icon-ui-widget1"
        viewBox="0 0 28 28">
        <path
            d="M3.19489 7.065C5.27289 6.261 6.37189 4.676 6.95089 3.219C7.16589 2.681 7.92089 2.649 8.13289 3.193C8.93989 5.268 10.5349 6.363 11.9979 6.943C12.5389 7.158 12.5649 7.913 12.0239 8.125C9.95189 8.935 8.85689 10.527 8.28089 11.987C8.06589 12.528 7.30789 12.557 7.09589 12.016C6.28589 9.931 4.68489 8.827 3.21789 8.244C2.67989 8.029 2.65089 7.274 3.19589 7.066L3.19489 7.065ZM9.82389 16.305C13.2859 14.97 15.1139 12.328 16.0779 9.904C16.4369 9.004 17.6979 8.956 18.0469 9.859C19.3919 13.314 22.0469 15.143 24.4799 16.107C25.3799 16.462 25.4279 17.721 24.5279 18.073C21.0759 19.418 19.2539 22.069 18.2899 24.5C17.9309 25.4 16.6729 25.451 16.3209 24.548C14.9729 21.077 12.3049 19.242 9.86489 18.272C8.96489 17.913 8.92289 16.655 9.82289 16.306L9.82389 16.305Z"></path>
    </symbol>
    <symbol
        id="icon-ui-widget-new"
        viewBox="0 0 28 28">
        <path
            d="M22 20H26V22H22V26H20V22H16V20H20V16H22V20ZM26 14H24V6H6V24H14V26H4V4H26V14ZM10.647 8.268C10.285 9.178 9.599 10.168 8.301 10.67C7.961 10.8 7.979 11.272 8.315 11.406C9.231 11.77 10.231 12.46 10.737 13.762C10.869 14.1 11.343 14.082 11.477 13.744C11.837 12.832 12.521 11.838 13.815 11.332C14.153 11.2 14.137 10.728 13.799 10.594C12.885 10.232 11.889 9.548 11.385 8.252C11.253 7.912 10.781 7.932 10.647 8.268Z"></path>
    </symbol>
    <symbol
        id="icon-ui-youtube"
        viewBox="0 0 28 28">
        <path
            d="M25.506 8.00001C26.02 9.78801 26 14.019 26 14.019C26 14.019 26 18.231 25.506 20.019C25.229 20.998 24.419 21.77 23.391 22.033C21.513 22.504 14.001 22.504 14.001 22.504C14.001 22.504 6.50795 22.504 4.61095 22.015C3.58295 21.751 2.77195 20.98 2.49595 20.001C2.00195 18.232 2.00195 14.001 2.00195 14.001C2.00195 14.001 2.00195 9.78901 2.49595 8.00101C2.77295 7.02201 3.60295 6.23201 4.61095 5.96801C6.48895 5.49701 14.001 5.49701 14.001 5.49701C14.001 5.49701 21.513 5.49701 23.391 5.98601C24.419 6.25001 25.229 7.02101 25.506 8.00001ZM18 14.019L11 10V18L18 14.019Z"></path>
    </symbol>
    <symbol
        id="icon-ui-zoom"
        viewBox="0 0 28 28">
        <path
            d="M21.501 19.982L27.76 26.241L26.241 27.76L19.982 21.501C18.083 23.063 15.651 24 13 24C6.925 24 2 19.075 2 13C2 6.925 6.925 2 13 2C19.075 2 24 6.925 24 13C24 15.651 23.062 18.083 21.501 19.982ZM13 22C17.971 22 22 17.971 22 13C22 8.029 17.971 4 13 4C8.029 4 4 8.029 4 13C4 17.971 8.029 22 13 22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-zoom-in"
        viewBox="0 0 28 28">
        <path
            d="M14 14V18H12V14H8V12H12V8H14V12H18V14H14ZM21.501 19.982L27.76 26.241L26.241 27.76L19.982 21.501C18.083 23.063 15.651 24 13 24C6.925 24 2 19.075 2 13C2 6.925 6.925 2 13 2C19.075 2 24 6.925 24 13C24 15.651 23.062 18.083 21.501 19.982ZM13 22C17.971 22 22 17.971 22 13C22 8.029 17.971 4 13 4C8.029 4 4 8.029 4 13C4 17.971 8.029 22 13 22Z"></path>
    </symbol>
    <symbol
        id="icon-ui-zoom-out"
        viewBox="0 0 28 28">
        <path
            d="M21.501 19.982L27.76 26.241L26.241 27.76L19.982 21.501C18.083 23.063 15.651 24 13 24C6.925 24 2 19.075 2 13C2 6.925 6.925 2 13 2C19.075 2 24 6.925 24 13C24 15.651 23.062 18.083 21.501 19.982ZM13 22C17.971 22 22 17.971 22 13C22 8.029 17.971 4 13 4C8.029 4 4 8.029 4 13C4 17.971 8.029 22 13 22ZM18 12V14H8V12H18Z"></path>
    </symbol>
    <symbol
        id="icon-ui-action"
        viewBox="0 0 28 28">
        <path d="M14.4 12L16 4L9 14H13.6L12 22L19 12H14.4Z"></path>
    </symbol>
    <symbol
        id="icon-ui-other-sizes-arrow-upload"
        viewBox="0 0 30 30">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.53988 12.1464C4.34462 11.9512 4.34462 11.6346 4.53988 11.4393L15.1434 0.835842C15.1444 0.834805 15.1454 0.833771 15.1465 0.83274C15.1475 0.83171 15.1485 0.830685 15.1496 0.829665L15.5 0.479187L16.2071 1.18629L26.4602 11.4393C26.6554 11.6346 26.6554 11.9512 26.4602 12.1464C26.2649 12.3417 25.9483 12.3417 25.7531 12.1464L16 2.39337V28.5C16 28.7762 15.7761 29 15.5 29C15.2238 29 15 28.7762 15 28.5V2.39346L5.24699 12.1464C5.05172 12.3417 4.73514 12.3417 4.53988 12.1464Z"></path>
    </symbol>
    <symbol
        id="icon-ui-twitter-colored"
        viewBox="0 0 26 26">
        <g clip-path="url(#clip0_119_8)">
            <path
                d="M26 0H0V26H26V0Z"
                fill="#1DA1F2"></path>
            <path
                d="M9.9853 19.6033C16.1174 19.6033 19.4714 14.5229 19.4714 10.1172C19.4714 9.97292 19.4714 9.82927 19.4616 9.68627C20.1141 9.21432 20.6774 8.62994 21.125 7.96052C20.5165 8.23014 19.871 8.40696 19.2101 8.48507C19.9061 8.06841 20.427 7.41307 20.6758 6.64102C20.0214 7.02937 19.3054 7.30306 18.5588 7.45027C18.0561 6.91577 17.3913 6.56183 16.6672 6.44324C15.9431 6.32464 15.2001 6.448 14.5532 6.79422C13.9063 7.14043 13.3915 7.69021 13.0885 8.35848C12.7855 9.02674 12.7113 9.77623 12.8771 10.491C11.5516 10.4245 10.2549 10.0801 9.07117 9.47996C7.88741 8.87985 6.84309 8.03751 6.006 7.00762C5.57966 7.74158 5.44908 8.61043 5.64085 9.43728C5.83262 10.2641 6.33231 10.9868 7.0382 11.4582C6.50763 11.4424 5.98863 11.2993 5.525 11.0409C5.525 11.0545 5.525 11.0688 5.525 11.0831C5.52521 11.8529 5.79167 12.5988 6.27918 13.1945C6.7667 13.7902 7.44525 14.1989 8.19975 14.3513C7.70892 14.4852 7.19393 14.5048 6.69435 14.4085C6.90739 15.071 7.32216 15.6503 7.88065 16.0654C8.43913 16.4806 9.1134 16.7108 9.80915 16.7238C8.62858 17.6517 7.17019 18.1553 5.66865 18.1538C5.40339 18.1533 5.13838 18.1373 4.875 18.1057C6.39966 19.0842 8.17369 19.6031 9.9853 19.6007"
                fill="white"></path>
        </g>
        <defs>
            <clipPath id="clip0_119_8">
                <rect
                    width="26"
                    height="26"
                    rx="13"
                    fill="white"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-snapchat-colored"
        viewBox="0 0 26 26">
        <path
            d="M21.7322 17.7169C18.5805 16.1912 18.0782 13.8356 18.0558 13.6609C18.0288 13.4493 17.9981 13.2829 18.2316 13.0676C18.4568 12.8596 19.4557 12.2413 19.7328 12.0479C20.191 11.7276 20.3927 11.4078 20.244 11.0146C20.14 10.7427 19.8868 10.6402 19.62 10.6402C19.5359 10.6405 19.452 10.6499 19.3699 10.6683C18.8665 10.7775 18.3777 11.0297 18.0948 11.0978C18.0609 11.1066 18.0259 11.1113 17.9908 11.1119C17.84 11.1119 17.7828 11.0448 17.7974 10.8633C17.8328 10.3132 17.9076 9.23936 17.8208 8.23628C17.7017 6.8562 17.2566 6.1724 16.7288 5.56764C16.4735 5.27436 15.2879 4.0144 12.9999 4.0144C10.7119 4.0144 9.52784 5.27436 9.27408 5.564C8.74472 6.16876 8.30012 6.85256 8.18208 8.23265C8.09524 9.23572 8.17324 10.309 8.20548 10.8597C8.21588 11.0323 8.16284 11.1082 8.01204 11.1082C7.97695 11.1076 7.94204 11.1029 7.90804 11.0942C7.62568 11.0261 7.13688 10.7739 6.63352 10.6647C6.55142 10.6463 6.46755 10.6369 6.3834 10.6366C6.1156 10.6366 5.8634 10.7406 5.7594 11.011C5.61068 11.4041 5.8114 11.7239 6.27108 12.0442C6.54824 12.2377 7.54716 12.8554 7.77232 13.064C8.00528 13.2792 7.97512 13.4456 7.94808 13.6573C7.92572 13.8346 7.42288 16.1902 4.27168 17.7133C4.08708 17.8027 3.773 17.992 4.3268 18.2978C5.19624 18.7782 5.775 18.7268 6.2248 19.0164C6.60648 19.2624 6.3808 19.7928 6.65848 19.9841C6.9996 20.2197 8.00788 19.9675 9.31048 20.3975C10.4025 20.7574 11.066 21.774 13.0025 21.774C14.939 21.774 15.6217 20.7527 16.6945 20.3975C17.9945 19.9675 19.0048 20.2197 19.3465 19.9841C19.6236 19.7928 19.3985 19.2624 19.7802 19.0164C20.23 18.7268 20.8082 18.7782 21.6782 18.2978C22.2309 17.9956 21.9168 17.8064 21.7322 17.7169Z"
            fill="white"></path>
        <path
            d="M23.1035 17.5375C22.962 17.1527 22.6927 16.9468 22.3859 16.7762C22.3282 16.7424 22.2751 16.7154 22.2299 16.6946C22.1384 16.6473 22.0448 16.6015 21.9517 16.5532C20.9954 16.0462 20.2487 15.4066 19.7308 14.6484C19.5837 14.435 19.4561 14.2087 19.3496 13.9724C19.3054 13.846 19.3075 13.7743 19.3392 13.7088C19.3707 13.6583 19.4123 13.6149 19.4614 13.5814C19.6257 13.4727 19.7952 13.3624 19.9102 13.2881C20.115 13.1555 20.2773 13.0504 20.3818 12.9761C20.7744 12.7015 21.049 12.4098 21.2206 12.0838C21.3403 11.8585 21.4101 11.6101 21.4253 11.3555C21.4404 11.1008 21.4006 10.8459 21.3084 10.608C21.0484 9.92369 20.4021 9.49885 19.619 9.49885C19.4538 9.49869 19.289 9.51612 19.1276 9.55085C19.0844 9.56021 19.0412 9.57009 18.9991 9.58101C19.0064 9.11301 18.996 8.61901 18.9544 8.13281C18.8067 6.42357 18.2082 5.52761 17.5842 4.81313C17.1846 4.3654 16.7139 3.98662 16.1911 3.69201C15.2442 3.15121 14.1704 2.87665 12.9999 2.87665C11.8294 2.87665 10.7608 3.15121 9.8128 3.69201C9.2887 3.98671 8.81708 4.36625 8.41712 4.81521C7.79312 5.52969 7.1946 6.42721 7.04693 8.13489C7.00533 8.62109 6.99492 9.11769 7.00168 9.58309C6.95956 9.57217 6.91692 9.56229 6.87376 9.55293C6.71228 9.5182 6.54755 9.50077 6.38237 9.50093C5.59873 9.50093 4.95133 9.92577 4.69237 10.6101C4.5998 10.8481 4.55956 11.1032 4.57436 11.3581C4.58917 11.613 4.65868 11.8617 4.77817 12.0874C4.95029 12.4134 5.22485 12.7052 5.61745 12.9797C5.72145 13.0525 5.88421 13.1576 6.08909 13.2917C6.19985 13.3635 6.36157 13.4685 6.52017 13.5736C6.57565 13.6094 6.62282 13.6568 6.65849 13.7124C6.69177 13.7805 6.69281 13.8538 6.64341 13.989C6.53833 14.2204 6.41286 14.4419 6.26849 14.651C5.76201 15.392 5.03713 16.0202 4.11153 16.523C3.62117 16.783 3.11157 16.9567 2.89629 17.5417C2.73405 17.9832 2.84013 18.4855 3.25249 18.9088C3.40383 19.0668 3.57936 19.1996 3.77249 19.3024C4.17434 19.5232 4.60164 19.6942 5.04493 19.8115C5.1364 19.8351 5.22325 19.8739 5.30181 19.9264C5.45209 20.058 5.43077 20.2561 5.63097 20.5462C5.73146 20.6962 5.85916 20.826 6.00745 20.929C6.42761 21.2191 6.89977 21.2373 7.4 21.2566C7.85188 21.2737 8.36408 21.2935 8.94908 21.4864C9.1914 21.5665 9.44308 21.7214 9.7348 21.9024C10.4352 22.333 11.3941 22.9221 12.9988 22.9221C14.6036 22.9221 15.5692 22.3298 16.2748 21.8977C16.5645 21.7199 16.8146 21.5665 17.0502 21.4885C17.6352 21.295 18.1474 21.2758 18.5992 21.2586C19.0995 21.2394 19.5716 21.2212 19.9918 20.931C20.1674 20.8086 20.3137 20.6488 20.4203 20.463C20.5643 20.2181 20.5607 20.047 20.6959 19.9274C20.7696 19.8775 20.8511 19.8402 20.9372 19.8172C21.3865 19.6996 21.8196 19.527 22.2268 19.3034C22.4319 19.1934 22.6166 19.0488 22.7728 18.876L22.778 18.8698C23.1648 18.4558 23.2621 17.9681 23.1035 17.5375ZM21.6771 18.304C20.8072 18.7845 20.2289 18.733 19.7791 19.0226C19.3969 19.2686 19.6231 19.799 19.3454 19.9904C19.0043 20.2259 17.996 19.9737 16.6934 20.4038C15.6191 20.7589 14.9338 21.7802 13.0014 21.7802C11.0691 21.7802 10.3999 20.761 9.30788 20.4012C8.00788 19.9711 6.99753 20.2233 6.65589 19.9878C6.37873 19.7964 6.60389 19.266 6.22221 19.02C5.77189 18.7304 5.19365 18.7819 4.32421 18.304C3.77041 17.9982 4.08449 17.809 4.26909 17.7195C7.42028 16.1938 7.92312 13.8382 7.94548 13.6635C7.97252 13.4519 8.00268 13.2855 7.76972 13.0702C7.54456 12.8622 6.54565 12.2439 6.26849 12.0505C5.80985 11.7302 5.60809 11.4104 5.75681 11.0172C5.86081 10.7453 6.11457 10.6428 6.38081 10.6428C6.46495 10.6431 6.54882 10.6525 6.63093 10.6709C7.13428 10.7801 7.62308 11.0323 7.90544 11.1004C7.93944 11.1092 7.97435 11.1139 8.00944 11.1145C8.16024 11.1145 8.21328 11.0386 8.20288 10.8659C8.17064 10.3152 8.09264 9.24197 8.17948 8.23889C8.29856 6.85881 8.74316 6.17501 9.27148 5.57025C9.52524 5.27957 10.7176 4.01961 12.9978 4.01961C15.278 4.01961 16.4735 5.27437 16.7272 5.56401C17.2561 6.16877 17.7012 6.85257 17.8192 8.23265C17.9061 9.23573 17.8312 10.3095 17.7958 10.8597C17.7839 11.0412 17.8385 11.1082 17.9893 11.1082C18.0244 11.1077 18.0593 11.103 18.0933 11.0942C18.3762 11.0261 18.865 10.7739 19.3683 10.6647C19.4504 10.6463 19.5343 10.6369 19.6184 10.6366C19.8862 10.6366 20.1384 10.7406 20.2424 11.011C20.3912 11.4041 20.1904 11.7239 19.7313 12.0442C19.4541 12.2377 18.4552 12.8554 18.23 13.064C17.9966 13.2792 18.0272 13.4456 18.0543 13.6573C18.0766 13.8346 18.579 16.1902 21.7307 17.7133C21.9168 17.8064 22.2309 17.9956 21.6771 18.304Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-pinterest-colored"
        viewBox="0 0 26 26">
        <g clip-path="url(#clip0_119_20)">
            <g clip-path="url(#clip1_119_20)">
                <path
                    d="M0 13.0002C0 18.3235 3.20105 22.8967 7.78162 24.9073C7.74506 23.9995 7.77512 22.9098 8.0079 21.9221C8.25784 20.8667 9.68063 14.8383 9.68063 14.8383C9.68063 14.8383 9.26534 14.0082 9.26534 12.7814C9.26534 10.8549 10.3819 9.41606 11.7725 9.41606C12.955 9.41606 13.5263 10.3042 13.5263 11.3678C13.5263 12.5565 12.7681 14.3345 12.3782 15.9814C12.0525 17.3604 13.0697 18.4852 14.4301 18.4852C16.8932 18.4852 18.5521 15.3216 18.5521 11.5734C18.5521 8.72412 16.6331 6.59151 13.1427 6.59151C9.19923 6.59151 6.74253 9.53235 6.74253 12.8173C6.74253 13.9499 7.07647 14.7486 7.59952 15.3671C7.84002 15.6512 7.87343 15.7654 7.78639 16.0917C7.72403 16.3308 7.58083 16.9067 7.52152 17.1349C7.43498 17.4642 7.16818 17.5819 6.8706 17.4603C5.05426 16.7188 4.20834 14.7297 4.20834 12.4937C4.20834 8.8008 7.32286 4.37267 13.4995 4.37267C18.4628 4.37267 21.7296 7.96433 21.7296 11.8197C21.7296 16.9195 18.8944 20.7294 14.7151 20.7294C13.3116 20.7294 11.9914 19.9707 11.5391 19.109C11.5391 19.109 10.7844 22.1043 10.6246 22.6827C10.3489 23.685 9.80941 24.6868 9.31612 25.4676C10.4853 25.8127 11.7204 26.0007 13.0005 26.0007C20.1794 26.0007 26.0001 20.1803 26.0001 13.0002C26.0001 5.82045 20.1794 0 13.0005 0C5.82095 0 0 5.82045 0 13.0002Z"
                    fill="#CB1F27"></path>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_119_20">
                <rect
                    width="26"
                    height="26"
                    rx="13"
                    fill="white"></rect>
            </clipPath>
            <clipPath id="clip1_119_20">
                <rect
                    width="26"
                    height="26"
                    fill="white"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-meta-colored"
        viewBox="0 0 26 26">
        <path
            d="M2.80832 15.3888C2.80832 16.3816 3.02622 17.1438 3.31103 17.6049C3.68445 18.2089 4.24141 18.4647 4.80922 18.4647C5.54159 18.4647 6.21157 18.283 7.50271 16.4973C8.53707 15.066 9.75588 13.057 10.5759 11.7975L11.9647 9.66365C12.9295 8.18174 14.0461 6.53436 15.3264 5.41772C16.3716 4.50633 17.4991 4 18.6338 4C20.5389 4 22.3535 5.10398 23.7423 7.1745C25.2622 9.44213 26 12.2984 26 15.2459C26 16.9982 25.6546 18.2857 25.0669 19.3029C24.4991 20.2866 23.3924 21.2694 21.5307 21.2694V18.4647C23.1248 18.4647 23.5226 17 23.5226 15.3237C23.5226 12.9349 22.9656 10.2839 21.7387 8.38969C20.868 7.04611 19.7396 6.22514 18.4982 6.22514C17.1555 6.22514 16.075 7.23779 14.8608 9.0434C14.2152 10.0027 13.5524 11.1718 12.8083 12.491L11.9892 13.9421C10.3436 16.8599 9.92676 17.5244 9.10398 18.6212C7.66184 20.5416 6.43038 21.2694 4.80922 21.2694C2.88608 21.2694 1.66998 20.4367 0.916817 19.1817C0.301989 18.1591 0 16.8174 0 15.2884L2.80832 15.3888Z"
            fill="#0081FB"></path>
        <path
            d="M2.21436 7.37251C3.50188 5.38788 5.35993 4 7.49103 4C8.72521 4 9.95215 4.36528 11.2333 5.41139C12.6348 6.55515 14.1285 8.43852 15.9919 11.5425L16.6601 12.6564C18.2731 15.3436 19.1908 16.726 19.7279 17.3779C20.4187 18.2152 20.9024 18.4647 21.5308 18.4647C23.1248 18.4647 23.5227 17 23.5227 15.3237L26.0001 15.2459C26.0001 16.9982 25.6547 18.2857 25.067 19.3029C24.4992 20.2866 23.3925 21.2694 21.5308 21.2694C20.3735 21.2694 19.3482 21.0181 18.2144 19.9485C17.3427 19.1275 16.3238 17.6691 15.5399 16.358L13.208 12.4629C12.038 10.5081 10.9648 9.05063 10.3437 8.3906C9.67548 7.68083 8.81653 6.82369 7.44582 6.82369C6.33642 6.82369 5.39428 7.60217 4.60586 8.79295L2.21436 7.37251Z"
            fill="url(#paint0_linear_4329_3923)"></path>
        <path
            d="M7.44575 6.82369C6.33635 6.82369 5.39421 7.60217 4.60579 8.79295C3.49096 10.4756 2.80832 12.9819 2.80832 15.3888C2.80832 16.3816 3.02622 17.1438 3.31103 17.6049L0.916817 19.1817C0.301989 18.1591 0 16.8174 0 15.2884C0 12.5081 0.76311 9.61031 2.21429 7.37251C3.50181 5.38788 5.35986 4 7.49096 4L7.44575 6.82369Z"
            fill="url(#paint1_linear_4329_3923)"></path>
        <defs>
            <linearGradient
                id="paint0_linear_4329_3923"
                x1="5.51544"
                y1="14.5787"
                x2="23.4178"
                y2="15.4828"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#0064E1"></stop>
                <stop
                    offset="0.4"
                    stop-color="#0064E1"></stop>
                <stop
                    offset="0.83"
                    stop-color="#0073EE"></stop>
                <stop
                    offset="1"
                    stop-color="#0082FB"></stop>
            </linearGradient>
            <linearGradient
                id="paint1_linear_4329_3923"
                x1="4.06872"
                y1="16.5678"
                x2="4.06872"
                y2="9.96745"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#0082FB"></stop>
                <stop
                    offset="1"
                    stop-color="#0064E0"></stop>
            </linearGradient>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-tiktok-colored"
        viewBox="0 0 26 26">
        <g clip-path="url(#clip0_4314_1255)">
            <path
                d="M10.947 10.2635V9.22374C10.5943 9.17457 10.2386 9.14939 9.88252 9.14838C5.53613 9.14838 2 12.6824 2 17.03C2.00021 18.2971 2.30609 19.5454 2.89166 20.6691C3.47724 21.7927 4.32523 22.7585 5.36368 23.4845C4.05185 22.076 3.27267 20.1889 3.27267 18.1171C3.27028 16.0643 4.07245 14.0923 5.50712 12.6242C6.94179 11.156 8.8947 10.3085 10.947 10.2635Z"
                fill="#25F4EE"></path>
            <path
                d="M11.1315 21.743C13.0709 21.743 14.6804 20.1744 14.7506 18.2516L14.7566 1.11342L17.8648 1.08702C17.7981 0.728519 17.7643 0.364661 17.7639 0H13.4835L13.4767 17.1646C13.4557 17.7724 13.2807 18.3649 12.9681 18.8867C12.6556 19.4084 12.2156 19.8422 11.6896 20.1474C11.1636 20.4526 10.5686 20.6193 9.96057 20.6318C9.35252 20.6442 8.75125 20.5021 8.21313 20.2187C8.86756 21.1235 9.93032 21.743 11.1315 21.743Z"
                fill="#25F4EE"></path>
            <path
                d="M23.7246 6.9424V5.9597C22.5722 5.96045 21.4445 5.62516 20.4797 4.99487C21.3117 5.95033 22.443 6.66777 23.7246 6.9424Z"
                fill="#25F4EE"></path>
            <path
                d="M20.4797 4.99487C19.5345 3.91285 19.0139 2.52464 19.0146 1.08789H17.865C18.0138 1.88215 18.3223 2.63795 18.7717 3.30951C19.2211 3.98108 19.8022 4.55444 20.4797 4.99487Z"
                fill="#FE2C55"></path>
            <path
                d="M9.88253 13.4296C9.07681 13.4286 8.29406 13.698 7.65964 14.1947C7.02521 14.6914 6.57581 15.3866 6.38341 16.169C6.19101 16.9514 6.26674 17.7757 6.59847 18.51C6.9302 19.2443 7.49874 19.846 8.21304 20.2187C7.82477 19.6818 7.59251 19.0479 7.54191 18.3872C7.49131 17.7265 7.62436 17.0647 7.92634 16.4749C8.22832 15.8851 8.68748 15.3902 9.25309 15.045C9.81869 14.6998 10.4687 14.5177 11.1314 14.5188C11.4918 14.5192 11.85 14.5748 12.1937 14.6836V10.3108C11.8417 10.2611 11.4868 10.2354 11.1314 10.2337C11.0692 10.2337 11.0075 10.2371 10.9453 10.2384V13.5961C10.6016 13.4869 10.2432 13.4308 9.88253 13.4296Z"
                fill="#FE2C55"></path>
            <path
                d="M23.7248 6.91388V10.2427C21.5868 10.2452 19.5022 9.57485 17.7664 8.32663V17.0301C17.7664 21.3769 14.2298 24.9134 9.88303 24.9134C8.26582 24.9146 6.68784 24.4155 5.36548 23.4845C6.10157 24.2782 6.99366 24.9113 7.98584 25.3442C8.97803 25.7771 10.0489 26.0003 11.1314 26C15.4782 26 19.0148 22.466 19.0148 18.1171V9.41322C20.7507 10.6613 22.8352 11.3316 24.9732 11.3292V7.0463C24.5536 7.04613 24.1351 7.00174 23.7248 6.91388Z"
                fill="#FE2C55"></path>
            <path
                d="M17.7662 17.03V8.3262C19.502 9.57442 21.5866 10.2448 23.7246 10.2422V6.91388C22.4639 6.64208 21.3253 5.96873 20.4797 4.99487C19.8026 4.55423 19.222 3.98078 18.7729 3.30922C18.3238 2.63767 18.0157 1.88198 17.8671 1.08789H14.7317L14.7248 18.2525C14.6985 19.0021 14.4382 19.7246 13.9805 20.3188C13.5228 20.913 12.8906 21.3491 12.1725 21.5659C11.4545 21.7828 10.6866 21.7694 9.97651 21.5278C9.26643 21.2862 8.64974 20.8285 8.21293 20.2187C7.49863 19.846 6.93009 19.2443 6.59836 18.51C6.26662 17.7757 6.1909 16.9514 6.3833 16.169C6.5757 15.3866 7.0251 14.6914 7.65952 14.1947C8.29395 13.698 9.0767 13.4286 9.88242 13.4296C10.2436 13.4306 10.6026 13.4867 10.9469 13.5961V10.2384C6.68607 10.338 3.25 13.8324 3.25 18.1154C3.24819 20.1087 4.00438 22.0281 5.36529 23.4845C6.68753 24.4154 8.26535 24.9145 9.88242 24.9134C14.2297 24.9134 17.7662 21.3769 17.7662 17.03Z"
                fill="black"></path>
        </g>
        <defs>
            <clipPath id="clip0_4314_1255">
                <rect
                    width="26"
                    height="26"
                    fill="white"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-linkedin-colored"
        viewBox="0 0 26 26">
        <g clip-path="url(#clip0_5337_199)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.88889 26H23.1111C24.7066 26 26 24.7066 26 23.1111V2.88889C26 1.2934 24.7066 0 23.1111 0H2.88889C1.2934 0 0 1.2934 0 2.88889V23.1111C0 24.7066 1.2934 26 2.88889 26Z"
                fill="#2867B2"></path>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.3889 22.3889H18.5306V15.8174C18.5306 14.0157 17.846 13.0088 16.4199 13.0088C14.8686 13.0088 14.0581 14.0566 14.0581 15.8174V22.3889H10.3398V9.87034H14.0581V11.5566C14.0581 11.5566 15.176 9.48788 17.8326 9.48788C20.4879 9.48788 22.3889 11.1094 22.3889 14.4629V22.3889ZM5.9039 8.23114C4.63738 8.23114 3.61108 7.19679 3.61108 5.92111C3.61108 4.64544 4.63738 3.61108 5.9039 3.61108C7.17043 3.61108 8.19611 4.64544 8.19611 5.92111C8.19611 7.19679 7.17043 8.23114 5.9039 8.23114ZM3.98395 22.3889H7.86115V9.87034H3.98395V22.3889Z"
                fill="white"></path>
        </g>
        <defs>
            <clipPath id="clip0_5337_199">
                <rect
                    width="26"
                    height="26"
                    fill="white"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-googlefonts-colored"
        viewBox="0 0 26 26">
        <g clip-path="url(#clip0_5596_2448)">
            <path
                d="M-0.00537109 23.0928L12.7847 3.01635L19.6402 7.38389L9.6325 23.0928H-0.00537109Z"
                fill="#FBBC04"></path>
            <path
                d="M12.5143 2.91168H20.3873V23.0928H12.5143V2.91168Z"
                fill="#1A73E8"></path>
            <path
                d="M4.35592 11.0519C6.51112 11.0519 8.25826 9.30473 8.25826 7.14952C8.25826 4.99432 6.51112 3.24718 4.35592 3.24718C2.20071 3.24718 0.453575 4.99432 0.453575 7.14952C0.453575 9.30473 2.20071 11.0519 4.35592 11.0519Z"
                fill="#EA4335"></path>
            <path
                d="M25.9946 17.4855C25.9946 18.9726 25.4039 20.3989 24.3523 21.4505C23.3007 22.5021 21.8744 23.0928 20.3873 23.0928V11.8786C21.8743 11.8786 23.3005 12.4693 24.3521 13.5208C25.4037 14.5723 25.9945 15.9984 25.9946 17.4855Z"
                fill="#34A853"></path>
            <path
                d="M20.3873 11.8786V23.0928C18.9095 23.0786 17.4972 22.4816 16.4572 21.4316C15.4173 20.3816 14.8339 18.9635 14.8339 17.4857C14.8339 16.0079 15.4173 14.5899 16.4572 13.5399C17.4972 12.4899 18.9095 11.8929 20.3873 11.8786Z"
                fill="#0D652D"></path>
            <path
                d="M24.7027 7.56315C24.7026 8.70763 24.2479 9.8052 23.4386 10.6145C22.6293 11.4238 21.5317 11.8785 20.3873 11.8786V3.24718C21.5318 3.24732 22.6295 3.7021 23.4388 4.51148C24.2481 5.32087 24.7027 6.41857 24.7027 7.56315Z"
                fill="#1A73E8"></path>
            <path
                d="M20.3873 3.24718V11.8786C19.2509 11.8661 18.1653 11.4059 17.3661 10.5979C16.5669 9.78993 16.1187 8.69934 16.1187 7.56289C16.1187 6.42643 16.5669 5.33584 17.3661 4.52785C18.1653 3.71985 19.2509 3.25966 20.3873 3.24718Z"
                fill="#174EA6"></path>
        </g>
        <defs>
            <clipPath id="clip0_5596_2448">
                <rect
                    width="26"
                    height="26"
                    fill="white"></rect>
            </clipPath>
        </defs>
    </symbol>
    <symbol
        id="icon-ui-linkedin-reactions-colored"
        viewBox="0 0 19 10">
        <circle
            cx="4.84507"
            cy="5.00001"
            r="4.84507"
            fill="#4E8ADD"></circle>
        <path
            d="M7.17823 4.54348H8.09183C8.33859 5.57347 7.95185 7.0077 7.72763 7.59607C7.72763 7.59607 6.92435 7.52734 6.41725 7.59607C5.90593 7.66538 5.65253 7.8616 5.14403 7.94923C4.27849 8.09837 2.895 7.94923 2.895 7.94923C2.4043 7.84514 2.44272 7.36683 2.52326 7.14069C1.8913 6.99199 1.98992 6.44844 2.11823 6.19525C1.5841 5.88601 1.75503 5.32845 1.90727 5.08833C1.77841 5.07662 1.52069 4.95125 1.52069 4.54348C1.52069 4.13572 1.77841 3.98715 1.90727 3.96384H4.70092C4.43149 3.60072 3.88911 2.73042 3.87506 2.15412C3.861 1.57782 4.23226 1.35173 4.41965 1.31073C4.51923 1.28728 4.76408 1.35633 4.94681 1.82018C5.12954 2.28403 6.51056 3.82899 7.17823 4.54348Z"
            fill="#CCDEF5"></path>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.40258 1.23816C4.55668 1.20187 4.82813 1.31589 5.01598 1.79274C5.05748 1.89809 5.17198 2.07412 5.33818 2.29616C5.50252 2.51571 5.71209 2.77338 5.93741 3.03962C6.37816 3.56038 6.87705 4.11135 7.21053 4.46894H8.09182C8.12622 4.46894 8.15613 4.49253 8.16414 4.52598C8.29091 5.05514 8.25421 5.68267 8.15968 6.24748C8.06496 6.81343 7.91088 7.32383 7.79711 7.62237C7.78529 7.65339 7.75435 7.67282 7.72128 7.66999L7.71912 7.66981L7.71247 7.66926L7.68647 7.66723C7.66377 7.6655 7.6307 7.6631 7.58939 7.66044C7.50676 7.65511 7.39131 7.64871 7.26017 7.64444C6.99671 7.63588 6.67429 7.6361 6.42722 7.66958C6.17978 7.70312 5.99478 7.76719 5.80475 7.83557C5.79569 7.83883 5.78662 7.8421 5.77753 7.84538C5.5957 7.91093 5.40578 7.9794 5.15664 8.02233C4.71569 8.09832 4.14685 8.09796 3.69187 8.07928C3.46362 8.06991 3.26262 8.05585 3.11865 8.04414C3.04665 8.03828 2.98887 8.03301 2.94903 8.02919L2.90318 8.02467L2.89121 8.02343L2.88732 8.02302L2.87947 8.02217C2.74488 7.99362 2.64202 7.93789 2.56644 7.86365C2.49105 7.78959 2.4465 7.70028 2.42291 7.6092C2.38521 7.46366 2.39993 7.31013 2.42997 7.19219C2.29938 7.15164 2.19852 7.0923 2.12334 7.01885C2.03385 6.93144 1.98455 6.82774 1.96279 6.72196C1.92599 6.54314 1.96746 6.35804 2.02337 6.22354C1.77605 6.05762 1.68619 5.83346 1.681 5.61748C1.67666 5.43705 1.73109 5.26475 1.79468 5.137C1.73435 5.11425 1.66945 5.07551 1.61203 5.01578C1.51662 4.91653 1.44631 4.76403 1.44631 4.5433C1.44631 4.09596 1.73344 3.91953 1.89401 3.89048C1.89838 3.88969 1.90281 3.88929 1.90725 3.88929H4.55615C4.42726 3.70366 4.26611 3.44705 4.12597 3.17256C3.95413 2.83596 3.80816 2.46164 3.8007 2.15575C3.78564 1.53849 4.18704 1.28532 4.40373 1.2379L4.41963 1.31055L4.40258 1.23816ZM1.94941 5.16252C1.88576 5.27536 1.82557 5.44281 1.82969 5.6139C1.83397 5.79178 1.90724 5.97699 2.13128 6.1162H2.27254C2.27254 6.1162 2.3834 6.09609 2.39203 6.13624C2.40066 6.1764 2.27254 6.22354 2.27254 6.22354L2.16956 6.2601C2.11695 6.37722 2.0776 6.54197 2.10847 6.69199C2.125 6.77233 2.16152 6.84823 2.22727 6.91246C2.28972 6.97347 2.38194 7.02725 2.51674 7.0623C2.51674 7.0623 2.75087 6.9973 2.76718 7.03499C2.78348 7.07269 2.5834 7.19551 2.5834 7.19551C2.55195 7.29888 2.53348 7.44294 2.56689 7.5719C2.58496 7.64167 2.61778 7.70559 2.67067 7.75755C2.72281 7.80876 2.79797 7.85184 2.90675 7.87551L2.91828 7.8767L2.96321 7.88114C3.00242 7.88489 3.05948 7.8901 3.13071 7.8959C3.27319 7.90749 3.47215 7.9214 3.69797 7.93067C4.15112 7.94928 4.70679 7.94892 5.13139 7.87576C5.36738 7.83509 5.54649 7.77055 5.72903 7.70476C5.73747 7.70172 5.74592 7.69867 5.75438 7.69563C5.946 7.62667 6.14336 7.55797 6.40724 7.5222C6.66728 7.48695 7.00005 7.48717 7.265 7.49579C7.39807 7.50012 7.51514 7.50661 7.59897 7.51201C7.62998 7.51401 7.65646 7.51587 7.67754 7.51741C7.78577 7.22187 7.92531 6.74677 8.01298 6.22293C8.10268 5.68702 8.13689 5.10694 8.03241 4.61767H7.17821C7.15762 4.61767 7.13794 4.60913 7.12388 4.59408C6.78946 4.23621 6.27643 3.67041 5.82388 3.1357C5.59765 2.8684 5.38597 2.6082 5.21911 2.38529C5.05412 2.16487 4.92746 1.97384 4.8776 1.84726C4.69999 1.39641 4.48174 1.37232 4.43668 1.38294L4.43553 1.38321C4.27745 1.4178 3.93633 1.61678 3.94938 2.15212C3.95598 2.42254 4.08822 2.77152 4.25844 3.10493C4.42735 3.43578 4.62803 3.74065 4.76062 3.91935C4.77737 3.94191 4.77996 3.97199 4.76733 3.99709C4.7547 4.02219 4.729 4.03803 4.7009 4.03803H1.91447C1.81425 4.05937 1.59505 4.18252 1.59505 4.5433C1.59505 4.73034 1.65359 4.8444 1.71925 4.91271C1.7852 4.98131 1.8629 5.00859 1.91092 5.01378C1.91092 5.01378 2.07183 5.03201 2.1129 5.03201C2.15397 5.03201 2.27254 5.08815 2.27254 5.08815L1.94941 5.16252Z"
            fill="#0A66C2"></path>
        <path
            d="M18.5902 5.00001C18.5902 7.67587 16.4209 9.84509 13.7451 9.84509C11.0692 9.84509 8.90001 7.67587 8.90001 5.00001C8.90001 2.32416 11.0692 0.154944 13.7451 0.154944C16.4209 0.154944 18.5902 2.32416 18.5902 5.00001Z"
            fill="#D17655"
            stroke="white"
            stroke-width="0.3"></path>
        <path
            d="M13.7449 8.49976L11.7978 6.49489L11.0071 5.65175C11.0071 5.65175 10.422 4.8555 10.422 4.33234C10.422 3.3496 11.2191 2.55241 12.2023 2.55241C12.8614 2.55241 13.4373 2.91138 13.7449 3.44414C14.0524 2.91138 14.6284 2.55241 15.2874 2.55241C16.2706 2.55241 17.0678 3.3496 17.0678 4.33234C17.0678 4.8555 16.4827 5.65175 16.4827 5.65175L15.562 6.604L13.7449 8.49976Z"
            fill="#FDF3F0"
            stroke="#792A0E"
            stroke-width="0.2"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-resize"
        viewBox="0 0 64 64">
        <path
            d="M37.0073 30.655V28.515L40.4926 32.005L37.0073 35.495V33.355C37.0073 33.0789 36.7835 32.855 36.5073 32.855H27.5026C27.2265 32.855 27.0026 33.0789 27.0026 33.355V35.495L23.5173 32.005L27.0026 28.515V30.655C27.0026 30.9312 27.2265 31.155 27.5026 31.155H36.5073C36.7835 31.155 37.0073 30.9312 37.0073 30.655Z"
            fill="black"></path>
        <path
            opacity="0.75"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27.6939 26.8448C27.8808 26.9221 28.0027 27.1045 28.0027 27.3068V30.155H36.0074V27.3068C36.0074 27.1045 36.1293 26.9221 36.3162 26.8448C36.5031 26.7674 36.7183 26.8103 36.8612 26.9535L41.5531 31.6517C41.7481 31.8469 41.7481 32.1631 41.5531 32.3583L36.8612 37.0566C36.7183 37.1997 36.5031 37.2426 36.3162 37.1653C36.1293 37.0879 36.0074 36.9056 36.0074 36.7033V33.855H28.0027V36.7033C28.0027 36.9056 27.8808 37.0879 27.6939 37.1653C27.507 37.2426 27.2919 37.1997 27.1489 37.0566L22.457 32.3583C22.2621 32.1631 22.2621 31.8469 22.457 31.6517L27.1489 26.9535C27.2919 26.8103 27.507 26.7674 27.6939 26.8448ZM37.0074 28.515V30.655C37.0074 30.9312 36.7836 31.155 36.5074 31.155H27.5027C27.2266 31.155 27.0027 30.9312 27.0027 30.655V28.515L23.5174 32.005L27.0027 35.495V33.355C27.0027 33.0789 27.2266 32.855 27.5027 32.855H36.5074C36.7836 32.855 37.0074 33.0789 37.0074 33.355V35.495L40.4927 32.005L37.0074 28.515Z"
            fill="white"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-rectangle"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M34 31H38C38.5523 31 39 31.4477 39 32V33C39 33.5523 38.5523 34 38 34H34V38C34 38.5523 33.5523 39 33 39H32C31.4477 39 31 38.5523 31 38V34H27C26.4477 34 26 33.5523 26 33V32C26 31.4477 26.4477 31 27 31H31V27C31 26.4477 31.4477 26 32 26H33C33.5523 26 34 26.4477 34 27V31Z"
            fill="white"></path>
        <path
            d="M33 32V27H32V32H27V33H32V38H33V33H38V32H33Z"
            fill="black"></path>
        <path
            opacity="0.75"
            d="M38 15H49C49.5523 15 50 15.4477 50 16V27C50 27.5523 49.5523 28 49 28H38C37.4477 28 37 27.5523 37 27V16C37 15.4477 37.4477 15 38 15Z"
            fill="white"></path>
        <path
            d="M38 27V16H49V27H38ZM39 26H48V17H39V26Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-button"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M34 31H38C38.5523 31 39 31.4477 39 32V33C39 33.5523 38.5523 34 38 34H34V38C34 38.5523 33.5523 39 33 39H32C31.4477 39 31 38.5523 31 38V34H27C26.4477 34 26 33.5523 26 33V32C26 31.4477 26.4477 31 27 31H31V27C31 26.4477 31.4477 26 32 26H33C33.5523 26 34 26.4477 34 27V31Z"
            fill="white"></path>
        <path
            d="M33 32V27H32V32H27V33H32V38H33V33H38V32H33Z"
            fill="black"></path>
        <path
            opacity="0.75"
            d="M49.9999 27C49.9999 27.2559 49.9023 27.5119 49.7071 27.7071C49.6113 27.8029 49.4971 27.8782 49.3714 27.9285L44.3714 29.9285C43.8586 30.1336 43.2766 29.8842 43.0715 29.3714C43.0243 29.2533 43 29.1272 43 29V27.0001H40C38.3431 27.0001 37 25.6569 37 24.0001V20.0001C37 18.3432 38.3431 17.0001 40 17.0001H50C51.6569 17.0001 53 18.3432 53 20.0001V24.0001C53 25.6569 51.6569 27.0001 50 27.0001L49.9999 27Z"
            fill="white"></path>
        <path
            d="M50 26V25C50.5523 25 51 24.5523 51 24V20C51 19.4477 50.5523 19 50 19H40C39.4477 19 39 19.4477 39 20V24C39 24.5523 39.4477 25 40 25H42V26H40C38.8954 26 38 25.1046 38 24V20C38 18.8954 38.8954 18 40 18H50C51.1046 18 52 18.8954 52 20V24C52 25.1046 51.1046 26 50 26ZM44 22L49 27L44 29V22Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-rotate"
        viewBox="0 0 64 64">
        <path
            d="M32 26L34 24H29V29L30.9498 27.0502C32.2165 28.317 33 30.067 33 32C33 33.933 32.2165 35.683 30.9498 36.9497L29 35V40H34L32.0104 38.0104C33.5486 36.4722 34.5 34.3472 34.5 32C34.5 29.6528 33.5486 27.5278 32.0104 25.9896L32 26Z"
            fill="black"></path>
        <path
            opacity="0.75"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.9498 36.9497C31.1861 36.7134 31.4056 36.4602 31.6064 36.1922C32.4816 35.0236 33 33.5723 33 32C33 30.4277 32.4816 28.9764 31.6064 27.8078C31.4056 27.5398 31.1861 27.2866 30.9498 27.0502L29 29V24H34L32.0104 25.9896C32.1288 26.108 32.2438 26.2299 32.355 26.355C32.4655 26.4793 32.5723 26.6068 32.6755 26.7374C33.8181 28.1849 34.5 30.0128 34.5 32C34.5 34.3472 33.5486 36.4722 32.0104 38.0104L34 40H29V35L30.9498 36.9497ZM33.3875 37.9733L34.7071 39.2929C34.9931 39.5789 35.0787 40.009 34.9239 40.3827C34.7691 40.7564 34.4045 41 34 41H29C28.4477 41 28 40.5523 28 40V35C28 34.5955 28.2436 34.2309 28.6173 34.0761C28.991 33.9213 29.4211 34.0069 29.7071 34.2929L30.8908 35.4766C31.5897 34.4955 32 33.2963 32 32C32 30.7037 31.5897 29.5045 30.8908 28.5234L29.7071 29.7071C29.4211 29.9931 28.991 30.0787 28.6173 29.9239C28.2436 29.7691 28 29.4045 28 29V24C28 23.4477 28.4477 23 29 23H34C34.4045 23 34.7691 23.2436 34.9239 23.6173C35.0787 23.991 34.9931 24.4211 34.7071 24.7071L33.3875 26.0267C34.7079 27.6581 35.5 29.7372 35.5 32C35.5 34.2628 34.708 36.3419 33.3875 37.9733Z"
            fill="white"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-text"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M31 34C30.4477 34 30 33.5523 30 33V32C30 31.4477 30.4477 31 31 31V26.7324C30.6964 26.5568 30.4432 26.3036 30.2676 26H29C28.4477 26 28 25.5523 28 25V24C28 23.4477 28.4477 23 29 23H31C31.5974 23 32.1335 23.2619 32.5 23.6771C32.8665 23.2619 33.4026 23 34 23H36C36.5523 23 37 23.4477 37 24V25C37 25.5523 36.5523 26 36 26H34.7324C34.5568 26.3036 34.3036 26.5568 34 26.7324V31C34.5523 31 35 31.4477 35 32V33C35 33.5523 34.5523 34 34 34V38.2676C34.3036 38.4432 34.5568 38.6964 34.7324 39H36C36.5523 39 37 39.4477 37 40V41C37 41.5523 36.5523 42 36 42H34C33.4026 42 32.8665 41.7381 32.5 41.3229C32.1335 41.7381 31.5974 42 31 42H29C28.4477 42 28 41.5523 28 41V40C28 39.4477 28.4477 39 29 39H30.2676C30.4432 38.6964 30.6964 38.4432 31 38.2676V34Z"
            fill="white"></path>
        <path
            d="M32 39C31.4477 39 31 39.4477 31 40H29V41H31C31.5523 41 32 40.5523 32 40H33C33 40.5523 33.4477 41 34 41H36V40H34C34 39.4477 33.5523 39 33 39V33H34V32H33V26C33.5523 26 34 25.5523 34 25H36V24H34C33.4477 24 33 24.4477 33 25H32C32 24.4477 31.5523 24 31 24H29V25H31C31 25.5523 31.4477 26 32 26V32H31V33H32V39Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-zoom-in"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M40.5867 39.8275L39.8273 40.5868C39.4368 40.9773 38.8037 40.9773 38.4132 40.5868L35.8797 38.0533C34.8742 38.6665 33.7119 39 32.5 39C28.9101 39 26 36.0899 26 32.5C26 28.9101 28.9101 26 32.5 26C36.0899 26 39 28.9101 39 32.5C39 33.7119 38.6665 34.8743 38.0533 35.8797L40.5868 38.4132C40.9773 38.8037 40.9773 39.4369 40.5868 39.8274L40.5867 39.8275Z"
            fill="white"></path>
        <path
            d="M36.7503 35.9909L39.8797 39.1203L39.1203 39.8797L35.9909 36.7503C35.0413 37.5312 33.8254 38 32.5 38C29.4624 38 27 35.5376 27 32.5C27 29.4624 29.4624 27 32.5 27C35.5376 27 38 29.4624 38 32.5C38 33.8254 37.5312 35.0413 36.7503 35.9909ZM32.5 37C34.9853 37 37 34.9853 37 32.5C37 30.0147 34.9853 28 32.5 28C30.0147 28 28 30.0147 28 32.5C28 34.9853 30.0147 37 32.5 37Z"
            fill="black"></path>
        <path
            d="M35 32V33H30V32H35Z"
            fill="black"></path>
        <path
            d="M32 30H33V35H32V30Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-oval"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M43.5 28C39.9101 28 37 25.0899 37 21.5C37 17.9101 39.9101 15 43.5 15C47.0899 15 50 17.9101 50 21.5C50 25.0899 47.0899 28 43.5 28Z"
            fill="white"></path>
        <path
            d="M43.5 26C45.9853 26 48 23.9853 48 21.5C48 19.0147 45.9853 17 43.5 17C41.0147 17 39 19.0147 39 21.5C39 23.9853 41.0147 26 43.5 26ZM43.5 27C40.4624 27 38 24.5376 38 21.5C38 18.4624 40.4624 16 43.5 16C46.5376 16 49 18.4624 49 21.5C49 24.5376 46.5376 27 43.5 27Z"
            fill="black"></path>
        <path
            opacity="0.75"
            d="M34 31H38C38.5523 31 39 31.4477 39 32V33C39 33.5523 38.5523 34 38 34H34V38C34 38.5523 33.5523 39 33 39H32C31.4477 39 31 38.5523 31 38V34H27C26.4477 34 26 33.5523 26 33V32C26 31.4477 26.4477 31 27 31H31V27C31 26.4477 31.4477 26 32 26H33C33.5523 26 34 26.4477 34 27V31Z"
            fill="white"></path>
        <path
            d="M33 32V27H32V32H27V33H32V38H33V33H38V32H33Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-zoom-out"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M40.5867 39.8275L39.8273 40.5868C39.4368 40.9773 38.8037 40.9773 38.4132 40.5868L35.8797 38.0533C34.8742 38.6665 33.7119 39 32.5 39C28.9101 39 26 36.0899 26 32.5C26 28.9101 28.9101 26 32.5 26C36.0899 26 39 28.9101 39 32.5C39 33.7119 38.6665 34.8743 38.0533 35.8797L40.5868 38.4132C40.9773 38.8037 40.9773 39.4369 40.5868 39.8274L40.5867 39.8275Z"
            fill="white"></path>
        <path
            d="M36.7503 35.9909L39.8797 39.1203L39.1203 39.8797L35.9909 36.7503C35.0413 37.5312 33.8254 38 32.5 38C29.4624 38 27 35.5376 27 32.5C27 29.4624 29.4624 27 32.5 27C35.5376 27 38 29.4624 38 32.5C38 33.8254 37.5312 35.0413 36.7503 35.9909ZM32.5 37C34.9853 37 37 34.9853 37 32.5C37 30.0147 34.9853 28 32.5 28C30.0147 28 28 30.0147 28 32.5C28 34.9853 30.0147 37 32.5 37Z"
            fill="black"></path>
        <path
            d="M35 32V33H30V32H35Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-polygon"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M34 31H38C38.5523 31 39 31.4477 39 32V33C39 33.5523 38.5523 34 38 34H34V38C34 38.5523 33.5523 39 33 39H32C31.4477 39 31 38.5523 31 38V34H27C26.4477 34 26 33.5523 26 33V32C26 31.4477 26.4477 31 27 31H31V27C31 26.4477 31.4477 26 32 26H33C33.5523 26 34 26.4477 34 27V31Z"
            fill="white"></path>
        <path
            d="M33 32V27H32V32H27V33H32V38H33V33H38V32H33Z"
            fill="black"></path>
        <path
            opacity="0.75"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M43 17C43.3632 17 43.6978 17.1969 43.8742 17.5144L48.8742 26.5144C49.0462 26.8241 49.0416 27.2017 48.8619 27.5071C48.6822 27.8125 48.3543 28 48 28H38C37.6457 28 37.3178 27.8125 37.1381 27.5071C36.9584 27.2017 36.9538 26.8241 37.1258 26.5144L42.1258 17.5144C42.3022 17.1969 42.6368 17 43 17Z"
            fill="white"></path>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M43 18L38 27H48L43 18ZM43 20.0591L39.6995 26H46.3005L43 20.0591Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-selection-locked"
        viewBox="0 0 64 64">
        <g opacity="0.75">
            <path
                d="M47 26V23C47 22.2597 46.5978 21.6134 46 21.2676V21C46 19.3431 44.6569 18 43 18C41.3431 18 40 19.3431 40 21V21.2676C39.4022 21.6134 39 22.2597 39 23V26C39 27.1046 39.8954 28 41 28H45C46.1046 28 47 27.1046 47 26Z"
                fill="white"></path>
            <path
                d="M31 44.7279C31 45.6188 32.0772 46.0649 32.7071 45.435L36.1421 41.9999H41C41.8909 41.9999 42.3371 40.9227 41.7071 40.2928L32.7071 31.2928C32.0771 30.6629 31 31.109 31 31.9999V44.7279Z"
                fill="white"></path>
        </g>
        <path
            d="M35.7279 41H41L32 32V44.7279L35.7279 41Z"
            fill="black"></path>
        <path
            d="M45 22C45.5523 22 46 22.4477 46 23V26C46 26.5523 45.5523 27 45 27H41C40.4477 27 40 26.5523 40 26V23C40 22.4477 40.4477 22 41 22V21C41 19.8954 41.8954 19 43 19C44.1046 19 45 19.8954 45 21V22ZM44 22V21C44 20.4477 43.5523 20 43 20C42.4477 20 42 20.4477 42 21V22H44Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-star"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M34 31H38C38.5523 31 39 31.4477 39 32V33C39 33.5523 38.5523 34 38 34H34V38C34 38.5523 33.5523 39 33 39H32C31.4477 39 31 38.5523 31 38V34H27C26.4477 34 26 33.5523 26 33V32C26 31.4477 26.4477 31 27 31H31V27C31 26.4477 31.4477 26 32 26H33C33.5523 26 34 26.4477 34 27V31Z"
            fill="white"></path>
        <path
            d="M33 32V27H32V32H27V33H32V38H33V33H38V32H33Z"
            fill="black"></path>
        <path
            opacity="0.75"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.0001 15C44.4333 15 44.8173 15.279 44.9511 15.691L46.143 19.3593H50.0001C50.4333 19.3593 50.8173 19.6382 50.9511 20.0502C51.085 20.4623 50.9384 20.9136 50.5879 21.1683L47.4674 23.4354L48.6593 27.1037C48.7932 27.5157 48.6466 27.9671 48.2961 28.2217C47.9456 28.4763 47.471 28.4763 47.1205 28.2217L44.0001 25.9546L40.8797 28.2217C40.5292 28.4763 40.0546 28.4763 39.7041 28.2217C39.3536 27.9671 39.2069 27.5157 39.3408 27.1037L40.5327 23.4354L37.4123 21.1683C37.0618 20.9136 36.9151 20.4623 37.049 20.0502C37.1829 19.6382 37.5668 19.3593 38.0001 19.3593H41.8571L43.049 15.691C43.1829 15.279 43.5668 15 44.0001 15Z"
            fill="white"></path>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45.4164 20.3593L44 16L42.5836 20.3593H38L41.7082 23.0534L40.2918 27.4127L44 24.7185L47.7082 27.4127L46.2918 23.0534L50 20.3593H45.4164ZM43.2918 21.3418L44 19.1622L44.7082 21.3418H47L45.1459 22.6889L45.8541 24.8685L44 23.5214L42.1459 24.8685L42.8541 22.6889L41 21.3418H43.2918Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-selection"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M32.7071 45.435C32.0772 46.0649 31 45.6188 31 44.7279V31.9999C31 31.109 32.0771 30.6629 32.7071 31.2928L41.7071 40.2928C42.3371 40.9227 41.8909 41.9999 41 41.9999H36.1421L32.7071 45.4349V45.435Z"
            fill="white"></path>
        <path
            d="M35.7279 41H41L32 32V44.7279L35.7279 41Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-heart"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M34 31H38C38.5523 31 39 31.4477 39 32V33C39 33.5523 38.5523 34 38 34H34V38C34 38.5523 33.5523 39 33 39H32C31.4477 39 31 38.5523 31 38V34H27C26.4477 34 26 33.5523 26 33V32C26 31.4477 26.4477 31 27 31H31V27C31 26.4477 31.4477 26 32 26H33C33.5523 26 34 26.4477 34 27V31Z"
            fill="white"></path>
        <path
            d="M33 32V27H32V32H27V33H32V38H33V33H38V32H33Z"
            fill="black"></path>
        <path
            opacity="0.75"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M43.5 15.7882C43.6518 15.6707 43.8116 15.5653 43.9784 15.4727C44.8457 14.9914 45.8194 14.8991 46.704 15.0991C48.4767 15.4999 50 17.0998 50 19.3692C50 20.518 49.5414 21.6186 49.0154 22.5282C48.4762 23.461 47.7787 24.3414 47.1157 25.0835C46.4478 25.831 45.7848 26.4714 45.2911 26.9236C45.0432 27.1505 44.8356 27.3323 44.6881 27.4588C44.6143 27.5221 44.5554 27.5717 44.5138 27.6063L44.5117 27.6081L44.4638 27.6478L44.4502 27.659L44.4457 27.6627L44.4447 27.6635C43.8952 28.1107 43.1072 28.1127 42.5562 27.6642L42.5548 27.663L42.5481 27.6576L42.5325 27.6448L42.4862 27.6063C42.4446 27.5717 42.3857 27.5221 42.3119 27.4588C42.1644 27.3323 41.9568 27.1505 41.7089 26.9235C41.2152 26.4714 40.5522 25.831 39.8843 25.0835C39.2213 24.3414 38.5238 23.461 37.9846 22.5282C37.4586 21.6186 37 20.518 37 19.3692C37 17.0998 38.5233 15.5 40.296 15.0991C41.1806 14.8991 42.1543 14.9914 43.0216 15.4727C43.1884 15.5653 43.3482 15.6707 43.5 15.7882Z"
            fill="white"></path>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M43.171 26.8752L43.1829 26.8849L43.1875 26.8886C43.3701 27.0373 43.6302 27.037 43.8129 26.8884L43.8138 26.8876L43.8171 26.8849L43.829 26.8752L43.8732 26.8385C43.9115 26.8066 43.9669 26.7599 44.0371 26.6997C44.1774 26.5794 44.3768 26.4048 44.6157 26.1861C45.0928 25.7492 45.7306 25.1329 46.37 24.4173C47.0077 23.7035 47.6571 22.8798 48.1497 22.0278C48.6377 21.1837 49 20.2639 49 19.3692C49 17.5885 47.8215 16.3771 46.4835 16.0745C45.8148 15.9234 45.0958 15.9963 44.4637 16.3471C44.0945 16.552 43.7663 16.8454 43.5 17.2258C43.2337 16.8454 42.9055 16.552 42.5363 16.3471C41.9042 15.9963 41.1852 15.9234 40.5165 16.0745C39.1785 16.3771 38 17.5885 38 19.3692C38 20.2639 38.3623 21.1837 38.8503 22.0278C39.3429 22.8798 39.9923 23.7035 40.63 24.4172C41.2694 25.1329 41.9072 25.7492 42.3843 26.1861C42.6232 26.4048 42.8226 26.5794 42.9629 26.6997C43.0331 26.7599 43.0885 26.8066 43.1268 26.8385L43.171 26.8752ZM44.9426 17.2404C44.5485 17.459 44.1883 17.8594 43.9743 18.5126C43.9063 18.7204 43.7152 18.8605 43.5 18.8605C43.2848 18.8605 43.0937 18.7204 43.0257 18.5126C42.8117 17.8594 42.4515 17.4591 42.0574 17.2404C41.6583 17.0188 41.1898 16.9646 40.7335 17.0678C39.8215 17.274 39 18.0975 39 19.3692C39 20.0008 39.2627 20.7343 39.7122 21.5119C40.1571 22.2815 40.7577 23.0476 41.37 23.7328C41.9806 24.4162 42.5928 25.0082 43.0532 25.4298C43.2271 25.589 43.3788 25.7235 43.5 25.8289C43.6212 25.7235 43.7729 25.589 43.9468 25.4298C44.4072 25.0082 45.0194 24.4162 45.63 23.7328C46.2423 23.0476 46.8429 22.2815 47.2878 21.5119C47.7373 20.7343 48 20.0008 48 19.3692C48 18.0975 47.1785 17.274 46.2665 17.0678C45.8102 16.9646 45.3417 17.0188 44.9426 17.2404Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-arrow"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M34 31H38C38.5523 31 39 31.4477 39 32V33C39 33.5523 38.5523 34 38 34H34V38C34 38.5523 33.5523 39 33 39H32C31.4477 39 31 38.5523 31 38V34H27C26.4477 34 26 33.5523 26 33V32C26 31.4477 26.4477 31 27 31H31V27C31 26.4477 31.4477 26 32 26H33C33.5523 26 34 26.4477 34 27V31Z"
            fill="white"></path>
        <path
            d="M33 32V27H32V32H27V33H32V38H33V33H38V32H33Z"
            fill="black"></path>
        <path
            opacity="0.75"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M48.3827 25.9239C48.009 26.0787 47.5789 25.9931 47.2929 25.7071L45.5 23.9142L41.7071 27.7071C41.3166 28.0976 40.6834 28.0976 40.2929 27.7071L37.2929 24.7071C37.1054 24.5196 37 24.2652 37 24C37 23.7348 37.1054 23.4804 37.2929 23.2929L41.0858 19.5L39.2929 17.7071C39.0069 17.4211 38.9213 16.991 39.0761 16.6173C39.2309 16.2436 39.5955 16 40 16H48C48.5522 16 49 16.4477 49 17L49 25C49 25.4045 48.7564 25.7691 48.3827 25.9239Z"
            fill="white"></path>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M48 25L48 17H40L42.5 19.5L38 24L41 27L45.5 22.5L48 25ZM41 25.5858L45.5 21.0858L47 22.5858L47 18H42.4142L43.9142 19.5L39.4142 24L41 25.5858Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-other"
        viewBox="0 0 64 64">
        <path
            opacity="0.75"
            d="M34 31H38C38.5523 31 39 31.4477 39 32V33C39 33.5523 38.5523 34 38 34H34V38C34 38.5523 33.5523 39 33 39H32C31.4477 39 31 38.5523 31 38V34H27C26.4477 34 26 33.5523 26 33V32C26 31.4477 26.4477 31 27 31H31V27C31 26.4477 31.4477 26 32 26H33C33.5523 26 34 26.4477 34 27V31Z"
            fill="white"></path>
        <path
            d="M33 32V27H32V32H27V33H32V38H33V33H38V32H33Z"
            fill="black"></path>
    </symbol>
    <symbol
        id="icon-ui-cursor-move-directions"
        viewBox="0 0 64 64">
        <g opacity="0.75">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32.4999 25L29.9999 27.5L31.9999 27.5V31H28.4999V29L25.9999 31.5L28.4999 34V32H31.9999V35.5H29.9999L32.4999 38L34.9999 35.5H32.9999V32H36.4999V34L38.9999 31.5L36.4999 29V31H32.9999V27.5H34.9999L32.4999 25ZM33.9999 28.5V30H35.4999V28.5H33.9999ZM29.4999 28.5V30H30.9999V28.5H29.4999ZM29.4999 34.5H30.9999V33H29.4999V34.5ZM35.4999 34.5V33H33.9999V34.5H35.4999Z"
                fill="white"></path>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.9999 28.5V30H35.4999V28.5H33.9999ZM29.4999 30H30.9999V28.5H29.4999V30ZM30.9999 34.5V33H29.4999V34.5H30.9999ZM35.4999 33H33.9999V34.5H35.4999V33ZM34.9999 27.5L32.4999 25L29.9999 27.5L31.9999 27.5V31H28.4999V29L25.9999 31.5L28.4999 34V32H31.9999V35.5H29.9999L32.4999 38L34.9999 35.5H32.9999V32H36.4999V34L38.9999 31.5L36.4999 29V31H32.9999V27.5H34.9999Z"
                fill="white"></path>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M40.4141 31.5L32.4999 23.5858L24.5857 31.5L32.4999 39.4142L40.4141 31.5ZM33.9999 28.5V30H35.4999V28.5H33.9999ZM29.4999 30H30.9999V28.5H29.4999V30ZM30.9999 34.5V33H29.4999V34.5H30.9999ZM35.4999 33H33.9999V34.5H35.4999V33ZM34.9999 27.5L32.4999 25L29.9999 27.5L31.9999 27.5V31H28.4999V29L25.9999 31.5L28.4999 34V32H31.9999V35.5H29.9999L32.4999 38L34.9999 35.5H32.9999V32H36.4999V34L38.9999 31.5L36.4999 29V31H32.9999V27.5H34.9999Z"
                fill="white"></path>
        </g>
        <path
            d="M33 31V26H32V31H27V32H32V37H33V32H38V31H33Z"
            fill="black"></path>
        <path
            d="M30 35.5H35L32.5 38L30 35.5Z"
            fill="black"></path>
        <path
            d="M35 27.5L30 27.5L32.5 25L35 27.5Z"
            fill="black"></path>
        <path
            d="M28.5 29V34L26 31.5L28.5 29Z"
            fill="black"></path>
        <path
            d="M36.5 34V29L39 31.5L36.5 34Z"
            fill="black"></path>
    </symbol>
</svg>
